import { useState, useRef, useEffect } from "react";
import classnames from "classnames";
import ReactPlayer from "react-player";
import MultiSourcePreview from "./MultiSourcePreview";
import "./css/PlaylistPlayer.css";
import "./css/PlaylistOverrides.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Skeleton from "@mui/material/Skeleton";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Modal, Button } from 'react-bootstrap';
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  RedditShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  RedditIcon
} from 'react-share';
var moment = require("moment");
const { SEARCH_SOURCES, doUniversalSearch } = require("./universalSearch");
const axios = require("axios");
// toast.configure();
  let visibleIndex = -1;
export const PlaylistPlayer = ({ playlists_data }) => {
	const [selectedOption, setSelectedOption] = useState('Search All');
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [isMobOpen, setIsMobOpen] = useState(false);
    const [isMobWorkspaceOpen, setIsMobWorkspaceOpen] = useState(false);
    const dropdownMobRef = useRef(null);
    const handleSelect = (option) => {
        setSelectedOption(option);
        setIsOpen(false);
    };

	const handleMobSelect = () => {
		setIsMobOpen(false);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }

		if (dropdownMobRef.current && !dropdownMobRef.current.contains(event.target)) {
            setIsMobOpen(false);
        }
    };

	const [selectedOptionDown, setSelectedOptionDown] = useState('Search All');
    const [isOpenDown, setIsOpenDown] = useState(false);
    const dropdownRefDown = useRef(null);

    const handleSelectDown = (option) => {
        setSelectedOptionDown(option);
        setIsOpenDown(false);
    };

    const handleClickOutsideDown = (event) => {
        if (dropdownRefDown.current && !dropdownRefDown.current.contains(event.target)) {
            setIsOpenDown(false);
        }
    };

    const formRef = useRef(null);
    const formRefDown = useRef(null);
    const formMobRef = useRef(null);
    const dropdownMobWsRef = useRef(null);

    const vimeo_url = process.env.REACT_APP_API_URL + '/vimeo';
    const reactAppUrl = process.env.REACT_APP_URL;
    const navigate = useNavigate();
    const [show, setShow] = useState({new_list:false,share_list:false,embed_code:false,past_url:false, user_media:false, playlistDesc:false, user_media_url:false, embed_code_modal:false, saved_csv:false});
    const clipDragRef = useRef(null);
    const playlistDragRef = useRef(null);
    const [mShow, setMShow] = useState({youtube:true,vimeo:false,playlists:false,playlist:false, user_media:false});
	const [totalViews, setTotalViews] = useState("-.-");
    const [CurrentPlay, setCurrentPlay] = useState('');
    const [playlists, setPlaylists] = useState(playlists_data);
    const [userMedia, setUserMedia] = useState([]);
    const [playlistsSequenceStatus, setPlaylistsSequenceStatus] = useState(true);
    const [editPlaylist, setEditPlaylist] = useState(false);
	const handleButtonClick = (key) => {
    	const displayKey = ['youtube','vimeo','playlists','playlist','user_media'].includes(key) ? key : 'youtube';
    	setMShow({
			youtube: false,
			vimeo: false,
			playlists: false,
			playlist: false,
			user_media: false,
			[displayKey]: true
		});
	};
  
const handleClose = (modal_name = '') => {
  if (modal_name !== '') {
    setShow((prev) => ({
      ...prev,
      [modal_name]: false,
    }));
    EmptyCopy();
  }
};

    const handleShow = (modal_name = '') => {
        if (modal_name != '') {
            setShow({ ...show, [modal_name]: true });
        }
    };

	const getId = (url) => {
		if (url.includes('vimeo.com')) {
			return url;
		} else if (url.includes('youtube.com') || url.includes('youtu.be')) {
			const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
			const match = url.match(regex);
			return match && match[1];
		} else {
			return url;
		}
	};


	const getPlaylistViews = (index) => {
		var tempYoutubePlaylist = playlists[index].videos;
		let total = 0;
		for (let i = 0; i < tempYoutubePlaylist.length; i++) {
			if (tempYoutubePlaylist[i].views !== null) {
				total += parseInt(tempYoutubePlaylist[i].views, 10);
			}
		}
		setTotalViews(formatViews(total));
	}

	const formatViews = (views) => {
		if (views === undefined || views === null || views === 0) return "-.-";
		if (views >= 1e12) {
			return (views / 1e12).toFixed(1) + "T";
		} else if (views >= 1e9) {
			return (views / 1e9).toFixed(1) + "B";
		} else if (views >= 1e6) {
			return (views / 1e6).toFixed(1) + "M";
		} else if (views >= 1e3) {
			return (views / 1e3).toFixed(1) + "K";
		} else {
			return views.toString();
		}
	};

	const addToPlaylist = async (url) => {
		if (url.includes("vimeo.com/")) {
			try {
				await axios.get(vimeo_url+`/videoInfo?video_id=` + url.match(/vimeo\.com\/(\d+)/)[1]).then((res) => {
					setYoutubeDatainState(
						res.data.name,
						res.data.link,
						null,
						res.data.metadata.connections.likes.total,
						res.data.created_time,
						res.data.duration,
						null,
						res.data.user.name,
						res.data.user.link,
						res.data.pictures.base_link,
						res.data.description,
						res.data.embed.html,
						res.data.categories.length != 0
						? res.data.categories[0].name
						: null,
						res.data.user.location_details
					);
				});
			} catch (error) {
        if (error.response) {
          console.error("Server Error:", error.response.data);
        } else if (error.request) {
          console.error("No response received:", error.request);
        } else {
          console.error("Request setup error:", error.message);
        }
      }
		}
		else {
			try {
				var EmbadeCode = url;
				if (url.includes("https://youtu.be/")) {
					EmbadeCode = url.replace(
					"https://youtu.be/",
					"https://www.youtube.com/watch?v="
					);
				}
				var pattern = new RegExp(
					"^(https?:\\/\\/)?" +
					"((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
					"((\\d{1,3}\\.){3}\\d{1,3}))" +
					"(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
					"(\\?[;&a-z\\d%_.~+=-]*)?" +
					"(\\#[-a-z\\d_]*)?$",
					"i"
				);

				if (pattern.test(EmbadeCode)) {
					var videoId_is = "";
					let UslIs = EmbadeCode;
					let paramString = UslIs.split("?")[1];
					let queryString = new URLSearchParams(paramString);
					for (let pair of queryString.entries()) videoId_is = pair[1];
					await axios
					.get(
						`https://www.googleapis.com/youtube/v3/videos?part=snippet%2Cstatus%2CcontentDetails%2Cstatistics&id=` +
						videoId_is +
						`&key=` +
						process.env.REACT_APP_YOUTUBEAPIKEY
					)
					.then((res) => {
						axios
						.post(
							process.env.REACT_APP_API_URL +
							"/manageplaylist/findYoutubeValidater",
							{ videoURL: "https://www.youtube.com/embed/" + videoId_is }
						)
						.then((res1) => {
							setPlayableStatus(res1.data.status);
							if (res1.data.status == "PLAYABLE") {
								setYoutubeDatainState(
									res.data.items[0].snippet.title,
									`https://www.youtube.com/watch?v=` + res.data.items[0].id,
									res.data.items[0].statistics.viewCount,
									res.data.items[0].statistics.likeCount,
									res.data.items[0].snippet.publishedAt,
									moment.duration(res.data.items[0].contentDetails.duration).asSeconds(),
									res.data.items[0].snippet.tags,
									res.data.items[0].snippet.channelTitle,
									`https://www.youtube.com/channel/` +res.data.items[0].snippet.channelId,
									res.data.items[0].snippet.thumbnails.high.url,
									res.data.items[0].snippet.description,
									res.data.items[0].id,
									res.data.items[0].snippet.categoryId,
									null
								)
							}
						});
					});
				} else {
					toast.error("Invalid Video Url");
				}
			} catch (error) {
        console.error("Error occurred:", error);
    }
    
		}
	}

	const getUserMedia = async (user_id) => {
		try {
			const response = await axios.get(process.env.REACT_APP_API_URL + '/playlist/getUsermedia', {
				headers: {
					'Authorization': 'Bearer your_token_here',
					'Content-Type': 'application/json',
					'user_id':user_id
				},
			});
			if (response.data && response.data.data) {
				setUserMedia(response.data.data);
			}
		} catch (error) {
			 console.error('Error fetching data:', error);
		}
	}

	const removeUserMedia = async (id) => {
		try {
			const response = await axios.get(process.env.REACT_APP_API_URL + '/playlist/deleteUsermedia', {
				headers: {
					'Authorization': 'Bearer your_token_here',
					'Content-Type': 'application/json',
					'user_id':loginId,
					'id':id
				},
			});
			if (response.data && response.data.data) {
				toast.success(response.data.message);
				getUserMedia(loginId);
			}
		} catch (error) {
			 console.error('Error fetching data:', error);
		}
	}
  // Style Sheet
  // Orientation -> body.landscape/.portrait (Back.js does this but is not
  // mounted on the tools/embed route, so do it here too).
  useEffect(() => {
    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    if (!isTouchDevice) return; // desktop: skip orientation class
    const mq = window.matchMedia("(orientation: portrait)");
    const apply = (e) => {
      if (e.matches) {
        document.body.classList.add("portrait");
        document.body.classList.remove("landscape");
      } else {
        document.body.classList.remove("portrait");
        document.body.classList.add("landscape");
      }
    };
    apply(mq);
    if (mq.addEventListener) { mq.addEventListener("change", apply); }
    else { mq.addListener(apply); }
    return () => {
      if (mq.removeEventListener) { mq.removeEventListener("change", apply); }
      else { mq.removeListener(apply); }
    };
  }, []);

  
  useEffect(() => {
    // console.log("PlaylistPlayer useEffect",currentPlaylist);
	if (document && document.body) {
		document.body.style.height = "auto";
	}

	// Check if elements with the class name "main-container" exist
	const mainContainerElements = document.getElementsByClassName("main-container");
	if (mainContainerElements && mainContainerElements.length > 0) {
		const mainContainer = mainContainerElements[0];
		mainContainer.style.height = "100%";
		mainContainer.style.width = "100%";
		mainContainer.style.paddingLeft = "0.75rem";
		mainContainer.style.paddingRight = "0.75rem";
	}

	// Check if elements with the class name "header" exist
	const headerElements = document.getElementsByClassName("header");
	if (headerElements && headerElements.length > 0) {
		headerElements[0].style.display = "flex";
	}

	// Check if elements with the class name "css-1g7fu7m-MuiContainer-root" exist
	const muiContainerElements = document.getElementsByClassName("css-1g7fu7m-MuiContainer-root");
	if (muiContainerElements && muiContainerElements.length > 0) {
		const muiContainer = muiContainerElements[0];
		muiContainer.style.maxWidth = "100%";
		muiContainer.style.paddingTop = "0";
	} 

	const muiContainerElement = document.getElementsByClassName("css-43wt9-MuiContainer-root");
	if (muiContainerElement && muiContainerElement.length > 0 && window.location.href.split("id=")[1]) {
		const muiContainer = muiContainerElement[0];
		muiContainer.style.paddingTop = "0";
	}
    setPlaylistIndex(0);
    setVideoIndex(0);
    // changePalylistData(0);
	var userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
	if(userDetails !== null) {
		setLoginId(userDetails.user_id);
	  getUserMedia(userDetails.user_id);
	}
	if (window.location.href.split("id=")[1]) {
		setIsLogin(window.location.href.split("id=")[1]);
		setLoginId(window.location.href.split("id=")[1]);
	}
	document.addEventListener('mousedown', handleClickOutside);
    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Video and Playlist Default Selected
  const [videoIndex, setVideoIndex] = useState(0);
  const [playlistIndex, setPlaylistIndex] = useState(0);
 const [currentPlaylist, setCurrentPlaylist] = useState(null);
  const [hasOpenedPlaylist, setHasOpenedPlaylist] = useState(false);

  const [sharedPlaylist, setsharedPlaylist] = useState(playlists[playlistIndex]);
useEffect(() => {
  if (playlists.length > 0 && playlistIndex >= 0 && playlists[playlistIndex]) {
    const selected = playlists[playlistIndex];

    // Prevent setting back to old playlist by checking title
    // console.log("🎯 Current Playlist Changed:", selected.title);
    setCurrentPlaylist(selected);
  }
}, [playlistIndex, playlists]);


  // const currentVideo = currentPlaylist.videos[videoIndex];
  // Loop Playlist
  const [loopPlayList, setLoopPlayList] = useState(false);
  // Video Ended
  const onEnded = () => {
    if (YoutubeTempPlaylist[videoIndex + 1]) {
      setVideoIndex(videoIndex + 1);
		setCurrentPlay(getId(YoutubeTempPlaylist[videoIndex + 1].url));
    } else if (playlists[playlistIndex + 1]) {
      if (!loopPlayList) {
        if (playlists[playlistIndex + 1].title == "Temp") {
          setPlaylistIndex(0);
          setVideoIndex(0);
          changePalylistData(0);
        } else {
          setPlaylistIndex(playlistIndex + 1);
          setVideoIndex(0);
          changePalylistData(playlistIndex + 1);
        }
      } else {
        setVideoIndex(0);
      }
    } else {
      setPlaylistIndex(0);
      setVideoIndex(0);
      changePalylistData(0);
    }
  };

  useEffect(() => {
  }, [videoIndex]);
  // Youtube Temp Data
  const [YoutubeTempPlaylist, setYoutubeTempPlaylist] = useState([]);
  // const [intoplay, setIntroplay] = useState(false);
  // const [intoPlayUrl, setIntoPlayUrl] = useState("");

 const changePalylistData = (ind) => {
  setYoutubePlay(false);

  if (playlists.length !== 0 && playlists[ind]) {
    setHasOpenedPlaylist(true);
    const playlist = playlists[ind];

    if (Array.isArray(playlist.videos)) {
      setYoutubeTempPlaylist(playlist.videos);

      if (playlist.videos[videoIndex]) {
        setCurrentPlay(getId(playlist.videos[videoIndex].url));
      }
    } else {
      setYoutubeTempPlaylist([]);
    }

    if (playlist.introVideo) {
      setYoutubePlay(true);
      setYoutubePlayUrl("asset/introvideo/" + playlist.introVideo);
    }

    getPlaylistViews(ind);
  }
};


  const onYoutubeVideoEndend = () => { setYoutubePlay(false); };
  // Update Runtime Time
  const [playListRunTime, setPlayListRunTime] = useState(0);


  useEffect(() => {
	setPlaylists(playlists_data);
    var sec = 0;
    for (let i = 0; i < YoutubeTempPlaylist.length; i++) {
      sec = sec + parseInt(YoutubeTempPlaylist[i]?.duration);
    }
    setPlayListRunTime(sec);
    document.addEventListener('mousedown', handleClickOutsideDown);
    return () => {
        document.removeEventListener('mousedown', handleClickOutsideDown);
    };
  }, [playlists_data]);

  //  Youtube Search Video using api
  const [searchKeyword, setSearchKeyword] = useState("");
  // const [indexing, setIndexing] = useState(0);
  const [showSearchVideo, setshowSearchVideo] = useState(true);
  const [nextPageToken, setnextPageToken] = useState("");
  const [prevPageToken, setprevPageToken] = useState("");
  const [nextPageTokenDown, setnextPageTokenDown] = useState("");
  const [prevPageTokenDown, setprevPageTokenDown] = useState("");
  const [allYoutubeSearchVideoData, SetallYoutubeSearchVideoData] = useState([]);
  const [allYoutubeSearchVideoDataDown, SetallYoutubeSearchVideoDataDown] = useState([]);
  const searchYoutubeVideo = async (data) => {
    if (data.searchText == "") {
      alert("Please Enter Something");
    } else {
      setshowSearchVideo(false);
      var pageToken = nextPageToken;
      if (data.searchText.length > 1) {
        if (searchSection == 'up') {
            setYoutubeSearchLoader(true)
            pageToken = nextPageToken;
        } else {
            setVimeoSearchLoader(true);
            pageToken = nextPageTokenDown;
        }
        var videosData = [];
        await axios
  .get(`https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=25&pageToken=${pageToken}&q=${data.searchText}&type=video&videoEmbeddable=true&key=${process.env.REACT_APP_YOUTUBEAPIKEY}`)
  .then(async (videos) => {
    if (searchSection == 'up') {
      setnextPageToken(videos.data.nextPageToken);
      setprevPageToken(videos.data.prevPageToken);
    } else {
      setnextPageTokenDown(videos.data.nextPageToken);
      setprevPageTokenDown(videos.data.prevPageToken);
    }
    const videoIds = videos.data.items
      .filter(item => item.id && item.id.videoId)
      .map(item => item.id.videoId);
    if (videoIds.length === 0) {
      if (searchSection == 'up') setYoutubeSearchLoader(false);
      else setVimeoSearchLoader(false);
      return;
    }
    const batchRes = await axios.get(
      `https://www.googleapis.com/youtube/v3/videos?part=snippet%2Cstatus%2CcontentDetails%2Cstatistics&id=${videoIds.join(',')}&key=${process.env.REACT_APP_YOUTUBEAPIKEY}`
    );
    const detailsMap = {};
    if (batchRes.data.items) {
      batchRes.data.items.forEach(item => { detailsMap[item.id] = item; });
    }
    for (let i = 0; i < videos.data.items.length; i++) {
      const vid = videos.data.items[i];
      if (!vid.id || !vid.id.videoId) continue;
      const details = detailsMap[vid.id.videoId];
      if (!details) continue;
      if (details.status && details.status.embeddable === true && details.status.uploadStatus === 'processed') {
        vid.likes = details.statistics ? details.statistics.likeCount : '0';
        vid.views = details.statistics ? details.statistics.viewCount : '0';
        vid.tags = details.snippet ? details.snippet.tags : [];
        vid.duration = details.contentDetails ? details.contentDetails.duration : 'PT0S';
        videosData.push(vid);
      }
    }
    if (videosData.length > 0) {
      if (searchSection == 'up') {
        SetallYoutubeSearchVideoData(videosData);
      } else {
        SetallYoutubeSearchVideoDataDown(videosData);
      }
    }
    if (searchSection == 'up') {
      setYoutubeSearchLoader(false);
    } else {
      setVimeoSearchLoader(false);
    }
  })
  .catch((error) => {
    console.error('YouTube search error:', error.message || error);
    if (searchSection == 'up') setYoutubeSearchLoader(false);
    else setVimeoSearchLoader(false);
  });

        // await axios.get(`https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=100&pageToken=` + pageToken + `&q=` + data.searchText + `,&key=` + process.env.REACT_APP_YOUTUBEAPIKEY)
        //   .then(async (videos) => {
        //     if (searchSection == 'up') {
        //         setnextPageToken(videos.data.nextPageToken);
        //         setprevPageToken(videos.data.prevPageToken);
        //     } else {
        //         setnextPageTokenDown(videos.data.nextPageToken);
        //         setprevPageTokenDown(videos.data.prevPageToken);
        //     }
        //     for (let i = 0; i < videos.data.items.length; i++) {
        //       await axios.get(`https://www.googleapis.com/youtube/v3/videos?part=snippet%2Cstatus%2CcontentDetails%2Cstatistics&id=` + videos.data.items[i].id.videoId + `&key=` + process.env.REACT_APP_YOUTUBEAPIKEY)
        //         .then(async (res) => {
        //           if (res.data.items.length != 0)
        //             await axios.post(process.env.REACT_APP_API_URL + "/manageplaylist/findYoutubeValidater", { videoURL: `https://www.youtube.com/embed/` + videos.data.items[i].id.videoId, }).then((resNew) => {
        //               if (resNew.data.status == "PLAYABLE") {
        //                 videos.data.items[i].likes = res.data.items[0].statistics.likeCount;
        //                 videos.data.items[i].views = res.data.items[0].statistics.viewCount;
        //                 // videos.data.items[i].category = catagrorys[res.data.items[0].snippet.categoryId];
        //                 videos.data.items[i].tags = res.data.items[0].snippet.tags;
        //                 videos.data.items[i].duration = res.data.items[0].contentDetails.duration;
        //                 videosData.push(videos.data.items[i]);
        //               }
        //             });
        //         });
        //     }

        //     if (videosData.length > 0) {
        //         if (searchSection == 'up') {
        //             SetallYoutubeSearchVideoData(videosData);	
        //         } else {
        //             SetallYoutubeSearchVideoDataDown(videosData);
        //         }
        //     }

        //     if (searchSection == 'up') {
        //         setYoutubeSearchLoader(false)
        //     } else {
        //         setVimeoSearchLoader(false);
        //     }
        //   });
      }
    }
  };

    const getFormData = (find = '') => {
        var form = searchSection == 'up' ? formRef.current : formRefDown.current;
		if (formMobRef.current.elements.youtubesearch.value !== '') {
			form = formMobRef.current;
			if (searchSection == 'up') {
				const tab = searchTab || 'all';
				handleButtonClick(tab === 'vimeo' ? 'vimeo' : 'youtube');
			} else {
				const tab = searchTabDown || 'all';
				handleButtonClick(tab === 'vimeo' ? 'vimeo' : 'youtube');
			}
		}
        var data = {
            searchText: form.elements.youtubesearch.value,
            section: form.attributes["data-section"].value
        };
        return find !== '' ? (data[find] !== undefined ? data[find] : '')  : data;
    }

    // const searchVideos = async (e) => {
	  //   e.preventDefault();
    //     var data = getFormData();
    //     if (data.section == 'up' && searchTab == "youtube" || data.section == 'down' && searchTabDown == "youtube") {
    //         searchYoutubeVideo(data);
    //     } else {
    //         searchVimeoVideo(data);
    //     }
    // }
    const searchVideos = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
	
	if (document.activeElement && document.activeElement.blur) {
		document.activeElement.blur();
	  }
  
    var data = getFormData();
    const activeTab = data.section == 'up' ? searchTab : searchTabDown;
    if (activeTab === "youtube") {
        searchYoutubeVideo(data);
    } else if (activeTab === "vimeo") {
        searchVimeoVideo(data);
    } else {
        const isUp = data.section === 'up';
        if (isUp) { setYoutubeSearchLoader(true); setshowSearchVideo(false); }
        else { setVimeoSearchLoader(true); }
        doUniversalSearch(process.env.REACT_APP_API_URL, activeTab, data.searchText, 1)
          .then((results) => {
            if (isUp) { SetallYoutubeSearchVideoData(results); setYoutubeSearchLoader(false); }
            else { SetallYoutubeSearchVideoDataDown(results); setVimeoSearchLoader(false); }
          })
          .catch((err) => {
            console.error('Universal search error:', err);
            if (isUp) setYoutubeSearchLoader(false);
            else setVimeoSearchLoader(false);
          });
    }
}
  // NEXT Youtube Video
  const [tempSearchKeyword, setTempSearchKeyword] = useState(""); // ps
  const [tempSearchKeywordNum, setTempSearchKeywordNum] = useState(0); // ps
  const nextyoutuberesults = (e) => {
    searchVideos(e);
  };

  // Previous Youtube Video
  const previousyoutuberesults = (e) => {
    var data = getFormData();
    // e.preventDefault();
    if (data.searchText == "") {
      alert("Please Enter Something");
    } else {
      setshowSearchVideo(false);
      var pageTokenPrev = '';
      if (data.searchText.length > 1) {
        if (searchSection == 'up') {
            setYoutubeSearchLoader(true)
            pageTokenPrev = prevPageToken;
        } else {
            setVimeoSearchLoader(true);
            pageTokenPrev = prevPageTokenDown;
        }
        var videosData = [];
        axios.get(`https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=100&pageToken=` + pageTokenPrev + `&q=` + data.searchText + `,&key=` + process.env.REACT_APP_YOUTUBEAPIKEY)
          .then(async (videos) => {

            if (searchSection == 'up') {
                setnextPageToken(videos.data.nextPageToken);
                setprevPageToken(videos.data.prevPageToken);
            } else {
                setnextPageTokenDown(videos.data.nextPageToken);
                setprevPageTokenDown(videos.data.prevPageToken);
            }
            for (let i = 0; i < videos.data.items.length; i++) {
              await axios.get(`https://www.googleapis.com/youtube/v3/videos?part=snippet%2Cstatus%2CcontentDetails%2Cstatistics&id=` + videos.data.items[i].id.videoId + `&key=` + process.env.REACT_APP_YOUTUBEAPIKEY)
                .then(async (res) => {
                  if (res.data.items.length != 0)
                    await axios.post(process.env.REACT_APP_API_URL + "/manageplaylist/findYoutubeValidater", { videoURL: `https://www.youtube.com/embed/` + videos.data.items[i].id.videoId, }).then((resNew) => {
                      if (resNew.data.status == "PLAYABLE") {
                        videos.data.items[i].likes = res.data.items[0].statistics.likeCount;
                        videos.data.items[i].views = res.data.items[0].statistics.viewCount;
                        // videos.data.items[i].category = catagrorys[res.data.items[0].snippet.categoryId];
                        videos.data.items[i].tags = res.data.items[0].snippet.tags;
                        videos.data.items[i].duration = res.data.items[0].contentDetails.duration;
                        videosData.push(videos.data.items[i]);
                      }
                    });
                });
            }

            if (videosData.length > 0) {
                if (searchSection == 'up') {
                    setYoutubeSearchLoader(false)
                    SetallYoutubeSearchVideoData(videosData);	
                } else {
                    setVimeoSearchLoader(false);
                    SetallYoutubeSearchVideoDataDown(videosData);	
                }
            }

          });
      }
    }
  };

  const setYoutubeDatainState = (
    title,
    video_url,
    views,
    likes,
    publishTime,
    duration,
    tags,
    channelTitle,
    channel_url,
    thumbnail,
    description,
    embeded_code,
    category,
    location_details,
    source_platform
  ) => {
    let newListArray = {
      title: title,
      url: video_url,
      views: views,
      likes: likes,
      posted_date: publishTime,
      duration: duration,
      keywords: tags,
      channel_name: channelTitle,
      channel_url: channel_url,
      thumbnail: thumbnail,
      description: description,
      embeded_code: embeded_code,
      category: category,
      location: JSON.stringify(location_details),
      plays_at: null,
      _source: source_platform || "",
    };
    setYoutubeTempPlaylist((YoutubeTempPlaylist) => [
      ...YoutubeTempPlaylist,
      newListArray,
    ]);
    // Update 2x2 thumbnail grid for current playlist in sidebar
    setPlaylists(prev => prev.map((pl, i) => {
      if (i === playlistIndex) {
        const allThumbs = [...(YoutubeTempPlaylist || []), newListArray]
          .filter(v => v && v.thumbnail)
          .map(v => v.thumbnail)
          .slice(0, 4);
        return { ...pl, image: allThumbs };
      }
      return pl;
    }));
    setTimeout(() => {
      var objDiv = document.getElementById("tempPlaylist");
      var postionDiv = objDiv.scrollHeight;
      objDiv.scrollTop = postionDiv;
    }, 500);
  };

  // ── CSV Export ──────────────────────────────────────────────────────
  // CSV Import (shared desktop + mobile)
  const handleCsvImport = (file, resetInput) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async (evt) => {
                    if (!file) return;
                    const reader = new FileReader();
                    reader.onload = async (evt) => {
                      try {
                        const text = evt.target.result;
                        const lines = text.split(/\r?\n/).filter(l => l.trim());
                        if (lines.length < 2) { toast.error("CSV is empty"); return; }
                        // Parse header
                        const parseCSVLine = (line) => {
                          const result = [];
                          let current = '';
                          let inQuotes = false;
                          for (let i = 0; i < line.length; i++) {
                            const ch = line[i];
                            if (inQuotes) {
                              if (ch === '"' && line[i+1] === '"') { current += '"'; i++; }
                              else if (ch === '"') { inQuotes = false; }
                              else { current += ch; }
                            } else {
                              if (ch === '"') { inQuotes = true; }
                              else if (ch === ',') { result.push(current.trim()); current = ''; }
                              else { current += ch; }
                            }
                          }
                          result.push(current.trim());
                          return result;
                        };
                        const headers = parseCSVLine(lines[0]).map(h => h.replace(/^"|"$/g, '').trim());
                        const clips = [];
                        for (let i = 1; i < lines.length; i++) {
                          const vals = parseCSVLine(lines[i]);
                          const obj = {};
                          headers.forEach((h, idx) => { obj[h] = vals[idx] || ''; });
                          if (!obj.url && !obj.title) return;
                          // Parse duration string back to seconds
                          let durSec = 0;
                          if (obj.duration) {
                            const parts = obj.duration.split(':').map(Number);
                            if (parts.length === 3) durSec = parts[0]*3600 + parts[1]*60 + parts[2];
                            else if (parts.length === 2) durSec = parts[0]*60 + parts[1];
                            else durSec = parts[0] || 0;
                          }
                          clips.push({
                            title: obj.title || 'Untitled',
                            url: obj.url || '',
                            views: obj.views || '',
                            likes: obj.likes || '',
                            posted_date: obj.posted_date || obj.upload_date_raw || '',
                            publishTime: obj.posted_date || obj.upload_date_raw || '',
                            channel_name: obj.channel_name || '',
                            channel_url: obj.channel_url || '',
                            thumbnail: obj.thumbnail || '',
                            embeded_code: obj.embeded_code || '',
                            duration: durSec,
                            description: obj.description || '',
                            category: obj.category || '',
                            keywords: obj.keyword || '',
                            _source: obj.category || '',
                          });
                        }
                        if (clips.length === 0) { toast.error("No valid clips found in CSV"); return; }
                        setYoutubeTempPlaylist(clips);
                        // Create new playlist from filename, save clips, refresh
                        const baseName = file.name.replace(/\.csv$/i, '').replace(/_\d{4}-\d{2}-\d{2}T[\d-]*$/, '').replace(/_/g, ' ').trim() || 'Imported Playlist';
                        try {
                          // 1. Create playlist
                          await axios.post(
                            process.env.REACT_APP_API_URL + "/manageplaylist/add",
                            { title: baseName, opration: "add", user: loginId, description: "Imported from " + file.name }
                          );
                          // 2. Refresh playlists to get the new one
                          const response = await axios.get(process.env.REACT_APP_API_URL + "/playlist/getPlayListData");
                          const updatedPlaylists = response.data;
                          const newIdx = updatedPlaylists.findIndex(pl => pl.title === baseName);
                          if (newIdx !== -1) {
                            setPlaylists(updatedPlaylists);
                            // 3. Save clips to the new playlist
                            await axios.post(process.env.REACT_APP_API_URL + "/playlist/savePlayListData", {
                              all_playlist_data: clips,
                              playlist_id: updatedPlaylists[newIdx]._id,
                              user: "alreday",
                              user_id: loginId,
                              title: baseName,
                            });
                            // 4. Re-fetch playlists so thumbnails update from saved clips
                            const refreshed = await axios.get(process.env.REACT_APP_API_URL + "/playlist/getPlayListData");
                            const finalPlaylists = refreshed.data;
                            const finalIdx = finalPlaylists.findIndex(pl => pl.title === baseName);
                            setPlaylists(finalPlaylists);
                            if (finalIdx !== -1) {
                              setPlaylistIndex(finalIdx);
                              setVideoIndex(0);
                              setCurrentPlaylist(finalPlaylists[finalIdx]);
                              changePalylistData(finalIdx);
                              // Load clips into editor after a tick so changePalylistData completes
                              setTimeout(() => {
                                setYoutubeTempPlaylist(finalPlaylists[finalIdx].videos || clips);
                                handleButtonClick('playlist');
                              }, 100);
                            }
                            toast.success(clips.length + " clips imported as " + baseName);
                          } else {
                            toast.error("Playlist created but could not find it");
                          }
                        } catch(apiErr) {
                          console.error("Import save error:", apiErr);
                          toast.error("Clips loaded but failed to save: " + (apiErr.response?.data?.error || apiErr.message));
                        }
                      } catch(err) {
                        console.error("CSV import error:", err);
                        toast.error("Failed to parse CSV: " + err.message);
                      }
                    };
                        };
    reader.readAsText(file);
    if (resetInput) resetInput();
  };

  const exportPlaylistCSV = () => {
    if (!YoutubeTempPlaylist || YoutubeTempPlaylist.length === 0) {
      alert("No videos in playlist to export.");
      return;
    }

    const CSV_HEADERS = [
      "title","url","views","posted_date","channel_name","channel_url",
      "thumbnail","embeded_code","duration","description","category",
      "plays_at","captions","play_log","clip_cleared","clip_contact",
      "timestamp","keyword","likes","framing","upload_date_raw"
    ];

    // Format duration from seconds to H:MM:SS or M:SS
    const fmtDuration = (sec) => {
      const s = parseInt(sec) || 0;
      if (s <= 0) return "";
      const h = Math.floor(s / 3600);
      const m = Math.floor((s % 3600) / 60);
      const ss = s % 60;
      if (h > 0) return h + ":" + String(m).padStart(2,"0") + ":" + String(ss).padStart(2,"0");
      return m + ":" + String(ss).padStart(2,"0");
    };

    // Today as MM_DD_YYYY
    const now = new Date();
    const today = String(now.getMonth()+1).padStart(2,"0") + "_" +
                  String(now.getDate()).padStart(2,"0") + "_" + now.getFullYear();

    // Detect source from URL
    const detectSource = (url) => {
      if (!url) return "";
      if (url.includes("youtube.com") || url.includes("youtu.be")) return "youtube";
      if (url.includes("vimeo.com")) return "vimeo";
      if (url.includes("archive.org")) return "archive";
      if (url.includes("dailymotion.com") || url.includes("dmcdn.net")) return "dailymotion";
      if (url.includes("odysee.com") || url.includes("odycdn.com")) return "odysee";
      if (url.includes("wikimedia.org")) return "wikimedia";
      if (url.includes("peertube") || url.includes("trom.tf") || url.includes("framatube") || url.includes("diode.zone")) return "peertube";
      return "";
    };

    const escapeCSV = (val) => {
      let s = String(val == null ? "" : val);
      // Strip surrounding quotes if already present
      if (s.startsWith('"') && s.endsWith('"')) s = s.slice(1, -1);
      s = s.replace(/"/g, '""');
      return '"' + s + '"';
    };

    const rows = [CSV_HEADERS.map(h => '"' + h + '"').join(",")];

    YoutubeTempPlaylist.forEach((v) => {
      const source = v._source || detectSource(v.url) || "";
      const row = [
        escapeCSV(v.title),
        escapeCSV(v.url),
        escapeCSV(v.views || ""),
        escapeCSV(v.posted_date || ""),
        escapeCSV(v.channel_name || ""),
        escapeCSV(v.channel_url || ""),
        escapeCSV(v.thumbnail || ""),
        escapeCSV(v.embeded_code || ""),
        escapeCSV(fmtDuration(v.duration)),
        escapeCSV(v.description || ""),
        escapeCSV(v.category || source),
        escapeCSV(v.plays_at || ""),
        escapeCSV(""),          // captions
        escapeCSV(""),          // play_log
        escapeCSV(""),          // clip_cleared
        escapeCSV(""),          // clip_contact
        escapeCSV(today),       // timestamp
        escapeCSV(v.keywords || ""),  // keyword
        escapeCSV(v.likes || ""),
        escapeCSV("normal"),    // framing
        escapeCSV(v.posted_date || ""),  // upload_date_raw
      ];
      rows.push(row.join(","));
    });

    const csvContent = rows.join("\r\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    const playlistName = currentPlaylist ? currentPlaylist.title.replace(/[^a-zA-Z0-9]/g, "_") : "playlist";
    const ts = now.toISOString().replace(/[:.]/g, "-").slice(0, -5);
    link.setAttribute("href", url);
    link.setAttribute("download", playlistName + "_" + ts + ".csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  //  Add New Playlist
  const [newplaylistName, setnewplaylistName] = useState("");
  const [newplaylistDescription, setnewplaylistDescription] = useState("");


 const addNewPlaylistSubmit = async () => {
  if (isLogin == null || !loginId) {
    toast.error("Please log in to save your playlist.");
    return;
  }
  const pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  );

  if (newplaylistName.length > 1 && !newplaylistName.includes("https://")) {
    let duplicateCount = 0;
    playlists?.forEach((element) => {
      if (
        element.title === newplaylistName &&
        (!editPlaylist || (editPlaylist && element._id !== currentPlaylist?._id))
      ) {
        duplicateCount++;
      }
    });

    if (duplicateCount === 0) {
      const playlist_data = {
        title: newplaylistName,
        opration: editPlaylist ? "update" : "add",
        user: loginId,
        description: newplaylistDescription,
      };

      if (editPlaylist) {
        playlist_data.id = currentPlaylist._id;
      }

      try {
        const res = await axios.post(
          process.env.REACT_APP_API_URL + "/manageplaylist/add",
          playlist_data
        );

        toast.success("Playlist Updated Successfully");
       
        
        setnewplaylistName("");
        setnewplaylistDescription("");

        // Refresh playlists
        const response = await axios.get(
          process.env.REACT_APP_API_URL + "/playlist/getPlayListData"
        );

        const updatedPlaylists = response.data;
     const newIndex = updatedPlaylists.findIndex(pl => pl.title === newplaylistName);
if (newIndex !== -1) {
  // Save new playlist data in local var
  const newPlaylist = updatedPlaylists[newIndex];

  setPlaylists(updatedPlaylists); // This triggers useEffect

  // Delay update until after playlists state is committed
  setTimeout(() => {
    setPlaylistIndex(newIndex); 
    setVideoIndex(0);
    setCurrentPlaylist(newPlaylist); 
    changePalylistData(newIndex);
      setYoutubeTempPlaylist([]);
setShow(prev => ({ ...prev, new_list: false, playlistDesc: false }));


    // console.log("✅ Playlist index set to:", newIndex, "Title:", newPlaylist.title);
  }, 0);
}


        else {
          console.warn("⚠️ New playlist not found in list after save.");
          setPlaylists(updatedPlaylists);
        }
        // Always close the dialog after successful save
        setShow(prev => ({ ...prev, new_list: false, playlistDesc: false }));

        // if (!editPlaylist) {
        //   setYoutubeTempPlaylist([]);
        // }

      } catch (err) {
        console.error("Error adding playlist:", err);
        if (
          err.response &&
          err.response.data &&
          err.response.data.errorMessage
        ) {
          toast.error(err.response.data.errorMessage);
        } else {
          toast.error("An unexpected error occurred.");
        }
      }
    } else {
      toast.error("Playlist Already Exists!");
    }
  } else {
    toast.error("Please Enter a Valid Name!");
    setnewplaylistName("");
  }
};

  //  Up Down Manage
  const tempPlayListVideoTop = (ind) => {
    if (ind != 0) {
      const sourceList = YoutubeTempPlaylist.length > 0
        ? YoutubeTempPlaylist
        : (currentPlaylist && currentPlaylist.videos ? currentPlaylist.videos : []);
      if (ind >= sourceList.length) return;
      const items = JSON.parse(JSON.stringify(sourceList));
      var element = items[ind];
      items.splice(ind, 1);
      items.splice(ind - 1, 0, element);
      setYoutubeTempPlaylist(items);
    }
  };
  const tempPlayListVideoDown = (ind) => {
    const sourceList = YoutubeTempPlaylist.length > 0
      ? YoutubeTempPlaylist
      : (currentPlaylist && currentPlaylist.videos ? currentPlaylist.videos : []);
    if (ind != sourceList.length - 1) {
      const items = JSON.parse(JSON.stringify(sourceList));
      var element = items[ind];
      items.splice(ind, 1);
      items.splice(ind + 1, 0, element);
      setYoutubeTempPlaylist(items);
    }
  };
  //  Temp PlayList Remove Btn


  // ── Drag-and-drop reorder for clip cards ──
  const handleClipDragStart = (e, idx) => {
    clipDragRef.current = idx;
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', String(idx));
    e.currentTarget.style.opacity = '0.4';
    e.currentTarget.style.border = '1px dashed #7c3aed';
  };
  const handleClipDragEnd = (e) => {
    e.currentTarget.style.opacity = '1';
    e.currentTarget.style.border = '';
    document.querySelectorAll('.mainBox').forEach(el => { el.style.borderTop = ''; });
  };
  const handleClipDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    const box = e.currentTarget.closest('.mainBox');
    if (box) box.style.borderTop = '2px solid #7c3aed';
  };
  const handleClipDragLeave = (e) => {
    const box = e.currentTarget.closest('.mainBox');
    if (box) box.style.borderTop = '';
  };
  const handleClipDrop = (e, dropIdx) => {
    e.preventDefault();
    e.stopPropagation();
    document.querySelectorAll('.mainBox').forEach(el => {
      el.style.borderTop = '';
      el.style.opacity = '1';
      el.style.border = '';
    });
    let dragIdx = clipDragRef.current;
    if (dragIdx === null || dragIdx === undefined) {
      const transferred = e.dataTransfer.getData('text/plain');
      if (transferred !== '') dragIdx = parseInt(transferred, 10);
    }
    if (dragIdx === null || dragIdx === undefined || isNaN(dragIdx) || dragIdx === dropIdx) {
      clipDragRef.current = null;
      return;
    }
    // Use same source as the JSX render — YoutubeTempPlaylist if populated,
    // otherwise currentPlaylist.videos (what the user actually sees)
    const sourceList = YoutubeTempPlaylist.length > 0
      ? YoutubeTempPlaylist
      : (currentPlaylist && currentPlaylist.videos ? currentPlaylist.videos : []);
    if (dragIdx < 0 || dragIdx >= sourceList.length || dropIdx < 0 || dropIdx >= sourceList.length) {
      clipDragRef.current = null;
      return;
    }
    const items = JSON.parse(JSON.stringify(sourceList));
    const element = items[dragIdx];
    items.splice(dragIdx, 1);
    items.splice(dropIdx, 0, element);
    setYoutubeTempPlaylist(items);
    clipDragRef.current = null;
  };

  const tempPlayListVideoRemove = (ind) => {
    let newListArray = YoutubeTempPlaylist;
    newListArray.splice(ind, 1);
    setYoutubeTempPlaylist(newListArray);
  };
  // play video
  const playYoutubeTempList = (ind) => {
    setVideoIndex(ind);
  };
  // delete
  const deleteCurrentPlaylist = (Playlist) => {
    swal({
      title: "Are you sure?",
      text: "This playlist will be permanently deleted.",
      icon: "warning",
      buttons: {
        cancel: { text: "Cancel", value: false, visible: true, className: "swal-btn-cancel" },
        confirm: { text: "Delete", value: true, className: "swal-btn-confirm" }
      },
      dangerMode: true,
      className: "dark-swal",
    }).then((willDelete) => {
      if (willDelete) {
        // if (playlists.length == 1)
        //   axios.post(process.env.REACT_APP_API_URL + "/manageplaylist/add", {
        //     title: "Temp",
        //     opration: "add",
        //   });
        if (Playlist) {
          for (let index = 0; index < Playlist.users.length; index++) {
            if (  Playlist.users[index]._id == loginId ) {
              axios
                .post(
                  process.env.REACT_APP_API_URL + "/manageplaylist/delete",
                  { ids: Playlist._id }
                )
                .then((res) => {
                  toast.success("Delete Successfully");
                  setPlaylistIndex(index);
                  setVideoIndex(0);
                  changePalylistData(index);
                  window.location.reload();

                })
                .catch((err) => {
                  if (
                    err.response &&
                    err.response.data &&
                    err.response.data.errorMessage
                  )
                    toast.error(err.response.data.errorMessage);
                });
            } else {
              setYoutubeTempPlaylist([]);
            }
          }
        }
      }
    });
  };
  //Get User Data
	
	// ── Drag-and-drop reorder for playlist cards ──
	const handlePlaylistDragStart = (e, idx) => {
		playlistDragRef.current = idx;
		e.dataTransfer.effectAllowed = 'move';
		e.dataTransfer.setData('text/plain', String(idx));
		e.currentTarget.style.opacity = '0.4';
		e.currentTarget.style.border = '1px dashed #7c3aed';
	};
	const handlePlaylistDragEnd = (e) => {
		e.currentTarget.style.opacity = '1';
		e.currentTarget.style.border = '';
		document.querySelectorAll('.playlist_main_box').forEach(el => { el.style.borderTop = ''; });
	};
	const handlePlaylistDragOver = (e) => {
		e.preventDefault();
		e.dataTransfer.dropEffect = 'move';
		const box = e.currentTarget.closest('.playlist_main_box');
		if (box) box.style.borderTop = '2px solid #7c3aed';
	};
	const handlePlaylistDragLeave = (e) => {
		const box = e.currentTarget.closest('.playlist_main_box');
		if (box) box.style.borderTop = '';
	};
	const handlePlaylistDrop = async (e, dropIdx) => {
		e.preventDefault();
		e.stopPropagation();
		document.querySelectorAll('.playlist_main_box').forEach(el => {
			el.style.borderTop = '';
			el.style.opacity = '1';
			el.style.border = '';
		});
		let dragIdx = playlistDragRef.current;
		if (dragIdx === null || dragIdx === undefined) {
			const transferred = e.dataTransfer.getData('text/plain');
			if (transferred !== '') dragIdx = parseInt(transferred, 10);
		}
		if (dragIdx === null || dragIdx === undefined || isNaN(dragIdx) || dragIdx === dropIdx) {
			playlistDragRef.current = null;
			return;
		}
		// Filter to only user-owned, non-Temp playlists (matching what renders)
		const validPlaylists = playlists.filter(p => p && p.title !== 'Temp' && p.users && p.users[0] && p.users[0]._id === loginId);
		if (dragIdx < 0 || dragIdx >= validPlaylists.length || dropIdx < 0 || dropIdx >= validPlaylists.length) {
			playlistDragRef.current = null;
			return;
		}
		// Deep clone full playlists array and reorder
		const cloned = JSON.parse(JSON.stringify(playlists));
		// Map visible indices back to full array indices
		let visibleCount = -1;
		let fullDragIdx = -1, fullDropIdx = -1;
		for (let i = 0; i < cloned.length; i++) {
			const p = cloned[i];
			if (p && p.title !== 'Temp' && p.users && p.users[0] && p.users[0]._id === loginId) {
				visibleCount++;
				if (visibleCount === dragIdx) fullDragIdx = i;
				if (visibleCount === dropIdx) fullDropIdx = i;
			}
		}
		if (fullDragIdx === -1 || fullDropIdx === -1) {
			playlistDragRef.current = null;
			return;
		}
		const element = cloned[fullDragIdx];
		cloned.splice(fullDragIdx, 1);
		cloned.splice(fullDropIdx, 0, element);
		setPlaylists(cloned);
		playlistDragRef.current = null;
		// Call same API as arrow reorder
		try {
			const payload = {};
			cloned.forEach((p, i) => {
				if (p && p._id) payload[i] = p._id;
			});
			const res = await axios.post(
				process.env.REACT_APP_API_URL + '/playlist/update-order',
				{ data: payload }
			);
			toast.success(res.data?.title || 'Playlist order updated');
		} catch (err) {
			console.error('Playlist drag reorder error', err);
			toast.error(err.response?.data?.error || 'Order update failed');
		}
	};

	const setPlaylistOrderSequence = async (playlistId, order, e) => {
		//console.warn(e);
	  // Quick guards & logs for debugging
	  const parentBox = e?.currentTarget?.closest(".playlist_main_box");
	  const parentClass = parentBox?.className || "";
	  const newClass = parentClass.split(" ").find(c => c.startsWith("new-"));
	  
	  const wrapper = document.querySelector(".creator_PlaylistPlayer__playlists");
	  
	  if(order === 'up'){
		  const firstChild = wrapper?.firstElementChild;
		   console.warn(firstChild);
		  if (firstChild?.classList?.contains(newClass)) {
			 console.warn(firstChild);
			  return false;
		  }
	  }
	  
	  if(order === 'down'){
		  const firstChild = wrapper?.lastElementChild;
		   console.warn(firstChild);
		  if (firstChild?.classList?.contains(newClass)) {
			 console.warn(firstChild);
			  return false;
		  }
	  }


	  // disable UI interaction while processing
	  setPlaylistsSequenceStatus(true); // show loading / disable UI

	  try {
		// Use functional state update so we always operate on latest state
		let newPlaylists = await new Promise((resolve) => {
		  setPlaylists(prev => {
			// defensive: ensure prev is an array
			const list = Array.isArray(prev) ? prev.filter(Boolean) : [];
			const currentIndex = list.findIndex(p => p && p._id === playlistId);

			// debug info

			if (currentIndex === -1) {
			  console.warn('reorder: playlist not found in current state', playlistId);
			  resolve(list); // return unchanged
			  return list;
			}

			// invalid moves
			if ((order === 'up' && currentIndex === 0) ||
				(order === 'down' && currentIndex === list.length - 1)) {
			  resolve(list);
			  return list;
			}

			const replaceWith = order === 'up' ? currentIndex - 1 : currentIndex + 1;

			// clone each item to ensure new references
			const cloned = list.map(p => ({ ...p }));

			// swap
			[cloned[currentIndex], cloned[replaceWith]] = [cloned[replaceWith], cloned[currentIndex]];

			resolve(cloned); // resolve promise with updated array
			return cloned;
		  });
		});

		// If no change, skip API call
		if (!Array.isArray(newPlaylists) || newPlaylists.length === 0) {
		  return;
		}

		// Build payload safely (skip any missing _id)
		const payload = {};
		newPlaylists.forEach((p, i) => {
		  if (p && p._id) payload[i] = p._id;
		});

		// Optional: optimistically update UI was already done above.
		// Send to backend
		const res = await axios.post(
		  `${process.env.REACT_APP_API_URL}/playlist/update-order`,
		  { data: payload }
		);

		toast.success(res.data?.title || 'Playlist order updated');
	  } catch (err) {
		console.error('setPlaylistOrderSequence error', err);
		toast.error(err.response?.data?.error || 'Order update failed');
		// Optionally re-fetch playlists from server to resync state here
		// const refreshed = await axios.get(`${process.env.REACT_APP_API_URL}/playlist/getPlayListData`);
		// setPlaylists(refreshed.data);
	  } finally {
		setPlaylistsSequenceStatus(true); // re-enable UI — true shows playlist images
	  }
	};

/* 	const setPlaylistOrderSequence = async (index, order) => {
		setPlaylistsSequenceStatus(true);
		var replaceWith = order == 'up' ? (index == 0 ? 0 : index - 1) : (index == playlists.length -1 ? index :  index + 1);
		let newPlaylists = [...playlists]; // Create a copy of the playlists array
		[newPlaylists[index], newPlaylists[replaceWith]] = [newPlaylists[replaceWith], newPlaylists[index]];
		setPlaylists(newPlaylists);

		let temp_arr = {};
		newPlaylists.forEach((playlist, i) => {
			temp_arr[i] = playlist._id;
		});

		await axios.post(process.env.REACT_APP_API_URL + "/playlist/update-order", { data: temp_arr }).then((res) => {
          	toast.success(res.data.title);
			setPlaylistsSequenceStatus(true);
        }).catch((err) => {
          	toast.error(err.data.error);
			setPlaylistsSequenceStatus(true);
        });
	}; */

  //  Save Playlist
  const saveYoutubePalylist = () => {


    var userId = loginId;
    if (currentPlaylist?.users[0]?._id == userId) {
      axios
        .post(process.env.REACT_APP_API_URL + "/playlist/savePlayListData", {
          all_playlist_data: YoutubeTempPlaylist,
          playlist_id: currentPlaylist._id,
          user: "alreday",
          user_id: loginId,
          title: currentPlaylist.title,
        })
        .then((res) => {
          toast.success(res.data.title);
          handleShow('saved_csv');
        })
        .catch((err) => {
          toast.error(err.data.error);
        });
    } else {
      axios
        .post(process.env.REACT_APP_API_URL + "/playlist/savePlayListData", {
          all_playlist_data: YoutubeTempPlaylist,
          playlist_id: currentPlaylist?._id,
          user: "new",
          user_id: loginId,
          title: currentPlaylist?.title,
        })
        .then((res) => {
          toast.success(res.data.title);
          handleShow('saved_csv');
        })
        .catch((err) => {
          toast.error(err.data.error);
        });
    }

  };
  //  Set Embed Code
  const [PlayableStatus, setPlayableStatus] = useState("");

  const [embedInput, setembedInput] = useState("");
  const [embedInputUserMedia, setembedInputUserMedia] = useState("");
//   const addEmbedVideoInTeampPlayList = async() => {
//     var EmbadeCode = document.getElementById("EmbadeCodeInputId").value;
//     if (EmbadeCode == "") {
//       toast.error("Please Enter Video Embed Code");
//       return;
//     }
//     // alert(EmbadeCode);
//     if (EmbadeCode.includes("vimeo.com/")) {
//       var result = EmbadeCode.split("vimeo.com/").pop();

//       await axios
//         .get(
//           vimeo_url+`/videoInfo?video_id=` + result
//         )
//         .then((res) => {
// 			handleClose('past_url');
//           	var newListArray = {
//             title: res.data.name,
//             url: res.data.link,
//             views: 0,
//             likes: res.data.metadata.connections.likes
//               .total,
//             posted_date: res.data.created_time,
//             duration: res.data.duration,
//             keywords: "",
//             channel_name: res.data.user.name,
//             channel_url: res.data.user.link,
//             thumbnail: res.data.pictures.base_link,
//             description: res.data.description,
//             embeded_code: res.data.embed.html,
//             // category: catagrorys[res.data.items[0].snippet.categoryId],
//             location: null,
//             plays_at: null,
//           };
//           setYoutubeTempPlaylist((YoutubeTempPlaylist) => [
//             ...YoutubeTempPlaylist,
//             newListArray,
//           ]);
//         });
// 		handleClose('past_url');
//     }
//     else {
//       // ✅ NEW: Check if input is YouTube <iframe> and extract src URL
// if (EmbadeCode.includes("<iframe")) {
//   const srcMatch = EmbadeCode.match(/src=["']?([^"'\s>]+)["']?/);
//   if (srcMatch && srcMatch[1]) {
//     EmbadeCode = srcMatch[1]; // Use extracted src URL
//   } else {
//     toast.error("Invalid iframe embed code");
//     return;
//   }
// }

//       if (EmbadeCode.includes("https://youtu.be/")) {
//          EmbadeCode = EmbadeCode.replace(
//           "https://youtu.be/",
//           "https://www.youtube.com/watch?v="
//         );
//       }
//       var pattern = new RegExp(
//         "^(https?:\\/\\/)?" + // protocol
//         "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
//         "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
//         "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
//         "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
//         "(\\#[-a-z\\d_]*)?$",
//         "i"
//       ); // fragment locator

//       if (pattern.test(EmbadeCode)) {
//         var videoId_is = "";
//         let UslIs = EmbadeCode;
//         let paramString = UslIs.split("?")[1];
//         let queryString = new URLSearchParams(paramString);
//         for (let pair of queryString.entries()) videoId_is = pair[1];
//         axios
//           .get(
//             `https://www.googleapis.com/youtube/v3/videos?part=snippet%2Cstatus%2CcontentDetails%2Cstatistics&id=` +
//             videoId_is +
//             `&key=` +
//             process.env.REACT_APP_YOUTUBEAPIKEY
//           )
//           .then((res) => {
//             axios
//               .post(
//                 process.env.REACT_APP_API_URL +
//                 "/manageplaylist/findYoutubeValidater",
//                 { videoURL: "https://www.youtube.com/embed/" + videoId_is }
//               )
//               .then((res1) => {
//                 setPlayableStatus(res1.data.status);
//                 if (res1.data.status == "PLAYABLE") {
//                   if (res?.data?.items[0]) {

//                   var newListArray = {
//                     title: res.data.items[0].snippet.title,
//                     url: `https://www.youtube.com/watch?v=` + res.data.items[0].id,
//                     views: res.data.items[0].statistics.viewCount,
//                     likes: res.data.items[0].statistics.likeCount,
//                     posted_date: res.data.items[0].snippet.publishedAt,
//                     duration: moment
//                       .duration(res.data.items[0].contentDetails.duration)
//                       .asSeconds(),
//                     keywords: "",
//                     channel_name: res.data.items[0].snippet.channelTitle,
//                     channel_url:
//                       `https://www.youtube.com/channel/` +
//                       res.data.items[0].snippet.channelId,
//                     thumbnail: res.data.items[0].snippet.thumbnails.high.url,
//                     description: res.data.items[0].snippet.description,
//                     embeded_code: res.data.items[0].id,
//                     // category: catagrorys[res.data.items[0].snippet.categoryId],
//                     location: null,
//                     plays_at: null,
//                   };
//                 }
//                   setYoutubeTempPlaylist((YoutubeTempPlaylist) => [
//                     ...YoutubeTempPlaylist,
//                     newListArray,
//                   ]);
//                   setembedInput("");
//                 } else {
//                   toast.error("This Video is Not Playable due to security reason");
//                   setembedInput("");
//                 }
//               });

//           });
//       } else {
//         setembedInput("");
//         toast.error("Invalid Video Url");
//       }
//     }
//     setembedInput("");

//   };
// ... other imports and code above

// Utility function to extract video ID from various YouTube URLs
function getVideoIdFromYoutubeUrl(url) {
  try {
    let urlObj = new URL(url);
    // Try to get the 'v' parameter first (standard YouTube share URL)
    let videoId = urlObj.searchParams.get('v');
    // If not found, check for embed-type URL (e.g., /embed/VIDEOID)
    if (!videoId && url.includes('/embed/')) {
      let match = url.match(/\/embed\/([^?]+)/);
      videoId = match ? match[1] : null;
    }
    // If not found, check for youtu.be short links
    if (!videoId && urlObj.hostname === 'youtu.be') {
      videoId = urlObj.pathname.slice(1);
    }
    return videoId;
  } catch (e) {
    return null;
  }
}

// ── Universal URL resolver (all 14+ sources via /api/resolve-url) ──
const addEmbedVideoInTeampPlayList = async () => {
  var inputVal = document.getElementById("EmbadeCodeInputId").value.trim();
  if (!inputVal) {
    toast.error("Please paste a video URL");
    return;
  }

  // Extract URL from share text (e.g. Bilibili: "title https://bilibili.com/...")
  const urlInText = inputVal.match(/(https?:\/\/[^\s]+)/);
  if (urlInText && inputVal.length > urlInText[0].length + 5) {
    inputVal = urlInText[0];
  }

  // If user pasted an iframe, extract the src URL from it
  if (inputVal.includes("<iframe")) {
    const srcMatch = inputVal.match(/src=["']?([^"'\s>]+)["']?/);
    if (srcMatch && srcMatch[1]) {
      inputVal = srcMatch[1];
    } else {
      toast.error("Could not extract URL from video URL");
      return;
    }
  }

  // Normalize youtu.be short links
  if (inputVal.includes("youtu.be/")) {
    const ytMatch = inputVal.match(/youtu\.be\/([\w-]{11})/);
    if (ytMatch) inputVal = "https://www.youtube.com/watch?v=" + ytMatch[1];
  }

  // Basic URL validation
  try { new URL(inputVal); } catch(e) {
    toast.error("Please paste a valid video URL");
    setembedInput("");
    return;
  }

  // C-SPAN: server returns 403, no video URL extractable — extension only
  if (/c-span\.org/i.test(inputVal)) {
    toast.error("C-SPAN is not available via URL paste. Please use the Curator Extension.");
    setembedInput("");
    return;
  }

  toast.info("Resolving video...");

  try {
    const resp = await fetch(process.env.REACT_APP_API_URL + "/api/resolve-url", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ url: inputVal })
    });
    const d = await resp.json();

    if (!d.ok) {
      toast.error(d.error || "Could not resolve URL");
      setembedInput("");
      return;
    }

    // Build video object matching PM data shape
    const slug = inputVal.split("/").filter(Boolean).pop() || "Video";
    const fallbackTitle = slug.split("?")[0].replace(/[-_]/g, " ").substring(0, 60);

    var newListArray = {
      title: d.title || fallbackTitle,
      url: inputVal,
      views: d.views || 0,
      likes: d.likes || 0,
      posted_date: d.posted_date || "",
      duration: d.duration_seconds || 0,
      keywords: "",
      channel_name: d.channel_name || "",
      channel_url: d.channel_url || "",
      thumbnail: d.thumbnail || (d.source_platform === "youtube" ? "https://img.youtube.com/vi/" + (d.video_id || "default") + "/hqdefault.jpg" : ""),
      description: (d.description || "").substring(0, 500),
      embeded_code: d.embeded_code || d.embed_url || "",
      source_platform: d.source_platform || "unknown",
      _embedUrl: d.embed_url || "",
      location: null,
      plays_at: null,
    };

    setYoutubeTempPlaylist((prev) => [...prev, newListArray]);
    setembedInput("");
    handleClose("past_url");
    toast.success("Added: " + (d.title || fallbackTitle).substring(0, 40));

  } catch (err) {
    console.error("resolve-url error:", err);
    // Graceful fallback — add with URL-derived title
    const slug = inputVal.split("/").filter(Boolean).pop() || "Video";
    const fallbackTitle = slug.split("?")[0].replace(/[-_]/g, " ").substring(0, 60);
    var newListArray = {
      title: fallbackTitle,
      url: inputVal,
      views: 0, likes: 0, posted_date: "",
      duration: 0, keywords: "",
      channel_name: "", channel_url: "",
      thumbnail: "data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27320%27 height=%27180%27%3E%3Crect fill=%27%23222%27 width=%27320%27 height=%27180%27/%3E%3Ctext x=%27160%27 y=%2790%27 fill=%27%23666%27 font-size=%2730%27 text-anchor=%27middle%27 dominant-baseline=%27middle%27%3E%F0%9F%8E%AC%3C/text%3E%3C/svg%3E",
      description: "",
      embeded_code: "",
      source_platform: "unknown",
      _embedUrl: "",
      location: null, plays_at: null,
    };
    setYoutubeTempPlaylist((prev) => [...prev, newListArray]);
    setembedInput("");
    handleClose("past_url");
    toast.success("Added (metadata unavailable)");
  }
};
    const [youtubePlay, setYoutubePlay] = useState(false);
  const [youtubePlayUrl, setYoutubePlayUrl] = useState("");
  const [youtubePlayThumb, setYoutubePlayThumb] = useState("");

  // End

  //  Vimeo api
  const [vimeoSearchLoader, setVimeoSearchLoader] = useState(false);
  const [youtubeSearchLoader, setYoutubeSearchLoader] = useState(false);
  const [searchVimeoKeyword, setSearchVimeoKeyword] = useState("");
  const [videoAllSearchData, setVideoAllSearchData] = useState([]);
  const [videoAllSearchDataDown, setVideoAllSearchDataDown] = useState([]);
  const [vimeoPageNumber, setvimeoPageNumber] = useState(1);
  const [vimeoPageNumberDown, setvimeoPageNumberDown] = useState(1);
  const searchVimeoVideo = (data) => {
    // e.preventDefault();
    if (data.searchText == "") {
      alert("Please Enter Search Value");
    } else {

        var vpagenumber = 1;
        if (searchSection == 'up') {
            setYoutubeSearchLoader(true)
            setshowSearchVideo(false);
            vpagenumber = vimeoPageNumber;
        } else {
            setVimeoSearchLoader(true);
            vpagenumber = vimeoPageNumberDown;
        }
      axios
        .get(
          vimeo_url+"/search?q=" +
          data.searchText +
          "&page=" + vpagenumber + "&perPage=10"
        )
        .then((res) => {
            if (res.data.length != 0){
                if (searchSection == 'up') {
                    setYoutubeSearchLoader(false)
                } else {
                    setVimeoSearchLoader(false);
                }
            }
            if (searchSection == 'up') {
                setVideoAllSearchData(res.data.data);
                setYoutubeSearchLoader(false)
            } else {
                setVideoAllSearchDataDown(res.data.data);
                setVimeoSearchLoader(false);
            }
        })
        .catch((error) => {
          if (error.response?.status === 429) {
          } else {
          //  console.error('API error:', error);
          }
       
        });
    }
  };

  // NEXT Vimeo Video
  const [tempVimeoSearchKeyword, setTempVimeoSearchKeyword] = useState("");
  const [tempVimeoSearchKeywordNum, setTempVimeoSearchKeywordNum] = useState(0);
	const [isLogin, setIsLogin] = useState(sessionStorage.getItem("userDetails"));
	const [loginId, setLoginId] = useState('');

	// Listen for WP auth completing (fixes race condition)
	useEffect(() => {
		const handleAuthUpdate = () => {
			const ud = sessionStorage.getItem("userDetails");
			setIsLogin(ud);
			if (ud) {
				try {
					const parsed = JSON.parse(ud);
					if (parsed && parsed.user_id) {
						setLoginId(parsed.user_id);
					}
				} catch(e) {}
			} else {
				setLoginId('');
			}
		};
		window.addEventListener("tvadi-auth-update", handleAuthUpdate);
		// Also check on mount in case auth already completed
		handleAuthUpdate();
		return () => window.removeEventListener("tvadi-auth-update", handleAuthUpdate);
	}, []);

  //  Randomize playlist
  // const randomizePlaylist = () => {
  //   var randomArray = YoutubeTempPlaylist;
  //   let currentIndex = YoutubeTempPlaylist.length,
  //     randomIndex;
  //   while (currentIndex != 0) {
  //     randomIndex = Math.floor(Math.random() * currentIndex);
  //     currentIndex--;
  //     [randomArray[currentIndex], randomArray[randomIndex]] = [
  //       randomArray[randomIndex],
  //       randomArray[currentIndex],
  //     ];
  //   }
  //   setYoutubeTempPlaylist(randomArray);
  // };
  const randomizePlaylist = () => {
    let randomArray = [...YoutubeTempPlaylist];
    let currentIndex = randomArray.length, randomIndex;
  
    // Shuffling the playlist
    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      [randomArray[currentIndex], randomArray[randomIndex]] = [
        randomArray[randomIndex], randomArray[currentIndex],
      ];
    }
  
    // Set the shuffled playlist
    setYoutubeTempPlaylist(randomArray);
  
    // Pick a random index to start playing from
    const startIndex = Math.floor(Math.random() * randomArray.length);
    setVideoIndex(startIndex); // Make sure videoIndex is updated
  };
  
  const redirectNorLogin = () => {
    if (isLogin == null) {
      // Never navigate away: there is no standalone /login route here and
      // navigating blanks the view inside an embed / PWA. Just prompt to log in.
      toast.error("Please Login First !");
    }
  };
  const [newVideoVideo, setnewVideoVideo] = useState([]);
  const [uploadIntroLoader, setUploadInroLoader] = useState(false);

  const onFormSubmit = async (e) => {
    e.preventDefault();
    if (newVideoVideo.size > 70000000) {
      toast.warning("File size too large");
      return;
    }
    setUploadInroLoader(true);
    const formdata = new FormData();
    formdata.append("avtarvid", newVideoVideo);
	handleClose('user_media');
    await axios
      .post(
        process.env.REACT_APP_API_URL +
        "/manageplaylist/upload?" +
        currentPlaylist._id,
        formdata,
        { user: loginId }
      )
      .then((res) => {
        if (res.data.length != 0) setUploadInroLoader(false);
        toast.success("Video Added Successfully");
        // window.location.reload();
      })
      .catch((err) => {
        if (
          err.response &&
          err.response.data &&
          err.response.data.errorMessage
        ) {
          setUploadInroLoader(false);
          toast.error(err.response.data.errorMessage);
        }
      });
  };

  	function extractVimeoVideoId(url) {
		const regex = /https:\/\/player\.vimeo\.com\/video\/(\d+)/;
		const match = url.match(regex);
		return match ? match[1] : null;
	}

  // const onFormSubmitUserMedia = async (e) => {
	// 	e.preventDefault();
	// 	setUploadInroLoader(true);
	// 	handleClose('user_media_url');	
	// 	if (embedInputUserMedia == "") {
	// 		toast.error("Please Enter Video Embed Code");
	// 		return;
	// 	}

	// if (embedInputUserMedia.includes("vimeo.com/")) {
	// 	extractVimeoVideoId(embedInputUserMedia)
  //     await axios.get(vimeo_url+`/videoInfo?video_id=` + embedInputUserMedia.match(/vimeo\.com\/(\d+)/)[1]).then((res) => {
	// 		var newListArray = {
	// 			title: res.data.name,
	// 			url: res.data.link,
	// 			views: 0,
	// 			likes: res.data.metadata.connections.likes
	// 			.total,
	// 			posted_date: res.data.created_time,
	// 			duration: res.data.duration,
	// 			keywords: "",
	// 			channel_name: res.data.user.name,
	// 			channel_url: res.data.user.link,
	// 			thumbnail: res.data.pictures.base_link,
	// 			description: res.data.description,
	// 			embeded_code: res.data.embed.html,
	// 			location: null,
	// 			plays_at: null,
	// 		};
	// 		saveUserMediaData(newListArray);
	// 		setembedInput("");
	// 		getUserMedia(loginId);
	// 		setUploadInroLoader(false);
  //       });
  //   }
  //   else {
	// var EmbadeCode = embedInputUserMedia;
  //     if (embedInputUserMedia.includes("https://youtu.be/")) {
  //       EmbadeCode = embedInputUserMedia.replace(
  //         "https://youtu.be/",
  //         "https://www.youtube.com/watch?v="
  //       );
  //     }
  //     var pattern = new RegExp(
  //       "^(https?:\\/\\/)?" +
  //       "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
  //       "((\\d{1,3}\\.){3}\\d{1,3}))" +
  //       "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
  //       "(\\?[;&a-z\\d%_.~+=-]*)?" +
  //       "(\\#[-a-z\\d_]*)?$",
  //       "i"
  //     );

  //     if (pattern.test(EmbadeCode)) {
  //       var videoId_is = "";
  //       let UslIs = EmbadeCode;
  //       let paramString = UslIs.split("?")[1];
  //       let queryString = new URLSearchParams(paramString);
  //       for (let pair of queryString.entries()) videoId_is = pair[1];
  //       await axios
  //         .get(
  //           `https://www.googleapis.com/youtube/v3/videos?part=snippet%2Cstatus%2CcontentDetails%2Cstatistics&id=` +
  //           videoId_is +
  //           `&key=` +
  //           process.env.REACT_APP_YOUTUBEAPIKEY
  //         )
  //         .then((res) => {
  //           axios
  //             .post(
  //               process.env.REACT_APP_API_URL +
  //               "/manageplaylist/findYoutubeValidater",
  //               { videoURL: "https://www.youtube.com/embed/" + videoId_is }
  //             )
  //             .then((res1) => {
  //               setPlayableStatus(res1.data.status);
  //               if (res1.data.status == "PLAYABLE") {
	// 				var newListArray = {
	// 					title: res.data.items[0].snippet?.title,
	// 					url: `https://www.youtube.com/watch?v=` + res.data.items[0].id,
	// 					views: res.data.items[0].statistics.viewCount,
	// 					likes: res.data.items[0].statistics.likeCount,
	// 					posted_date: res.data.items[0].snippet.publishedAt,
	// 					duration: moment
	// 					.duration(res.data.items[0].contentDetails.duration)
	// 					.asSeconds(),
	// 					keywords: "",
	// 					channel_name: res.data.items[0].snippet.channelTitle,
	// 					channel_url:
	// 					`https://www.youtube.com/channel/` +
	// 					res.data.items[0].snippet.channelId,
	// 					thumbnail: res.data.items[0].snippet.thumbnails.high.url,
	// 					description: res.data.items[0].snippet.description,
	// 					embeded_code : '<iframe width="560" height="315" src="https://www.youtube.com/embed/'+res.data.items[0].id+'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
	// 					location: null,
	// 					plays_at: null,
	// 				};
	// 			   	saveUserMediaData(newListArray);
	// 				getUserMedia(loginId);
	// 				setUploadInroLoader(false);
  //                 	setembedInput("");
  //               } else {
  //                 	toast.error("This Video is Not Playable due to security reason");
  //                 	setembedInput("");
	// 				setUploadInroLoader(false);
  //               }
  //             });

  //         });
  //     } else {
  //       setembedInput("");
  //       toast.error("Invalid Video Url");
	// 	getUserMedia(loginId);
	// 	setUploadInroLoader(false);
  //     }
  //   }
  // };

const onFormSubmitUserMedia = async (e) => {
  e.preventDefault();
  setUploadInroLoader(true);
  handleClose('user_media_url');
  if (embedInputUserMedia == "") {
    toast.error("Please Try A Shareable Video URL");
    setUploadInroLoader(false);
    return;
  }

  if (embedInputUserMedia.includes("vimeo.com/")) {
    extractVimeoVideoId(embedInputUserMedia)
    await axios.get(vimeo_url + `/videoInfo?video_id=` + embedInputUserMedia.match(/vimeo\.com\/(\d+)/)[1]).then((res) => {
      var newListArray = {
        title: res.data.name,
        url: res.data.link,
        views: 0,
        likes: res.data.metadata.connections.likes.total,
        posted_date: res.data.created_time,
        duration: res.data.duration,
        keywords: "",
        channel_name: res.data.user.name,
        channel_url: res.data.user.link,
        thumbnail: res.data.pictures.base_link,
        description: res.data.description,
        embeded_code: res.data.embed.html,
        location: null,
        plays_at: null,
      };
      saveUserMediaData(newListArray);
      setembedInput("");
      getUserMedia(loginId);
      setUploadInroLoader(false);
      // toast.success("Successfully Added");
    }).catch(() => {
      setUploadInroLoader(false);
      toast.error("Please Try A Shareable Video URL");
    });
  }
  else {
    var EmbadeCode = embedInputUserMedia;
    if (embedInputUserMedia.includes("https://youtu.be/")) {
      EmbadeCode = embedInputUserMedia.replace(
        "https://youtu.be/",
        "https://www.youtube.com/watch?v="
      );
    }
    var pattern = new RegExp(
      "^(https?:\\/\\/)?" +
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
      "((\\d{1,3}\\.){3}\\d{1,3}))" +
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
      "(\\?[;&a-z\\d%_.~+=-]*)?" +
      "(\\#[-a-z\\d_]*)?$",
      "i"
    );

    if (pattern.test(EmbadeCode)) {
      var videoId_is = getVideoIdFromYoutubeUrl(EmbadeCode);
      if (!videoId_is) {
        setembedInput("");
        toast.error("Please Try A Shareable Video URL");
        getUserMedia(loginId);
        setUploadInroLoader(false);
        return;
      }
      await axios
        .get(
          `https://www.googleapis.com/youtube/v3/videos?part=snippet%2Cstatus%2CcontentDetails%2Cstatistics&id=` +
          videoId_is +
          `&key=` +
          process.env.REACT_APP_YOUTUBEAPIKEY
        )
        .then((res) => {
          axios
            .post(
              process.env.REACT_APP_API_URL +
              "/manageplaylist/findYoutubeValidater",
              { videoURL: "https://www.youtube.com/embed/" + videoId_is }
            )
            .then((res1) => {
              setPlayableStatus(res1.data.status);
              if (res1.data.status == "PLAYABLE") {
                var newListArray = {
                  title: res.data.items[0].snippet?.title,
                  url: `https://www.youtube.com/watch?v=` + res.data.items[0].id,
                  views: res.data.items[0].statistics.viewCount,
                  likes: res.data.items[0].statistics.likeCount,
                  posted_date: res.data.items[0].snippet.publishedAt,
                  duration: moment
                    .duration(res.data.items[0].contentDetails.duration)
                    .asSeconds(),
                  keywords: "",
                  channel_name: res.data.items[0].snippet.channelTitle,
                  channel_url:
                    `https://www.youtube.com/channel/` +
                    res.data.items[0].snippet.channelId,
                  thumbnail: res.data.items[0].snippet.thumbnails.high.url,
                  description: res.data.items[0].snippet.description,
                  embeded_code:
                    '<iframe width="560" height="315" src="https://www.youtube.com/embed/' +
                    res.data.items[0].id +
                    '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
                  location: null,
                  plays_at: null,
                };
                saveUserMediaData(newListArray);
                getUserMedia(loginId);
                setUploadInroLoader(false);
                setembedInput("");
                // toast.success("Successfully Added");
              } else {
                toast.error("This Video is Not Playable due to security reason");
                setembedInput("");
                setUploadInroLoader(false);
              }
            }).catch(() => {
              setembedInput("");
              toast.error("Please Try A Shareable Video URL");
              setUploadInroLoader(false);
            });

        }).catch(() => {
          setembedInput("");
          toast.error("Please Try A Shareable Video URL");
          setUploadInroLoader(false);
        });
    } else {
      setembedInput("");
      toast.error("Please Try A Shareable Video URL");
      getUserMedia(loginId);
      setUploadInroLoader(false);
    }
  }
};
  const saveUserMediaData = async (data) => {
	if (data.title) {
		data.user_id = loginId;
		await axios.post(
			process.env.REACT_APP_API_URL +
			"/playlist/saveUsermedia",
			{videoData:data},
			{ user: loginId }
		)
		.then((res) => {
			if (res.data.length != 0) setUploadInroLoader(false);
			setembedInputUserMedia('');
			toast.success("Video Added Successfully");
		})
		.catch((err) => {
			if ( err.response.data.errorMessage ) {
				setUploadInroLoader(false);
				toast.error(err.response.data.errorMessage);
			}
		});
	}
  }

  const [socialMediaMenu, setSocialMediaMenu] = useState(false);

  const style = {
    background: "transparent",
    borderRadius: 3,
    border: 0,
    color: "white",
  };
  // copy Embed Code
  const [copySuccess, setCopySuccess] = useState("");
  const textAreaRef = useRef(null);
  const textAreaRef1 = useRef(null);
  const embedCodeModal = useRef(null);
  const [embedCode, setEmbedCode] = useState(false);
  function copyToClipboard(e) {
	var datatype = e.target.attributes['data-type'].value;
	if (datatype == 'textAreaRef') {
	    textAreaRef.current.select();
	} else if(datatype == 'embedCodeModal') {
		embedCodeModal.current.select();
	} else {
	    textAreaRef1.current.select();
	}
    document.execCommand("copy");
    e.target.focus();
    setCopySuccess("Copied!");
  }
  const EmptyCopy = () => {
    setCopySuccess("");
  };

  const DeleteIntro = (id, location) => {
    swal({
      title: "Are you sure?",
      text: "This media will be permanently deleted.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
      className: "dark-swal",
    }).then((willDelete) => {
      if (willDelete) {
        const CurrentplayListId = id;
        const CurrentIntroLocation = location;
        axios
          .post(process.env.REACT_APP_API_URL + "/manageplaylist/add", {
            opration: "deleteIntro",
            currentplaylistid: CurrentplayListId,
            fileLocation: CurrentIntroLocation,
          })
          .then((res) => {
            toast.success("Media Removed", {});
            window.location.reload();
          })
          .catch((err) => {
            if (err.response && err.response.data && err.response.data.errorMessage)
              toast.error(err.response.data.errorMessage);
          });
      }
    });
  };
  const [searchTab, setsearchTab] = useState("all");
  const [searchTabDown, setsearchTabDown] = useState("all");

  // Auto-search when source tab changes (if search field has text)
  const searchTabInitRef = useRef(true);
  useEffect(() => {
    if (searchTabInitRef.current) { searchTabInitRef.current = false; return; }
    const form = formRef.current;
    if (form && form.elements.youtubesearch && form.elements.youtubesearch.value.trim()) {
      setsearchSection('up');
      setTimeout(() => searchVideos(), 50);
    } else {
      SetallYoutubeSearchVideoData([]);
      setVideoAllSearchData([]);
    }
  }, [searchTab]);
  const [searchSection, setsearchSection] = useState("up");
  const [IntroVideoArr, setIntroVideoArr] = useState([]);

  const GetViews = (playlist) => {
    const totalViews = playlist.videos.reduce((acc, video) => acc + (parseInt(video.views) || 0), 0);
    return formatViews(totalViews,playlist);
  }

  useEffect(() => {
    var arr = [];
    playlists?.forEach((element, index) => {
      if (element.introVideo != null) {
        arr.push(element);
        setIntroVideoArr(arr);
      }
    });
  }, [])

  const columns = [
    {
      id: 1,
      name: "",
      selector: (row) => (<><div className="mt-1 -100"><video height={100} src={"asset/introvideo/" +
        row.introVideo} alt="Not Found" width={200} /></div></>),
      sortable: true,
      reorder: true,
    },
    {
      id: 2,
      name: "FILE NAME",
      selector: (row) => (<>{row.introVideo.substring(row.introVideo.indexOf('_') + 1)}</>),
      sortable: true,
      reorder: true,
    },
    {
      id: 3,
      name: "UPLOAD DATE",
      selector: (row) => (<>{moment(row.updatedAt).format("MM/DD/YYYY")}</>),
      sortable: true,
      reorder: true,
    },
    {
      id: 4,
      name: "",
      selector: (row) => (
        <>
          <div className="row">
            <div onClick={redirectNorLogin} className="col mb-2">
              <button
                onClick={() =>
                  setYoutubeDatainState(
                    row.introVideo.substring(row.introVideo.indexOf('_') + 1),
                    "asset/introvideo/" +
                    row.introVideo,
                    null,
                    null,
                    moment(row.createdAt).format("MM/DD/YYYY"),
                    "0",
                    null,
                    row.users[0].username,
                    null,
                    "asset/introvideo/" +
                    row.introVideo,
                    row.introVideo,
                    null,
                    null,
                    null
                  )
                }
                className="todayList  "
                style={{ width: "140px" }}
              >
                <span style={{ color: "white", fontSize: "1rem" }}>ADD</span>
              </button>
            </div>
            <div onClick={redirectNorLogin} className="col mb-2">
              <button
                onClick={() => {
                  DeleteIntro(row._id, row.introVideo);
                }}
                className="todayList  "
                style={{ width: "140px" }}
              >
                <span style={{ color: "white", fontSize: "1rem" }}>DELETE</span>
              </button>
            </div>
          </div>
        </>
      ),
      sortable: true,
      reorder: true,
    },

  ];

  return (
    <>
      	<Modal show={show.embed_code} onHide={() => {handleClose('embed_code');}}>
			<Modal.Header closeButton>
				<Modal.Title>Embed Code</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div>
					{document.queryCommandSupported("copy") && (
						<div>
						{" "}
						<button className="btn btn-dark" data-type="textAreaRef1" onClick={copyToClipboard}>
							Copy
						</button>{" "}
						{copySuccess}
						</div>
					)}
					{currentPlaylist ? (
						<form>
						<textarea
							className="embedTextArea"
							ref={textAreaRef1}
							value={
							"<iframe width='560' height='315' src='"+reactAppUrl+"/playlist?id=" +
							currentPlaylist._id +
							"' title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen style='position:absolute;top:0;left:0;width:100%;height:119%;'></iframe>"
							}
						/>
						</form>
					) : (
						""
					)}
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button
				onClick={() => { handleClose('embed_code'); EmptyCopy();}}
				type="button"
				className="btn btn-secondary"
				data-bs-dismiss="modal"
				>
				Close
				</button>
			</Modal.Footer>
		</Modal>

		<Modal show={show.embed_code_modal} onHide={() => {handleClose('embed_code_modal');}}>
			<Modal.Header closeButton>
				<Modal.Title>Embed Code</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div>
					{document.queryCommandSupported("copy") && (
						<div>
						{" "}
						<button className="btn btn-dark" data-type="embedCodeModal" onClick={copyToClipboard}>
							Copy 
						</button>{" "}
						{copySuccess}
						</div>
					)}
					{currentPlaylist ? (
						<form>
						<textarea
							className="embedTextArea"
							ref={embedCodeModal}
							value={embedCode}
						/>
						</form>
					) : (
						""
					)}
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button
				onClick={() => { handleClose('embed_code_modal'); EmptyCopy();}}
				type="button"
				className="btn btn-secondary"
				data-bs-dismiss="modal"
				>
				Close
				</button>
			</Modal.Footer>
		</Modal>
      <div
        className="row todayList mp-0 ww"
        style={{ borderBottom: "none", borderLeft: "none" }}

      >
        {/* FirsT Section  */}
        <div className="col-12 col-lg-3 col-sm-12 col-xs-12 order-lg-1 order-sm-second p-0 md-none">
          <div className="borderRadius todayList p-0 overflow-hidden">
            <div className="row" style={{ padding: ".5rem 1rem 0" }}>
              <div className="col-6">
                <div className=" todayList" style={{ borderRadius: "2px" }}>
                  <button
                    onClick={() => {handleShow('new_list'); setEditPlaylist(false); setnewplaylistName(''); setnewplaylistDescription(''); }}
                    style={{ outline: "none !important", margin: "-6px" }}
                    className="btn w-100 p-1 text-white rounded-0 border-0 d-flex pt-0 pb-0 ">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: "17px", height: "17px" }}><path d="M4 6h16"/><path d="M4 10h16"/><path d="M4 14h10"/><line x1="18" y1="14" x2="18" y2="22"/><line x1="14" y1="18" x2="22" y2="18"/></svg>
                    <span  className="m-auto astroSpace" style={{ textTransform: "uppercase", fontSize: "90%", }} > NEW </span>
                  </button>
                </div>
              </div>
				
            </div>
            {/* <hr className="mb-0" style={{ margin: "0.5rem 0", color: "#fff" }} /> */}

            <div className="row m-0 text-white playlist-border bs-0 be-0 mt-2 md-none">
                <div className="pe-0 playlist-title" style={{ fontSize: "10px", textTransform: "uppercase", letterSpacing: "1px", color: "rgba(255,255,255,0.45)", fontWeight: "500", display: "flex", alignItems: "center", padding: "0 10px" }}>TITLE</div>
                <div style={{ width: "80%", padding: ".5rem 0", paddingLeft: ".75rem"}}>
                    {hasOpenedPlaylist && currentPlaylist ?
					<>
					 	{currentPlaylist.title + " playlist"}
						{isLogin != null && currentPlaylist.users && currentPlaylist.users[0] && currentPlaylist.users[0]._id == loginId &&
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="float-end" style={{ width: "22px", height: "22px", cursor: "pointer", opacity: 0.45, marginRight: "8px" }} onClick={() => {setEditPlaylist(true); handleShow('new_list'); setnewplaylistName(currentPlaylist.title); setnewplaylistDescription(currentPlaylist.description)}}><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.1 2.1 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>}
					</>
					: "Untitled Playlist"}
                </div>
             
            </div>
            {/* <hr className="mt-0" style={{ margin: "0.5rem 0", color: "#fff" }} /> */}

            <div className="row m-0 md-none">
              <div
                className="creator_PlaylistPlayer__menu playlistEdit p-0"
                id="tempPlaylist"
              >
                {/* before */}
                 {/* {YoutubeTempPlaylist.length == 0 || JSON.parse(sessionStorage.getItem("userDetails")) != null && currentPlaylist && currentPlaylist.users[0]._id != loginId || isLogin == null ? (
                  <div style={{ padding: "20px 15px", textAlign: "center", opacity: 0.25 }}>
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"24px",height:"24px",stroke:"white",strokeWidth:1.5,fill:"none",display:"inline-block",verticalAlign:"middle",marginRight:"8px"}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
                    <span style={{ color: "white", fontSize: "13px", letterSpacing: "1px" }}>Add video to playlist</span>
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"20px",height:"20px",stroke:"white",strokeWidth:1.5,fill:"none",display:"inline-block",verticalAlign:"middle",marginLeft:"8px"}}><polyline points="13 17 18 12 13 7"/><polyline points="6 17 11 12 6 7"/></svg>
                  </div>
                ) : (
                  <>
                    {YoutubeTempPlaylist.map((val, index) => {
                        if (!val || !val.title || !val.thumbnail) return null;

                      return (
                        <> 
                          <div
                            key={index}
							className={(CurrentPlay != '' && CurrentPlay == getId(val.url) ? 'active_video' : '')+" mainBox"}
                            style={{ position: "relative", cursor: "grab" }}
                            draggable="true"
                            onDragStart={(e) => handleClipDragStart(e, index)}
                            onDragEnd={handleClipDragEnd}
                            onDragOver={handleClipDragOver}
                            onDragLeave={handleClipDragLeave}
                            onDrop={(e) => handleClipDrop(e, index)}
                          >
                            {val?.thumbnail && val?.thumbnail.includes(".mp4") ||val?.thumbnail && val?.thumbnail.includes(".mov") ? (
                              <div
                                className="creator_VideoBadge ps-2"
                                onClick={() => {
                                  playYoutubeTempList(index);
                                  setYoutubePlay(false);
                                }}
                              >
                                <video className="creator_VideoBadge__logo" src={val?.thumbnail}></video>
                                <div
                                  className="creator_VideoBadge__info lcheck"
                                  style={{ padding: "3px" }}
                                >
                                  <div className="info">
                                    <p
                                      style={{
                                        lineHeight: "15px",
                                        fontSize: "10px",
                                        margin: "2px",
                                        color: "#fff",
                                        width: "88%",
                                      }}
                                    >
                                      <l title={val.title} style={{ fontSize: "12px", display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                        {val.title}
                                      </l>
                                      <br />
                                      {val.channel_name} -{" "}
                                      {moment(val.publishTime)
                                        .utc()
                                        .format("MM/DD/YYYY")}
                                      <br />
                                      {moment("2015-01-01")
                                        .startOf("day")
                                        .seconds(val.duration)
                                        .format("H:mm:ss")}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )
                              :
                              (
                                <div
                                  className="creator_VideoBadge ps-2 mb-0"
                                  onClick={() => {
                                    playYoutubeTempList(index);
                                    setYoutubePlay(false);
                                  }}
                                >
                                  <div
                                    className="creator_VideoBadge__logo br-5 overflow-hidden my-2"
                                    style={{ backgroundImage: `url(${val?.thumbnail})` }}
                                  />
                                  <div 
                                    className="creator_VideoBadge__info playlist_video_main lcheck1 pt-0 df"
                                    style={{ padding: "3px" }}
                                  >
                                    <div className="info playlist_video_content_box">
                                      <p
                                        style={{
                                          lineHeight: "15px",
                                          fontSize: "10px",
                                          margin: "2px",
                                          color: "#fff"
                                        }}
										className="mt-0 mm-0 mp-1 playlist_video_content lcheck123"
                                      >
                                        <l title={val?.title} style={{ fontSize: "12px", display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                          {val?.title}
                                        </l>
                                        <br />
										<div className="playlist_ellipsis mb-2">
                                        {val?.description ? (<l title={val?.description}>
                                          {val?.description}
                                        </l>) : ("")}
										</div>

                                        {(val._source || detectSource(val.url)) && (
                                          <div style={{ fontSize: '9px', color: '#aaa', marginBottom: '2px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                            {val._source || detectSource(val.url)}
                                          </div>
                                        )}
                                        
                                     <div style={{ color: 'white' }}>
                                        <div style={{display: 'inline'}}>
											<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"15px",height:"15px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
										</div>

										<div style={{display: 'inline'}}>
											<span style={{fontSize:"15px",opacity:1,margin:"0 3px",color:"rgba(255,255,255,0.6)",fontWeight:"bold"}}>±</span>
										</div>
                                        <div style={{display: 'inline'}}> 
											{
												!val.views || val.views === 0 || val.views === "0" ? "-.-" : val.views > 999 && val.views < 1000000 ? (val.views / 1000).toFixed(1) + "K" : val.views > 1000000 ? (val.views / 1000000).toFixed(1) + "M" : val.views
											}
											</div>
                                        <div className="mme-1" style={{ display: 'inline', float: 'right' }} onClick={() => { if(val.url){ navigator.clipboard.writeText(val.url).then(() => toast.success("Video URL copied!")); } }}>
											<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
										</div>
                                        <div style={{ display: 'inline', float: 'right' }} onClick={() => tempPlayListVideoRemove(index)}>
											<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><circle cx="12" cy="12" r="10"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
										</div>
                                      </div>
                                      </p>
                                    </div>  
                                  </div>
                                </div>)}

                            <div className="clip-card-actions" style={{
                                position: "absolute", top: "0", right: "0", bottom: "0",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                width: "35px", background: "rgba(0,0,0,0.6)",
                                borderLeft: "1px solid rgba(255,255,255,0.15)",
                                cursor: "pointer"
                              }} onClick={() => {
                                try {
                                  playYoutubeTempList(index);
                                  setCurrentPlay(getId(val.url));
                                  setYoutubePlay(false);
                                } catch(e) { console.error('Play error:', e); }
                              }}>
                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"16px",height:"16px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><rect x="2" y="2" width="20" height="20" rx="4" ry="4"/><polygon points="10 8 16 12 10 16 10 8" style={{fill:"rgba(255,255,255,0.8)",stroke:"none"}}/></svg>
                              </div>
                          </div>
                        </>
                      );
                    })}
                  </>
                )} */}
                {/* before */}
               {(YoutubeTempPlaylist.length === 0 && (!currentPlaylist?.videos || currentPlaylist?.videos?.length === 0)) ||
 JSON.parse(sessionStorage.getItem("userDetails")) != null &&
 currentPlaylist &&
 currentPlaylist.users[0]._id !== loginId ||
 isLogin == null ? (
  <div style={{ padding: "20px 15px", textAlign: "center", opacity: 0.25 }}>
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"24px",height:"24px",stroke:"white",strokeWidth:1.5,fill:"none",display:"inline-block",verticalAlign:"middle",marginRight:"8px"}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
    <span style={{ color: "white", fontSize: "13px", letterSpacing: "1px" }}>Add video to playlist</span>
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"20px",height:"20px",stroke:"white",strokeWidth:1.5,fill:"none",display:"inline-block",verticalAlign:"middle",marginLeft:"8px"}}><polyline points="13 17 18 12 13 7"/><polyline points="6 17 11 12 6 7"/></svg>
  </div>
) : (
  <>
    {(YoutubeTempPlaylist.length > 0 ? YoutubeTempPlaylist : (currentPlaylist?.videos || [])).map((val, index) => {
      if (!val || !val.title || !val.thumbnail) return null;

      return (
        <div
          key={index}
          className={(CurrentPlay !== '' && CurrentPlay === getId(val.url) ? 'active_video ' : '') + "mainBox"}
          style={{ position: "relative", cursor: "grab" }}
          draggable="true"
          onDragStart={(e) => handleClipDragStart(e, index)}
          onDragEnd={handleClipDragEnd}
          onDragOver={handleClipDragOver}
          onDragLeave={handleClipDragLeave}
          onDrop={(e) => handleClipDrop(e, index)}
        >
          {(val.thumbnail?.includes(".mp4") || val.thumbnail?.includes(".mov")) ? (
            <div className="creator_VideoBadge ps-2" onClick={() => {
              playYoutubeTempList(index);
              setCurrentPlay(getId(val.url));
              setYoutubePlay(false);
            }}>
              <video className="creator_VideoBadge__logo" src={val.thumbnail}></video>
              <div className="creator_VideoBadge__info lcheck" style={{ padding: "3px" }}>
                <div className="info">
                  <p style={{ lineHeight: "15px", fontSize: "10px", margin: "2px", color: "#fff", width: "88%" }}>
                    <l title={val.title} style={{ fontSize: "12px" }}>
                      {val.title.length <= 30 ? val.title : <marquee scrollamount="3">{val.title}</marquee>}
                    </l><br />
                    {val.channel_name} - {moment(val.posted_date || val.publishTime).utc().format("MM/DD/YYYY")}<br />
                    {moment("2015-01-01").startOf("day").seconds(val.duration).format("H:mm:ss")}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="creator_VideoBadge ps-2 mb-0" onClick={() => {
              playYoutubeTempList(index);
              setCurrentPlay(getId(val.url));
              setYoutubePlay(false);
            }}>
              <div className="creator_VideoBadge__logo br-5 overflow-hidden my-2" style={{ backgroundImage: `url(${val.thumbnail})` }} />
              <div className="creator_VideoBadge__info playlist_video_main lcheck1 pt-0 df" style={{ padding: "3px" }}>
                <div className="info playlist_video_content_box">
                  <p style={{ lineHeight: "15px", fontSize: "10px", margin: "2px", color: "#fff" }} className="mt-0 mm-0 mp-1 playlist_video_content lcheck123">
                    <l title={val.title} style={{ fontSize: "15px" }}>
                      {val.title.length <= 30 ? val.title : <marquee scrollamount="3">{val.title}</marquee>}
                    </l><br />
                    <div className="playlist_ellipsis mb-2">{val.description && <l title={val.description}>{val.description}</l>}</div>
                    <div style={{ color: 'white', display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px' }}>
                      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"13px",height:"13px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                      <span style={{fontSize:"15px",opacity:1,margin:"0 3px",color:"rgba(255,255,255,0.6)",fontWeight:"bold"}}>±</span>
                      <span style={{ fontSize:"11px", color:"rgba(255,255,255,0.6)", opacity:1 }}>{!val.views || val.views === 0 || val.views === "0" ? "-.-" : val.views > 999 && val.views < 1000000 ? (val.views / 1000).toFixed(1) + "K" : val.views > 1000000 ? (val.views / 1000000).toFixed(1) + "M" : val.views}</span>
                      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"13px",height:"13px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
                      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width: "13px", height: "13px", cursor: "pointer", opacity: 0.5,stroke:"currentColor",strokeWidth:1.5,fill:"none"}} onClick={() => tempPlayListVideoRemove(index)} ><circle cx="12" cy="12" r="10"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
                    </div>
                  </p>
                </div>
              </div>
            </div>
          )}
          {/* Play overlay on hover */}
          <div className="clip-play-overlay" onClick={() => {
            try {
              playYoutubeTempList(index);
              setCurrentPlay(getId(val.url));
              setYoutubePlay(false);
            } catch(e) { console.error('Play error:', e); }
          }}>
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polygon points="5,3 19,12 5,21"/></svg>
          </div>
          {/* Reorder controls: up arrow, grab handle, down arrow */}
          <div className="clip-card-grip" draggable="false">
            <div className="clip-arrow-up" draggable="false" onClick={(e) => { e.stopPropagation(); tempPlayListVideoTop(index); }}>
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"12px",height:"12px",stroke:"white",strokeWidth:2,fill:"none"}}><polyline points="18 15 12 9 6 15"/></svg>
            </div>
            <div className="clip-grip-handle" draggable="false">
              <svg viewBox="0 0 12 16" xmlns="http://www.w3.org/2000/svg" stroke="white" strokeWidth="1.5" fill="none" style={{width:"14px",height:"14px"}}>
                <line x1="2" y1="3" x2="10" y2="3"/><line x1="2" y1="6" x2="10" y2="6"/><line x1="2" y1="9" x2="10" y2="9"/><line x1="2" y1="12" x2="10" y2="12"/>
              </svg>
            </div>
            <div className="clip-arrow-down" draggable="false" onClick={(e) => { e.stopPropagation(); tempPlayListVideoDown(index); }}>
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"12px",height:"12px",stroke:"white",strokeWidth:2,fill:"none"}}><polyline points="6 9 12 15 18 9"/></svg>
            </div>
          </div>
        </div>
      );
    })}
  </>
)}


              </div>
            </div>
            <div style={{ borderTop: "1px solid rgba(255,255,255,0.15)", margin: "0" }}></div>
            <div className="row px-2 pt-1 mpb-2 md-none">
              <div className="col-4">
                <div className=" todayList buttonPadding mp-0">
                  {isLogin !== null ? (
                    <button
                      onClick={saveYoutubePalylist}
                      className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 d"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: "16px", height: "16px" }}><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
                      <span
                        className="m-auto text-white astroSpace text-hide"
                        style={{
                          textTransform: "uppercase",
                          fontSize: "90%",
                        }}
                      >
                        Save
                      </span>
                    </button>
                  ) : (
                    <button
                      onClick={redirectNorLogin}
                      className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 1"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: "16px", height: "16px" }}><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
                      <span
                        className="m-auto text-white astroSpace text-hide"
                        style={{
                          textTransform: "uppercase",
                          fontSize: "90%",
                        }}
                      >
                        Save
                      </span>
                    </button>
                  )}
                </div>
              </div>
              <div className="col-4 p-0">
                <div className=" todayList buttonPadding mp-0">
                  {isLogin !== null ? (
                    <button
                      onClick={() => {handleShow('past_url');}}
                      className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 2"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: "16px", height: "16px" }}><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
                      <span
                        className="m-auto text-white astroSpace"
                        style={{
                          textTransform: "uppercase",
                          fontSize: "90%",
                        }}
                      >
                        + URL
                      </span>
                    </button>
                  ) : (
                    <button
                      onClick={redirectNorLogin}
                      className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 4"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: "16px", height: "16px" }}><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
                      <span
                        className="m-auto text-white astroSpace"
                        style={{
                          textTransform: "uppercase",
                          fontSize: "90%",
                        }}
                      >
                        + URL
                      </span>
                    </button>
                  )}
                </div>
              </div>
              <div className="col-4">
                <div className=" todayList buttonPadding mp-0">
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#sharePlaylist"
                    onClick={() => {
                       setsharedPlaylist(currentPlaylist);
                       EmptyCopy();
                       handleShow('share_list');
                        {
                            socialMediaMenu
                            ? setSocialMediaMenu(false)
                            : setSocialMediaMenu(true);
                        }
                    }}
                    className="btn w-100 p-1  rounded-0 border-0 d-flex p-0"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: "16px", height: "16px" }}><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
                    <span
                      className="m-auto text-white astroSpace text-hide"
                      style={{
                        textTransform: "uppercase",
                        fontSize: "90%",
                      }}
                    >
                      Share{" "}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End First Section */}

        {/* Second Section */}

        <div className="col-12 col-lg-6 col-sm-12 col-xs-12 order-lg-2 order-sm-first mmt-0 mp-0 mmb-3">
          <div className="borderRadius todayList mp-0 m-b-radius-0 m-border-0 landscapeView">
            <div className="creator_PlaylistPlayer__player-wrapper m-b-radius-0 mmt-0" data-type={youtubePlay} data-length={YoutubeTempPlaylist.length} data-youtubePlayUrl={youtubePlayUrl} >
              {youtubePlay ? (
                <MultiSourcePreview
                  url={youtubePlayUrl}
                  thumbnail={youtubePlayThumb || ""}
                  title="Preview"
                  playing={true}
                  onEnded={onYoutubeVideoEndend}
                  showBadge={true}
                  className="creator_PlaylistPlayer__player"
                />
              ) : YoutubeTempPlaylist.length == 0 ? (
                <div className="playerWrapperEmpty end-0 start-0 top-0 bottom-0 text-center p-0">
                  <img
                    src={require("../asset/PlaylistMakerImages/SearchClipsGif.gif")}
                    className="img-fluid h-100 m-auto"
                    alt=""
                  />
                </div>
              ) : (
                <MultiSourcePreview
                  url={YoutubeTempPlaylist[videoIndex] ? YoutubeTempPlaylist[videoIndex].url : ""}
                  embedUrl={YoutubeTempPlaylist[videoIndex] ? YoutubeTempPlaylist[videoIndex]._embedUrl : null}
                  embedCode={YoutubeTempPlaylist[videoIndex] ? YoutubeTempPlaylist[videoIndex].embeded_code : null}
                  thumbnail={YoutubeTempPlaylist[videoIndex] ? YoutubeTempPlaylist[videoIndex].thumbnail : null}
                  title={YoutubeTempPlaylist[videoIndex] ? YoutubeTempPlaylist[videoIndex].title : "Video"}
                  playing={true}
                  onEnded={onEnded}
                  showBadge={true}
                  className="creator_PlaylistPlayer__player"
                />
              )}
            </div>
			<div className="m-show mobileSection">
{YoutubeTempPlaylist.length > 0 && !(JSON.parse(sessionStorage.getItem("userDetails")) != null && currentPlaylist && currentPlaylist.users[0]._id != loginId) && isLogin != null && (
				<div className="belowPlayerBox px-2" style={{width:"100%", overflow:"scroll", display:"inline-flex"}}>
					{YoutubeTempPlaylist.length == 0 || JSON.parse(sessionStorage.getItem("userDetails")) != null && currentPlaylist && currentPlaylist.users[0]._id != loginId || isLogin == null ? (
					''
					) : (
					<>
						{YoutubeTempPlaylist.map((val, index) => {
						return (
							<>
							<div key={index} className={(CurrentPlay != '' && CurrentPlay == getId(val.url) ? 'active_video' : '')+" me-1 my-1"}
								style={{ width:"fit-content", cursor: "pointer" }}
							>
								{val?.thumbnail && val?.thumbnail.includes(".mp4") ||val?.thumbnail && val?.thumbnail.includes(".mov") ? (
									<video className="creator_VideoBadge__logo" src={val?.thumbnail}></video>
								)
								:
								(
									<div
									className=""
									onClick={() => {
										playYoutubeTempList(index);
										setYoutubePlay(false);
										setCurrentPlay(getId(val.url));
									}}
									>
									<div
										className="creator_VideoBadge__logo br-5 overflow-hidden"
										style={{ backgroundImage: `url(${val?.thumbnail})` }}
									/>
									</div>)}

								
							</div>
							</>
						);
						})}
					</>
					)}
				</div>
				)}

				<div className="row text-white m-0 py-1 common-border bb-0">
					<div className="col-2 d-flex align-items-center justify-content-start ps-0 pe-0">
							<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
								onClick={() => {
									if (isLogin != null && currentPlaylist && currentPlaylist.users[0]._id == loginId) {
										setEditPlaylist(true);
										handleShow('new_list');
										setnewplaylistName(currentPlaylist.title);
                    // alert("peter");
										toast.error("Added to Playlist.");
									} else {
										toast.error("Please Select Playlist First.");
										handleButtonClick('playlists');
									}
								}}
								style={{width:"24px",height:"24px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,cursor:"pointer"}}
							><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.1 2.1 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
					</div>
					<div className="col-6 ps-0" style={{marginLeft:"-1.25rem"}}>
					<div className="pe-2" 
						style={{ fontSize:"14px"}}>Current Playlist</div>
						<div className="pe-2">{hasOpenedPlaylist && currentPlaylist ? currentPlaylist.title : "Untitled Playlist"}</div>
					</div>
					<div className="col-4 text-end">
						<div className="">
							<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"1px",height:"1px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
							=  {moment("2015-01-01").startOf("day").seconds(playListRunTime).format("H:mm:ss")}
						</div>
						<div>
							<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"18px",height:"18px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
							<span style={{fontSize:"15px",opacity:1,margin:"0 3px",color:"rgba(255,255,255,0.6)",fontWeight:"bold"}}>±</span>
							{totalViews}
							</div>
					</div>
				</div>

				<div className="row text-white m-0 common-border">
					<div className="col-12 d-flex justify-content-between">
						<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
							onClick={() => {handleShow('new_list'); setEditPlaylist(false); setnewplaylistName('');}}
               style={{maxWidth: '30px', height: '40px', cursor: "pointer",stroke:"currentColor",strokeWidth:1.5,fill:"none"}}
						><path d="M4 6h16"/><path d="M4 10h16"/><path d="M4 14h10"/><line x1="18" y1="14" x2="18" y2="22"/><line x1="14" y1="18" x2="22" y2="18"/></svg>
						<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
							onClick={() => {handleShow('past_url');}}
              style={{maxWidth: '30px', height: '40px', cursor: "pointer",stroke:"currentColor",strokeWidth:1.5,fill:"none"}}
						><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
						<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
							onClick={() => {
								if (isLogin !== null) {
									saveYoutubePalylist();
								}
							}}
              style={{maxWidth: '30px', height: '40px', cursor: "pointer",stroke:"currentColor",strokeWidth:1.5,fill:"none"}}
						><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
						<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
							onClick={() => {
								setsharedPlaylist(currentPlaylist);
								EmptyCopy();
								handleShow('share_list');
								{
									socialMediaMenu
									? setSocialMediaMenu(false)
									: setSocialMediaMenu(true);
								}
							}}
              style={{maxWidth: '30px', height: '40px', cursor: "pointer",stroke:"currentColor",strokeWidth:1.5,fill:"none"}}
						><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
						<div className="px-2">
							<label style={{maxWidth: '30px', height: '40px', cursor: "pointer", margin: 0, display: "inline-flex", alignItems: "center"}}>
								<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"30px",height:"40px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65}}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
								<input type="file" accept=".csv" style={{display:"none"}} onChange={(e) => { handleCsvImport(e.target.files[0], () => { e.target.value = ''; }); }} />
							</label>
						</div>
 
						<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
							 onClick={() => {
								{
								if (searchKeyword !== "" && videoIndex != 0 && allYoutubeSearchVideoData[videoIndex - 1] !== undefined) {
									if (allYoutubeSearchVideoData[videoIndex - 1] !== undefined) {
										setYoutubePlay(true);
										setCurrentPlay(allYoutubeSearchVideoData[videoIndex - 1].id
											.videoId);
										setYoutubePlayUrl(
										"https://www.youtube.com/watch?v=" +
										allYoutubeSearchVideoData[videoIndex - 1].id
											.videoId
										);
										setVideoIndex(videoIndex - 1);
									}

									if (videoAllSearchData[videoIndex - 1] !== undefined) {
										setYoutubePlay(true);
										setCurrentPlay(videoAllSearchData[videoIndex - 1].link);
										setYoutubePlayUrl(
										videoAllSearchData[videoIndex - 1].link
										);
										setYoutubePlay(true);
										setYoutubePlayUrl(
										videoAllSearchData[videoIndex - 1].link
										);
										setVideoIndex(videoIndex - 1);
									}
								}
								}
							}}
            style={{maxWidth: '30px', height: '40px', cursor: "pointer",stroke:"currentColor",strokeWidth:1.5,fill:"none"}}
						><polyline points="15 18 9 12 15 6"/></svg>

						<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
							onClick={() => {
								if ((searchKeyword !== "" || searchVimeoKeyword !== "") && allYoutubeSearchVideoData.length) {
									setYoutubeDatainState(
										allYoutubeSearchVideoData[videoIndex].snippet.title,
										"https://www.youtube.com/watch?v=" +
										allYoutubeSearchVideoData[videoIndex].id.videoId,
										allYoutubeSearchVideoData[videoIndex].views,
										allYoutubeSearchVideoData[videoIndex].likes,
										allYoutubeSearchVideoData[videoIndex].snippet
										.publishTime,
										moment
										.duration(
											allYoutubeSearchVideoData[videoIndex].duration
										)
										.asSeconds(),
										(allYoutubeSearchVideoData[videoIndex].tags = null),
										allYoutubeSearchVideoData[videoIndex].snippet
										.channelTitle,
										"https://www.youtube.com/channel/" +
										allYoutubeSearchVideoData[videoIndex].snippet
										.channelId,
										allYoutubeSearchVideoData[videoIndex].snippet
										.thumbnails.high.url,
										allYoutubeSearchVideoData[videoIndex].snippet
										.description,
										'<iframe width="560" height="315" src="https://www.youtube.com/embed/' +
										allYoutubeSearchVideoData[videoIndex].id.videoId +
										'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
										allYoutubeSearchVideoData[videoIndex].category,
										null
									);
								}
								}}
              style={{maxWidth: '30px', height: '40px', cursor: "pointer",stroke:"currentColor",strokeWidth:1.5,fill:"none"}}
						><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
						<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
							onClick={() => {
								if (searchTab == "vimeo") {
									if(searchKeyword !== "" || searchVimeoKeyword !== "") {
										setYoutubePlay(true);
										setVideoIndex(videoIndex + 1);
										setYoutubePlayUrl(videoAllSearchData[videoIndex + 1].link);
									}
								} else if ((searchKeyword !== "" || searchVimeoKeyword !== "") && allYoutubeSearchVideoData[videoIndex + 1] !== undefined) {
									if(allYoutubeSearchVideoData[videoIndex + 1] !== undefined) {
										setYoutubePlay(true);

										setYoutubePlayUrl(
										"https://www.youtube.com/watch?v=" +
										allYoutubeSearchVideoData[videoIndex + 1].id
											.videoId
										);
										setCurrentPlay(getId("https://www.youtube.com/watch?v=" +
										allYoutubeSearchVideoData[videoIndex + 1].id
											.videoId));
										setVideoIndex(videoIndex + 1);
										setYoutubePlay(true);
									}
								}
							}}
              style={{maxWidth: '30px', height: '40px', cursor: "pointer",stroke:"currentColor",strokeWidth:1.5,fill:"none"}}
						><polyline points="9 18 15 12 9 6"/></svg>
					</div>
				</div>
				<div className="sideBar bs-1 be-1">
					<div className="row m-0">
						<div className="col-12 p-0">
							<div className="todayList  buttonPadding border-0 mp-0">
							<form
								// onSubmit={(e) => searchYoutubeVideo(e)}
								ref={formMobRef}
								onSubmit={(e) => searchVideos(e)}
								className="d-flex youtube-search-form"
								style={{width:"100%"}}
								data-section={searchSection}

							>
								<div className="search-box p-2 common-border bt-0 be-0 bb-0" style={{flexShrink:0}}>
									<button type="button" className="border-0 bg-transparent p-0 m-0" onClick={() => {!isMobOpen && setIsMobOpen(true);} }>
										<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"24px",height:"24px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><path d="M4 6h16"/><path d="M4 10h16"/><path d="M4 14h10"/><path d="M16 14l7 4-7 4z"/></svg>
									</button>

								</div>
								<div className="search-box p-2">
									<button type="submit" className="border-0 bg-transparent p-0 m-0">
										<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"24px",height:"24px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
									</button>
								</div>
								<input
								onChange={(e) => {searchTab === 'vimeo' ? setSearchVimeoKeyword(e.target.value) : setSearchKeyword(e.target.value)}}
								type="text"
								placeholder='Search'
								style={{
									outline: "none",
									background: "transparent",
									color: "white",
									border: "transparent",
									fontSize: "13px",
									flexGrow: 1,
									minWidth: 0
								}}
								className="w-100 p-2"
								name="youtubesearch"
								/>

								<div className="search-box p-2 common-border bt-0 be-0 bb-0" style={{flexShrink:0, marginLeft:"auto"}}>
									<button type="button" className="border-0 bg-transparent p-0 m-0" onClick={(e) => { e.preventDefault(); setIsMobWorkspaceOpen(o => !o); setIsMobOpen(false); }}>
										<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"24px",height:"24px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>
									</button>
								</div>
							</form>
							</div>
							<div className="" ref={dropdownMobRef}>
							{isMobOpen &&
								(<div className="p-2"><ul className="CustomDropdown rounded w-100 position-relative m-0" style={{maxHeight:"400px",overflowY:"auto"}}>
									<li className="cursor-pointer w-100" onClick={() => {handleMobSelect(); handleSelect('Search All'); setsearchTab('all'); setsearchSection("up"); handleButtonClick('youtube');}}>
										<a className="" href="#" onClick={(e) => {e.preventDefault();}}>
										<span>Search All</span>
										</a>
									</li>
									<li className="cursor-pointer w-100" onClick={() => {handleMobSelect(); handleSelect('YouTube'); setsearchTab('youtube'); setsearchSection("up"); handleButtonClick('youtube');}}>
										<a className="" href="#" onClick={(e) => {e.preventDefault();}}>
										<span>YouTube</span>
										</a>
									</li>
									<li className="cursor-pointer w-100" onClick={() => {handleMobSelect(); handleSelectDown('Vimeo'); setsearchTabDown('vimeo'); setsearchSection("up"); handleButtonClick('vimeo');}}>
										<a className="" href="#" onClick={(e) => {e.preventDefault();}}>
										<span>Vimeo</span>
										</a>
									</li>
									<li className="cursor-pointer w-100" onClick={() => {handleMobSelect(); handleSelect('Archive.org'); setsearchTab('archiveorg'); setsearchSection("up"); handleButtonClick('youtube');}}>
										<a className="" href="#" onClick={(e) => {e.preventDefault();}}>
										<span>Archive.org</span>
										</a>
									</li>
									<li className="cursor-pointer w-100" onClick={() => {handleMobSelect(); handleSelect('Wikimedia'); setsearchTab('wikimedia'); setsearchSection("up"); handleButtonClick('youtube');}}>
										<a className="" href="#" onClick={(e) => {e.preventDefault();}}>
										<span>Wikimedia</span>
										</a>
									</li>
									<li className="cursor-pointer w-100" onClick={() => {handleMobSelect(); handleSelect('PeerTube'); setsearchTab('peertube'); setsearchSection("up"); handleButtonClick('youtube');}}>
										<a className="" href="#" onClick={(e) => {e.preventDefault();}}>
										<span>PeerTube</span>
										</a>
									</li>
									<li className="cursor-pointer w-100" onClick={() => {handleMobSelect(); handleSelect('Dailymotion'); setsearchTab('dailymotion'); setsearchSection("up"); handleButtonClick('youtube');}}>
										<a className="" href="#" onClick={(e) => {e.preventDefault();}}>
										<span>Dailymotion</span>
										</a>
									</li>
									<li className="cursor-pointer w-100" onClick={() => {handleMobSelect(); handleSelect('Odysee'); setsearchTab('odysee'); setsearchSection("up"); handleButtonClick('youtube');}}>
										<a className="" href="#" onClick={(e) => {e.preventDefault();}}>
										<span>Odysee</span>
										</a>
									</li>
									<li className="cursor-pointer w-100" onClick={() => {handleMobSelect(); handleSelect('Twitch Clips'); setsearchTab('twitch'); setsearchSection("up"); handleButtonClick('youtube');}}>
										<a className="" href="#" onClick={(e) => {e.preventDefault();}}>
										<span>Twitch Clips</span>
										</a>
									</li>
									<li className="cursor-pointer w-100" onClick={() => {handleMobSelect(); handleSelect('Audius (audio)'); setsearchTab('audius'); setsearchSection("up"); handleButtonClick('youtube');}}>
										<a className="" href="#" onClick={(e) => {e.preventDefault();}}>
										<span>Audius (audio)</span>
										</a>
									</li>
									<li className="cursor-pointer w-100" onClick={() => {handleMobSelect(); handleSelect('NASA'); setsearchTab('nasa'); setsearchSection("up"); handleButtonClick('youtube');}}>
										<a className="" href="#" onClick={(e) => {e.preventDefault();}}>
										<span>NASA</span>
										</a>
									</li>
									<li className="cursor-pointer w-100" onClick={() => {handleMobSelect(); handleSelect('Pixabay'); setsearchTab('pixabay'); setsearchSection("up"); handleButtonClick('youtube');}}>
										<a className="" href="#" onClick={(e) => {e.preventDefault();}}>
										<span>Pixabay</span>
										</a>
									</li>
									<li className="cursor-pointer w-100" onClick={() => {handleMobSelect(); handleSelect('Pexels'); setsearchTab('pexels'); setsearchSection("up"); handleButtonClick('youtube');}}>
										<a className="" href="#" onClick={(e) => {e.preventDefault();}}>
										<span>Pexels</span>
										</a>
									</li>
								</ul></div>)
								}
							{isMobWorkspaceOpen &&
							(<div className="p-2" ref={dropdownMobWsRef}><ul className="CustomDropdown rounded w-100 position-relative m-0" style={{maxHeight:"400px",overflowY:"auto"}}>
								<li className="cursor-pointer w-100" onClick={() => {setIsMobWorkspaceOpen(false); handleButtonClick('playlists');}}>
									<a className="" href="#" onClick={(e) => {e.preventDefault();}}><span>Playlists</span></a>
								</li>
								<li className="cursor-pointer w-100" onClick={() => {setIsMobWorkspaceOpen(false); handleButtonClick('playlist');}}>
									<a className="" href="#" onClick={(e) => {e.preventDefault();}}><span>Current Playlist</span></a>
								</li>
								<li className="cursor-pointer w-100" onClick={() => {setIsMobWorkspaceOpen(false); handleButtonClick('user_media');}}>
									<a className="" href="#" onClick={(e) => {e.preventDefault();}}><span>User Media</span></a>
								</li>
								<li className="cursor-pointer w-100" onClick={() => {setIsMobWorkspaceOpen(false); window.location.href = 'https://tvadi.com/tools/';}}>
									<a className="" href="#" onClick={(e) => {e.preventDefault();}}><span>Guides</span></a>
								</li>
								<li className="cursor-pointer w-100" onClick={() => {setIsMobWorkspaceOpen(false); window.location.href = 'https://tvadi.com/market/';}}>
									<a className="" href="#" onClick={(e) => {e.preventDefault();}}><span>Market</span></a>
								</li>
							</ul></div>)
							}
						</div>
					</div>
					</div>
					{
						mShow.playlist && (
							<div className="row m-0">
								<div>
									<div
										className="creator_PlaylistPlayer__menu playlistEdit p-0"
										id="tempPlaylist"
									>
										{YoutubeTempPlaylist.length == 0 || JSON.parse(sessionStorage.getItem("userDetails")) != null && currentPlaylist && currentPlaylist.users[0]._id != loginId || isLogin == null ? (
										<img
											src={require("../asset/PlaylistMakerImages/NothingPlaylistText.png")}
											className="img-fluid m-0 p-2"
											alt=""
											style={{ width: "100%"}}
										/>
										) : (
										<>
											{YoutubeTempPlaylist.map((val, index) => {
											return (
												<>
												<div
													key={index}
													className={(CurrentPlay != '' && CurrentPlay == getId(val.url) ? 'active_video' : '')+" mainBox"}
													style={{ position: "relative", cursor: "grab" }}
											draggable="true"
											onDragStart={(e) => handleClipDragStart(e, index)}
											onDragEnd={handleClipDragEnd}
											onDragOver={handleClipDragOver}
											onDragLeave={handleClipDragLeave}
											onDrop={(e) => handleClipDrop(e, index)}
												>
													{val.thumbnail && val.thumbnail.includes(".mp4") ||val.thumbnail && val.thumbnail.includes(".mov") ? (
													<div
														className="creator_VideoBadge ps-2"
														onClick={() => {
														playYoutubeTempList(index);
														setYoutubePlay(false);
														}}
													>
														<video className="creator_VideoBadge__logo" src={val.thumbnail}></video>
														<div
														className="creator_VideoBadge__info lcheck"
														style={{ padding: "3px" }}
														>
														<div className="info">
															<p
															style={{
																lineHeight: "15px",
																fontSize: "10px",
																margin: "2px",
																color: "#fff",
																width: "88%",
															}}
															>
															<l title={val.title} style={{ fontSize: "12px" }}>
																{val.title.length <= 30 ? (
																val.title.substring(0, 30)
																) : (
																<marquee className="mt-0" scrollamount={3}
																>
																	{val.title}
																</marquee>
																)}
															</l>
															<br />
															{val.channel_name} -{" "}
															{moment(val.publishTime)
																.utc()
																.format("MM/DD/YYYY")}
															<br />
															{moment("2015-01-01")
																.startOf("day")
																.seconds(val.duration)
																.format("H:mm:ss")}
															</p>
														</div>
														</div>
													</div>
													)
													:
													(
														<div
														className="creator_VideoBadge ps-2 mb-0"
														onClick={() => {
															playYoutubeTempList(index);
															setYoutubePlay(false);
														}}
														>
														<div
															className="creator_VideoBadge__logo br-5 overflow-hidden my-2"
															style={{ backgroundImage: `url(${val.thumbnail})` }}
														/>
														<div 
															className="creator_VideoBadge__info playlist_video_main lcheck1 pt-0 df"
															style={{ padding: "3px" }}
														>
															<div className="info playlist_video_content_box">
															<p
																style={{
																lineHeight: "15px",
																fontSize: "10px",
																margin: "2px",
																color: "#fff"
																}}
																className="mt-0 mm-0 mp-1 playlist_video_content lcheck123"
															>
																<l title={val.title} style={{ fontSize: "15px" }}>
																{val.title.length <= 30 ? (
																	val.title.substring(0, 30)
																) : (
																	<marquee
																	scrollamount={3}
																	>
																	{val.title}
																	</marquee>
																)}
																</l>
																<br />
																<div className="playlist_ellipsis mb-2">
																{val.description ? (<l title={val.description}>
																{val.description}
																</l>) : ("")}
																</div>
															<div style={{ color: 'white' }}>
																<div style={{display: 'inline'}}>
																	<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"15px",height:"15px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
																</div>

																<div style={{display: 'inline'}}>
																	<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"15px",height:"15px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
																</div>
																<div style={{display: 'inline'}}> 
																	{
																		!val.views || val.views === 0 || val.views === "0" ? "-.-" : val.views > 999 && val.views < 1000000 ? (val.views / 1000).toFixed(1) + "K" : val.views > 1000000 ? (val.views / 1000000).toFixed(1) + "M" : val.views
																	}
																	</div>
																<div className="mme-1" style={{ display: 'inline', float: 'right' }} onClick={() => { if(val.url){ navigator.clipboard.writeText(val.url).then(() => toast.success("Video URL copied!")); } }}>
																	<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
																</div>
																<div style={{ display: 'inline', float: 'right' }} onClick={() => tempPlayListVideoRemove(index)}>
																	<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><circle cx="12" cy="12" r="10"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
																</div>
															</div>
															</p>
															</div>  
														</div>
														</div>)}

													<div className="clip-card-actions" style={{
                                position: "absolute", top: 0, right: 0, bottom: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                width: "30px", background: "rgba(0,0,0,0.5)",
                                borderLeft: "1px solid rgba(255,255,255,0.1)",
                                cursor: "pointer"
                              }} onClick={() => {
                                try {
                                  playYoutubeTempList(index);
                                  setCurrentPlay(getId(val.url));
                                  setYoutubePlay(false);
                                } catch(e) { console.error('Play error:', e); }
                              }}>
                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"16px",height:"16px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><polygon points="5 3 19 12 5 21 5 3"/></svg>
                              </div>
												</div>
												</>
											);
											})}
										</>
										)}

									</div>
									</div>
									<div className="row m-0 bt-1 py-1 mob-playlist">
										<div className="col-4">
											<div className=" todayList buttonPadding mp-0">
											{isLogin !== null ? (
												<button
												onClick={saveYoutubePalylist}
												className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 d"
												>
												<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"18px",height:"18px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
												<span
													className="m-auto text-white astroSpace"
													style={{
													textTransform: "uppercase",
													fontSize: "90%",
													}}
												>
													Save
												</span>
												</button>
											) : (
												<button
												onClick={redirectNorLogin}
												className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 1"
												>
												<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"18px",height:"18px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
												<span
													className="m-auto text-white astroSpace"
													style={{
													textTransform: "uppercase",
													fontSize: "90%",
													}}
												>
													Save
												</span>
												</button>
											)}
											</div>
										</div>
										<div className="col-4 p-0">
											<div className=" todayList buttonPadding mp-0">
											{isLogin !== null ? (
												<button
												onClick={() => {handleShow('past_url');}}
												className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 2"
												>
												<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"18px",height:"18px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
												<span
													className="m-auto text-white astroSpace"
													style={{
													textTransform: "uppercase",
													fontSize: "90%",
													}}
												>
													+ URL
												</span>
												</button>
											) : (
												<button
												onClick={redirectNorLogin}
												className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 4"
												>
												<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"18px",height:"18px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
												<span
													className="m-auto text-white astroSpace"
													style={{
													textTransform: "uppercase",
													fontSize: "90%",
													}}
												>
													+ URL
												</span>
												</button>
											)}
											</div>
										</div>
										<div className="col-4">
											<div className=" todayList buttonPadding mp-0">
											<button
												data-bs-toggle="modal"
												data-bs-target="#sharePlaylist"
												onClick={() => {
												setsharedPlaylist(currentPlaylist);
												EmptyCopy();
												handleShow('share_list');
													{
														socialMediaMenu
														? setSocialMediaMenu(false)
														: setSocialMediaMenu(true);
													}
												}}
												className="btn w-100 p-1  rounded-0 border-0 d-flex p-0"
											>
												<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"18px",height:"18px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
												<span
												className="m-auto text-white astroSpace"
												style={{
													textTransform: "uppercase",
													fontSize: "90%",
												}}
												>
												Share{" "}
												</span>
											</button>
											</div>
										</div>
									</div>
							</div>
						)
					}

					{
						mShow.playlists && (
							<div className="creator_PlaylistPlayer__playlists col-12 p-0 bt-1">
								{/* <hr style={{ margin: "0.5rem", color: "#fff" }} /> */}
								{playlists?.length == 0 ||
								(playlists[0].title == "Temp" && playlists?.length == 1) ? (
								<img
									src={require("../asset/images/NothingImgAdd.png")}
									className="img-fluid m-0 p-0"
									alt=""
									style={{ width: "100%", height: "80%" }}
								/>
								) : (
								playlists?.map((playlist, index) =>
									isLogin != null && playlist.title != "Temp" && playlist?.users[0]?._id == loginId ? (
									<>
										<div
										key={index}
										className="playlist_main_box"
										style={{ position: "relative", cursor: "grab"}}
										draggable="true"
										onDragStart={(e) => handlePlaylistDragStart(e, index)}
										onDragEnd={handlePlaylistDragEnd}
										onDragOver={handlePlaylistDragOver}
										onDragLeave={handlePlaylistDragLeave}
										onDrop={(e) => handlePlaylistDrop(e, index)}
										>
										<PlaylistButton
											playlist={playlist}
											onClick={() => {
											setPlaylistIndex(index);
											setVideoIndex(0);
											changePalylistData(index);
											}}
											active={index === playlistIndex}
											deletePlaylist = {() => {deleteCurrentPlaylist(playlist)}}
											totalViews = {GetViews(playlist)}
											shared = {()=> {setsharedPlaylist(playlist); EmptyCopy();  handleShow('share_list');}}
											rerender={playlistsSequenceStatus}
										/>
										

										<ul
											className="icons vertical-justify px-2 playlist-button-border bg-dark cursor-pointer"
											style={{
												height: "100%",
												position: "absolute",
												top: "0",
												right: "0",
												listStyle: "none",
												bottom:"0",
												margin:"0"
											}}
											>
											<li className="text-center" onClick={() => {setPlaylistOrderSequence(index, 'up');}}>
												<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"15px",height:"15px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><polyline points="18 15 12 9 6 15"/></svg>
											</li>
											<li
												onClick={() => {
													setVideoIndex(0);
													setPlaylistIndex(index);
													changePalylistData(index);
												}}
												className="text-center"
											>
												<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"25px",height:"25px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><polygon points="5 3 19 12 5 21 5 3"/></svg>
											</li>
											{/* <li onClick={() => tempPlayListVideoRemove(index)}>
												<img
												src={require("../asset/images/Minus.webp")}
												className="img-fluid"
												alt=""
												style={{ width: "19px" }}
												/>
											</li> */}
											<li className="text-center" onClick={() => {setPlaylistOrderSequence(index, 'down');}}>
												<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"15px",height:"15px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><polyline points="6 9 12 15 18 9"/></svg>
											</li>
											</ul>
										</div>
									</>
									) : (
									""
									)
								)
								)}
							</div>
						)
					}

					{
						mShow.user_media && (
							<div className="mt-1 p-0 user_media_container" style={{maxHeight:"31.2rem", overflow:"auto"}}> 
								{uploadIntroLoader ? (
								<div className="main_loader_box">
									<h5
									style={{
										lineHeight: "11px",
										margin: "20px",
										color: "#fff",
									}}
									>
									Uploading
									</h5>
									<div className="loader">
									<span></span>
									<span></span>
									<span></span>
									<span></span>
									<span></span>
									</div>
								</div>
								) : (
								//   <DataTable
								//     style={{ background: "transparent" }}
								//     title=""
								//     columns={columns}
								//     data={IntroVideoArr}
								//     defaultSortFieldId={1}
								//     // sortIcon={<ArrowUpwardIcon />}
								//     pagination
								//   // selectableRows
								//   // onSelectedRowsChange={handleChange}
								//   />
									
								userMedia.length ? userMedia.map((val, index) => (
									<div key={index} lassName="mainBox" style={{ position: "relative" }}
									>
									<div className="creator_VideoBadge playlist-border bs-0 be-0 mb-0 user_media_list_box py-2 user_media_playlist ">
										<div
										className="creator_VideoBadge__logo br-10 ms-2"
										style={{ backgroundImage: `url(${val.thumbnail})` }}
										/>
										<div
										className="creator_VideoBadge__info lcheck3" 
										style={{ padding: "3px", width:"100%" }}
										>
										<div className="info user_media">
											<p
											style={{
												lineHeight: "11px",
												fontSize: "10px",
												margin: "2px",
												color: "#fff",
											}}
											>

											<div style={{ fontSize: "20px" }} title="title">
												<marquee className="pb-2 pt-1" scrollamount={3}> {val.title} </marquee>
											</div>
											{/* <h6>{video.name
												? <marquee scrollamount="3">{video.name}</marquee>
												: ""}</h6> */}


											{/* {video.description
												? video.description.slice(0, 75) + "..."
												: ""} */}
												<div className="playlist_ellipsis mb-2" style={{ lineHeight: "40px", fontSize:"15px" }}>
													{val.description}
												</div>
											{/* <br />
											<img
												src={require("../asset/images/ButtonNotLike.png")}
												className="img-fluid"
												alt=""
												style={{ width: "20px", cursor: "pointer" }}
											/>{" "}
											{video.metadata.connections.likes.total}
											<br />
											play@:
											{moment("2015-01-01")
												.startOf("day")
												.seconds(video.duration)
												.format("H:mm:ss")} */}

												<div className="text-white">
												<div className="d-inline me-1" data-id={val._id} onClick={() => {removeUserMedia(val._id);}}>
													<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"22px",height:"22px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><circle cx="12" cy="12" r="10"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
												</div>
												<div className="d-inline ms-3 me-1 float-end user_media_add_url_box common-border rounded overflow-hidden" style={{width:"8rem"}}>
													<button
									onClick={() => {redirectNorLogin(); handleShow('user_media_url');}}
									className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 2"
									>
									<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"18px",height:"18px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
									<span
										className="m-auto text-white astroSpace"
										style={{
										textTransform: "uppercase",
										fontSize: "90%",
										}}
									>
										+ Add Video
									</span>
									</button>
												</div>
											</div>
											</p>
										</div>
										</div>
									</div>
									<ul
										className="icons playlist-border bt-0 bb-0 bs-0 user_media_playlist_button_box">

										<li
											style={{
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											margin: "10px 0"
											}}
											onClick={() => {
												setCurrentPlay(getId(val.url));
												setYoutubePlay(true);
												setVideoIndex(videoIndex);
												setYoutubePlayUrl(val.url);
											}}
										>
										<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"16px",height:"16px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><rect x="2" y="2" width="20" height="20" rx="4" ry="4"/><polygon points="10 8 16 12 10 16 10 8" style={{fill:"rgba(255,255,255,0.8)",stroke:"none"}}/></svg>
										</li>

										<li
										
										style={{
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											margin: "10px 0"
											}}
											onClick={() => {addToPlaylist(val.url);}}
										>
										<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"16px",height:"16px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
										</li>
									</ul>
									</div>
								)) : 
									<div class="row m-0">
									<div class="col-12 mpx-2">
										<div class="todayList  buttonPadding p-2 text-white text-center">No Video Added.</div>
									</div>
									</div>
								)}

							</div>
						)
					}

					{
						mShow.youtube && (
							<>
							<div className="row mt-2" style={{ margin: "0px" }}>
								<div className="creator_PlaylistPlayer__menu userUploadVideo p-0 lcheck12" style={{ maxHeight: "25rem", overflowY: "auto", overflowX:"hidden"}}>
									{youtubeSearchLoader ? (
									<div className="main_loader_box sd">
										<div className="loader"><span></span><span></span><span></span><span></span><span></span></div>
									</div>
									) : showSearchVideo ? (
										<div style={{ padding: "32px 15px", textAlign: "center", opacity: 0.32, display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
											<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"26px",height:"26px",stroke:"white",strokeWidth:1.5,fill:"none"}}><polyline points="18 15 12 9 6 15"/></svg>
											<span style={{ color: "white", fontSize: "13px", letterSpacing: "1px" }}>Search and add videos</span>
											<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"22px",height:"22px",stroke:"white",strokeWidth:1.5,fill:"none"}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
										</div>
									) : (
										selectedOption !== 'Vimeo' ? 
										<YoutubeListSection
										allYoutubeSearchVideoData={allYoutubeSearchVideoData}
										CurrentPlay = {CurrentPlay}
										setCurrentPlay = {setCurrentPlay}
										setYoutubePlay = {setYoutubePlay}
										setVideoIndex = {setVideoIndex}
										videoIndex = {videoIndex}
										setYoutubePlayUrl = {setYoutubePlayUrl}
										setYoutubeDatainState = {setYoutubeDatainState}
										setYoutubePlayThumb = {setYoutubePlayThumb}
										/>
									: 
									<VimeoListSection
										videoAllSearchData = {videoAllSearchData}
										CurrentPlay = {CurrentPlay}
										setYoutubePlay = {setYoutubePlay}
										setCurrentPlay = {setCurrentPlay}
										setYoutubePlayUrl = {setYoutubePlayUrl}
										setYoutubeDatainState = {setYoutubeDatainState}
									/>
									)}
								</div>
								</div>
							<div className="row p-2 bb-1 bt-1 m-0">
								<div className="col-5">
									<div className=" todayList buttonPadding br-5 mp-0">
									{searchTab == 'youtube' && searchKeyword != "" && prevPageToken != "" && prevPageToken != undefined || searchTab == 'vimeo' && searchKeyword != "" && vimeoPageNumber != 1 ? (
										<button
										// onClick={nextyoutuberesults}
										onClick={(e) => {
											if (searchTab === 'youtube') {
												previousyoutuberesults(e);
											} else {
												setvimeoPageNumber(vimeoPageNumber - 1);
												searchVideos(e);
											}
										}}
										// onClick={previousyoutuberesults}
										className="btn w-100  p-1 rounded-0 border-0 d-flex p-0 position-relative"
										>
										<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="15 18 9 12 15 6"/></svg>
										<span
											className="m-auto text-white astroSpace"
											style={{
											textTransform: "uppercase",
											fontSize: "90%",
											}}
										>
											BACK
										</span>
										</button>
									) : (
										<button
										disabled
										// onClick={previousyoutuberesults}
										className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 13 position-relative"
										>
										<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="15 18 9 12 15 6"/></svg>
										<span
											className="m-auto text-white astroSpace"
											style={{
											textTransform: "uppercase",
											fontSize: "90%",
											}}
										>
											BACK
										</span>
										</button>
									)}
									</div>
								</div>
								<div className="col-2 p-0"></div>
								<div className="col-5">
									<div className=" todayList buttonPadding br-5 mp-0">
									{searchKeyword != "" || searchVimeoKeyword != "" ? (
										<button
										onClick={(e) => {
											if (searchTab === 'youtube') {
												nextyoutuberesults(e);
											} else {
												setvimeoPageNumber(vimeoPageNumber + 1);
												searchVideos(e);
											}
										}}
										className="btn w-100  p-1 rounded-0 border-0 d-flex p-0 position-relative"
										>
										<span
											className="m-auto text-white astroSpace"
											style={{
											textTransform: "uppercase",
											fontSize: "90%",
											}}
										>
											MORE
										</span>
										<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="9 18 15 12 9 6"/></svg>
										</button>
									) : (
										<button
										disabled
										className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 14 position-relative"
										>
										<span
											className="m-auto text-white astroSpace"
											style={{
											textTransform: "uppercase",
											fontSize: "90%",
											}}
										>
											MORE
										</span>
										<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="9 18 15 12 9 6"/></svg>
										</button>
									)}
									</div>
								</div>
							</div>
							</>
						)
					}

					{
						mShow.vimeo && (
							<>
							<div className="row mt-2 m-0">
								<div className="creator_PlaylistPlayer__menu userUploadVideo lcheck11">
								{vimeoSearchLoader ? (
									<div className="main_loader_box">
									<div className="loader">
										<span></span>
										<span></span>
										<span></span>
										<span></span>
										<span></span>
									</div>
									</div>
								) : videoAllSearchDataDown.length != 0 || allYoutubeSearchVideoDataDown.length != 0 ? (
									selectedOptionDown !== 'Vimeo' ? 
									<YoutubeListSection
										allYoutubeSearchVideoData={allYoutubeSearchVideoDataDown}
										CurrentPlay = {CurrentPlay}
										setCurrentPlay = {setCurrentPlay}
										setYoutubePlay = {setYoutubePlay}
										setVideoIndex = {setVideoIndex}
										videoIndex = {videoIndex}
										setYoutubePlayUrl = {setYoutubePlayUrl}
										setYoutubeDatainState = {setYoutubeDatainState}
										setYoutubePlayThumb = {setYoutubePlayThumb}
										/>
									: 
									<VimeoListSection
										videoAllSearchData = {videoAllSearchDataDown}
										CurrentPlay = {CurrentPlay}
										setYoutubePlay = {setYoutubePlay}
										setCurrentPlay = {setCurrentPlay}
										setYoutubePlayUrl = {setYoutubePlayUrl}
										setYoutubeDatainState = {setYoutubeDatainState}
									/>
								) : (
									<VideoLoader />
								)}
								</div>
							</div>
							<div className="row p-2 bb-1 bt-1 m-0">
								<div className="col-5">
								<div className=" todayList buttonPadding br-5 mp-0">
										{searchTabDown == 'youtube' && searchVimeoKeyword != "" && prevPageTokenDown != "" && prevPageTokenDown != undefined || searchTabDown == 'vimeo' && searchVimeoKeyword != "" && vimeoPageNumberDown != 1 ? (
									<button
										onClick={(e) => {
											if (searchTabDown === 'youtube') {
												previousyoutuberesults(e);
											} else {
												// setvimeoPageNumberDown(vimeoPageNumberDown - 1);
												setvimeoPageNumberDown((vimeoPageNumber) => {
													const newPageNumber = vimeoPageNumber - 1;
													return newPageNumber < 1 ? 1 : newPageNumber;
												});
												searchVideos(e);
											}
										}}
										className="btn w-100 p-1  rounded-0 border-0 d-flex p-0 position-relative"
									>
										<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="15 18 9 12 15 6"/></svg>
										<span
										className="m-auto text-white astroSpace"
										style={{
											textTransform: "uppercase",
											fontSize: "90%",
										}}
										>
										BACK
										</span>
									</button>
									) : (
									<button
										disabled
										className="btn w-100 p-1  rounded-0 border-0 d-flex p-0 position-relative"
									>
										<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="15 18 9 12 15 6"/></svg>
										<span
										className="m-auto text-white astroSpace"
										style={{
											textTransform: "uppercase",
											fontSize: "90%",
										}}
										>
										BACK
										</span>
									</button>
									)}
								</div>
								</div>
								<div className="col-2 p-0"></div>
								<div className="col-5">
								<div className=" todayList buttonPadding br-5 mp-0">
									{searchVimeoKeyword != "" ? (
									<button
										onClick={(e) => {
											if (searchTabDown === 'youtube') {
												nextyoutuberesults(e);
											} else {
											setvimeoPageNumberDown(vimeoPageNumberDown + 1);
												searchVimeoVideo(e)
											}
										}}
										className="btn w-100 p-1  rounded-0 border-0 d-flex p-0 position-relative"
									>
										<span
										className="m-auto text-white astroSpace"
										style={{
											textTransform: "uppercase",
											fontSize: "90%",
										}}
										>
										MORE
										</span>
										<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="9 18 15 12 9 6"/></svg>
									</button>
									) : (
									<button
										disabled
										className="btn w-100 p-1  rounded-0 border-0 d-flex p-0 position-relative"
									>
										<span
										className="m-auto text-white astroSpace"
										style={{
											textTransform: "uppercase",
											fontSize: "90%",
										}}
										>
										MORE
										</span>
										<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="9 18 15 12 9 6"/></svg>
									</button>
									)}
								</div>
								</div>
							</div>
							</>
						)
					}
			</div>

			</div>
            <div className="row my-3 md-none">
              <div className="col-4 my-2 mpl-05 mpr-05">
                <div className="todayList  buttonPadding br-5 mp-0">
                  {allYoutubeSearchVideoData.length != 0 ? (
                    <button
                      onClick={() => {
                        {
                          if (searchKeyword !== "" && videoIndex != 0 && allYoutubeSearchVideoData[videoIndex - 1] !== undefined) {
							if (allYoutubeSearchVideoData[videoIndex - 1] !== undefined) {
								setYoutubePlay(true);
								setCurrentPlay(allYoutubeSearchVideoData[videoIndex - 1].id
									.videoId);
								setYoutubePlayUrl(
								"https://www.youtube.com/watch?v=" +
								allYoutubeSearchVideoData[videoIndex - 1].id
									.videoId
								);
                            	setVideoIndex(videoIndex - 1);
							}

							if (videoAllSearchData[videoIndex - 1] !== undefined) {
								setYoutubePlay(true);
								setCurrentPlay(videoAllSearchData[videoIndex - 1].link);
								setYoutubePlayUrl(
								videoAllSearchData[videoIndex - 1].link
								);
								setYoutubePlay(true);
								setYoutubePlayUrl(
								videoAllSearchData[videoIndex - 1].link
								);
								setVideoIndex(videoIndex - 1);
							}
                          }
                        }
                      }}
                      className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 5 position-relative mpx-0"
                    >
                      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"30px",height:"30px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><polyline points="15 18 9 12 15 6"/></svg>
                      <span
                        className="m-auto astroSpace player_pervious_btn"
                        style={{
                          fontSize: "90%",
                          color: "white",
                        }}
                      >
                        Previous
                      </span>
                    </button>
                  ) : (
                    <button
                      disabled
                      className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 6 position-relative"
                    >
                      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"30px",height:"30px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><polyline points="15 18 9 12 15 6"/></svg>
                      <span
                        className="m-auto astroSpace player_pervious_btn"
                        style={{
                          fontSize: "90%",
                          color: "white",
                        }}
                      >
                        Previous
                      </span>
                    </button>
                  )}
                </div>
              </div>
              {videoAllSearchData ? (
                <div
                  // onClick={() => {
                  //   console.log('inside code videoAllSearchData');
                  //   setYoutubeDatainState(
                  //     videoAllSearchData[videoIndex].name,
                  //     videoAllSearchData[videoIndex].link,
                  //     null,
                  //     videoAllSearchData[videoIndex].metadata.connections.likes
                  //       .total,
                  //     videoAllSearchData[videoIndex].created_time,
                  //     videoAllSearchData[videoIndex].duration,
                  //     null,
                  //     videoAllSearchData[videoIndex].user.name,
                  //     videoAllSearchData[videoIndex].user.link,
                  //     videoAllSearchData[videoIndex].pictures.base_link,
                  //     videoAllSearchData[videoIndex].description,
                  //     videoAllSearchData[videoIndex].embed.html,
                  //     videoAllSearchData[videoIndex].categories.length != 0
                  //       ? videoAllSearchData[videoIndex].categories[0].name
                  //       : null,
                  //     videoAllSearchData[videoIndex].user.location_details
                  //   );
                  // }}
                  className="col-4 my-2 addListButton mpl-05 mpr-05"
                >
                  <div className="todayList  buttonPadding br-5 mp-0">
                    {(searchKeyword !== "" || searchVimeoKeyword !== "") && allYoutubeSearchVideoData.length ? (
                      <button
                        onClick={() => {
                          setYoutubeDatainState(
                            allYoutubeSearchVideoData[videoIndex].snippet.title,
                            "https://www.youtube.com/watch?v=" +
                            allYoutubeSearchVideoData[videoIndex].id.videoId,
                            allYoutubeSearchVideoData[videoIndex].views,
                            allYoutubeSearchVideoData[videoIndex].likes,
                            allYoutubeSearchVideoData[videoIndex].snippet
                              .publishTime,
                            moment
                              .duration(
                                allYoutubeSearchVideoData[videoIndex].duration
                              )
                              .asSeconds(),
                            (allYoutubeSearchVideoData[videoIndex].tags = null),
                            allYoutubeSearchVideoData[videoIndex].snippet
                              .channelTitle,
                            "https://www.youtube.com/channel/" +
                            allYoutubeSearchVideoData[videoIndex].snippet
                              .channelId,
                            allYoutubeSearchVideoData[videoIndex].snippet
                              .thumbnails.high.url,
                            allYoutubeSearchVideoData[videoIndex].snippet
                              .description,
                            '<iframe width="560" height="315" src="https://www.youtube.com/embed/' +
                            allYoutubeSearchVideoData[videoIndex].id.videoId +
                            '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
                            allYoutubeSearchVideoData[videoIndex].category,
                            null
                          );
                        }}
                        className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 7 position-relative mpx-0"
                      >
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"22px",height:"22px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
                        <span
                          className="m-auto astroSpace"
                          style={{
                            fontSize: "90%",
                            color: "white",
                          }}
                        >
                          <strong>Add</strong>
                        </span>
                      </button>
                    ) : (
                      <button
                        disabled
                        className="btn w-100 p-1  rounded-0 border-0 d-flex p-0 position-relative"
                      >
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"22px",height:"22px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
                        <span
                          className="m-auto astroSpace"
                          style={{
                            fontSize: "90%",
                            color: "white",
                          }}
                        >
                          <strong>Add</strong>
                        </span>
                      </button>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}

              {searchTab == "vimeo" ? (<div
                onClick={() => {
                  if (searchKeyword !== "" && videoAllSearchData) {
                    setYoutubePlay(true);
                    setYoutubePlayUrl(videoAllSearchData[videoIndex + 1].link);
                    setVideoIndex(videoIndex + 1);
                  }
                }}
                className="col-4 my-2 addListButton mpl-05 mpr-05"
              >
                <div className="todayList  buttonPadding br-5 mp-0">
                  {searchKeyword !== "" || searchVimeoKeyword !== "" ? (
                    <button
						onClick={() => {
							setYoutubePlay(true);
							setVideoIndex(videoIndex + 1);
							setYoutubePlayUrl(videoAllSearchData[videoIndex + 1].link);
						}}
						className="btn w-100 p-1 rounded-0 border-0 d-flex align-items-center justify-content-center position-relative mpx-0"
						style={{ padding: "0" }}
						>
						<span
							className="astroSpace"
							style={{
							fontSize: "90%",
							color: "white",
							textAlign: "center",
							flexGrow: 1,
							}}
						>
							<strong className="nextbutton">Next</strong>
						</span>
						<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="9 18 15 12 9 6"/></svg>
						</button>

                  ) : (
                    <button
                      disabled
                      className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 9"
                    >
                      <span
                        className="m-auto astroSpace"
                        style={{
                          fontSize: "90%",
                          color: "white",
                        }}
                      >
                        <strong  className="nextbutton2">Next</strong>
                      </span>
                      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="9 18 15 12 9 6"/></svg>
                    </button>
                  )}
                </div>
              </div>) :
                // Youtube Search Tab Condition
                (<div
                  className="col-4 my-2 addListButton mpl-05 mpr-05"
                >
                  <div className="todayList  buttonPadding br-5 mp-0">
                    {(searchKeyword !== "" || searchVimeoKeyword !== "") && allYoutubeSearchVideoData[videoIndex + 1] !== undefined ? (
                      <button
                        onClick={() => {
                          	if(allYoutubeSearchVideoData[videoIndex + 1] !== undefined) {
                            setYoutubePlay(true);

                            setYoutubePlayUrl(
                              "https://www.youtube.com/watch?v=" +
                              allYoutubeSearchVideoData[videoIndex + 1].id
                                .videoId
                            );
							setCurrentPlay(getId("https://www.youtube.com/watch?v=" +
                              allYoutubeSearchVideoData[videoIndex + 1].id
                                .videoId));
                            setVideoIndex(videoIndex + 1);
                            setYoutubePlay(true);
                          }
                        }}
                        className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 10 position-relative mpx-0"
                      >
                        <span
                          className="m-auto astroSpace"
                          style={{
                            fontSize: "90%",
                            color: "white",
                          }}
                        >
                          <strong className="tnext">Next</strong>
                        </span>
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="9 18 15 12 9 6"/></svg>
                      </button>
                    ) : (
                      <button
                        disabled
                        className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 11 position-relative"
                      >
                        <span
                          className="m-auto astroSpace"
                          style={{
                            fontSize: "90%",
                            color: "white",
                          }}
                        >
                          <strong  className="tnextd">Next</strong>
                        </span>
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="9 18 15 12 9 6"/></svg>
                      </button>
                    )}
                  </div>
                </div>)}

              <div className="col-4 mpl-05 mpr-05">
                <div className="todayList  buttonPadding br-5 mp-0">
                  <button
                    onClick={() => {
						getPlaylistViews(playlistIndex);
                      loopPlayList
                        ? setLoopPlayList(false)
                        : setLoopPlayList(true);
                    }}
                    className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 12 mpx-0"
                  >
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"18px",height:"18px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
					<span style={{fontSize:"16px",opacity:1,margin:"0 3px",color:"rgba(255,255,255,0.5)",fontWeight:"bold"}}>±</span>
                    <span
                      className="m-auto astroSpace"
                      style={{
                        fontSize: "90%",
                        color: "white",
                      }}
                    >
                      {/* {loopPlayList ? "Unloop Playlist" : "Loop Playlist"} */}
					  {totalViews}
                    </span>
                  </button>
                </div>
              </div>

			  <div className="col-4 mpl-05 mpr-05">
                <div className="todayList  buttonPadding br-5 mp-0">
                  <button
                    onClick={randomizePlaylist}
                    className="btn w-100 p-1 rounded-0 border-0 d-flex p-1 mpx-0"
                  >
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"27px",height:"27px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><path d="M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.6-8.6c.8-1.1 2-1.7 3.3-1.7H20"/><path d="M18 2l3 4-3 4"/><path d="M2 6h1.4c1.3 0 2.5.6 3.3 1.7l6.6 8.6c.8 1.1 2 1.7 3.3 1.7H20"/><path d="M18 14l3 4-3 4"/></svg>
                    <span
                      className="m-auto astroSpace playlist_randomize_btn"
                      style={{
                        fontSize: "89%",
                        color: "white",
                      }}
                    >
                      Randomize
                    </span>
                  </button>
                </div>
              </div>

              <div className="col-4 mpl-05 mpr-05">
                <div className="todayList  buttonPadding br-5 mp-0">
                  <button className="btn w-100 p-1 rounded-0 border-0 d-flex p-1 mpx-0">
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"27px",height:"27px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                    <span
                      className="m-auto astroSpace"
                      style={{
                        fontSize: "90%",
                        color: "white",
                      }}
                    >
                      {moment("2015-01-01")
                        .startOf("day")
                        .seconds(playListRunTime)
                        .format("H:mm:ss")}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*End Second Section */}

        {/* Third Section */}

        <div onClick={() => {
          setsearchSection("up");
        }} className="col-12 col-lg-3 p-0 col-sm-12 col-xs-12 order-lg-3 order-sm-last mmt-3 md-none">
          <div className="borderRadius todayList p-0 overflow-hidden">
            <div className="row">
              <div className="col-12">
                <div className="todayList  buttonPadding border-0 mp-0">
                  <form
                    // onSubmit={(e) => searchYoutubeVideo(e)}
                    ref={formRef}
                    onSubmit={(e) => searchVideos(e)}
                    className="d-flex youtube-search-form"
                    data-section="up"

                  >
					<div className="search-box p-2">
                        <button type="submit" className="border-0 bg-transparent p-0 m-0">
                            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"16px",height:"16px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                        </button>
					</div>
                    <input
                      onChange={(e) => {searchTab === 'vimeo' ? setSearchVimeoKeyword(e.target.value) : setSearchKeyword(e.target.value)}}
                      type="text"
                      placeholder='Search'
                      style={{
                        outline: "none",
                        background: "transparent",
                        color: "white",
                        border: "transparent",
						fontSize: "13px"
                      }}
                      className="w-100 p-2"
                      name="youtubesearch"
                    />
                  </form>
                </div>
              </div>
            </div>
             <div className="row m-0 text-white playlist-border br-5 mt-2 mx-2">
            <div className="pe-0 playlist-title text-center w-10" style={{ cursor: "pointer" }} onClick={() => setIsOpen(prev => !prev)}>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"16px",height:"16px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><path d="M4 6h16"/><path d="M4 10h16"/><path d="M4 14h10"/><path d="M16 14l7 4-7 4z"/></svg>
            </div>
            <div className="d-flex align-items-center w-90 position-relative cursor-pointer" style={{ padding: "0", paddingLeft: ".75rem" }}>
                <span className="flex-grow-1 fs-5">
                    <div className="custom-dropdown" ref={dropdownRef}>
                        <div
                            className="search_dropdown"
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            {selectedOption}
                            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"12px",height:"12px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.45,flexShrink:0}}><polyline points="6 9 12 15 18 9"/></svg>
                        </div>
                        {isOpen && (
							<ul className="CustomDropdown rounded w-100" style={{maxHeight:"400px",overflowY:"auto"}}>
                                <li className="cursor-pointer w-100" onClick={() => {handleSelect('Search All'); setsearchTab('all')}}>
                                    <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                        <span>Search All</span>
                                    </a>
                                </li>
								<li className="cursor-pointer w-100" onClick={() => {handleSelect('YouTube'); setsearchTab('youtube')}}>
                                    <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                        <span>YouTube</span>
                                    </a>
                                </li>
								<li className="cursor-pointer w-100" onClick={() => {handleSelect('Vimeo'); setsearchTab('vimeo')}}>
                                    <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                        <span>Vimeo</span>
                                    </a>
                                </li>
								<li className="cursor-pointer w-100" onClick={() => {handleSelect('Archive.org'); setsearchTab('archiveorg')}}>
                                    <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                        <span>Archive.org</span>
                                    </a>
                                </li>
								<li className="cursor-pointer w-100" onClick={() => {handleSelect('Wikimedia'); setsearchTab('wikimedia')}}>
                                    <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                        <span>Wikimedia</span>
                                    </a>
                                </li>
								<li className="cursor-pointer w-100" onClick={() => {handleSelect('PeerTube'); setsearchTab('peertube')}}>
                                    <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                        <span>PeerTube</span>
                                    </a>
                                </li>
								<li className="cursor-pointer w-100" onClick={() => {handleSelect('Dailymotion'); setsearchTab('dailymotion')}}>
                                    <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                        <span>Dailymotion</span>
                                    </a>
                                </li>
								<li className="cursor-pointer w-100" onClick={() => {handleSelect('Odysee'); setsearchTab('odysee')}}>
                                    <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                        <span>Odysee</span>
                                    </a>
                                </li>
								<li className="cursor-pointer w-100" onClick={() => {handleSelect('Twitch Clips'); setsearchTab('twitch')}}>
                                    <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                        <span>Twitch Clips</span>
                                    </a>
                                </li>
                                <li className="cursor-pointer w-100" onClick={() => {handleSelect('Audius (audio)'); setsearchTab('audius')}}>
                                    <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                        <span>Audius (audio)</span>
                                    </a>
                                </li>
                                <li className="cursor-pointer w-100" onClick={() => {handleSelect('NASA'); setsearchTab('nasa')}}>
                                    <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                        <span>NASA</span>
                                    </a>
                                </li>
                                <li className="cursor-pointer w-100" onClick={() => {handleSelect('Pixabay'); setsearchTab('pixabay')}}>
                                    <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                        <span>Pixabay</span>
                                    </a>
                                </li>
                                <li className="cursor-pointer w-100" onClick={() => {handleSelect('Pexels'); setsearchTab('pexels')}}>
                                    <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                        <span>Pexels</span>
                                    </a>
                                </li>
                            </ul>
                        )}
                    </div>
                </span>
            </div>
        </div>

            {/* <hr style={{ margin: "0.5rem", color: "#fff" }} /> */}
            <div className="row mt-2" style={{ margin: "0px" }}>
              <div className="creator_PlaylistPlayer__menu userUploadVideo p-0 lcheck12" style={{ maxHeight: "25rem", overflowY: "auto", overflowX:"hidden"}}>
                {youtubeSearchLoader ? (
                  <div className="main_loader_box sd">
                    <div className="loader"><span></span><span></span><span></span><span></span><span></span></div>
                  </div>
                ) : showSearchVideo ? (<VideoLoader />) : (
					selectedOption !== 'Vimeo' ? 
                    <YoutubeListSection
                    allYoutubeSearchVideoData={allYoutubeSearchVideoData}
                    CurrentPlay = {CurrentPlay}
                    setCurrentPlay = {setCurrentPlay}
                    setYoutubePlay = {setYoutubePlay}
                    setVideoIndex = {setVideoIndex}
                    videoIndex = {videoIndex}
                    setYoutubePlayUrl = {setYoutubePlayUrl}
                    setYoutubeDatainState = {setYoutubeDatainState}
                    setYoutubePlayThumb = {setYoutubePlayThumb}
                    />
                   : 
                   <VimeoListSection
                    videoAllSearchData = {videoAllSearchData}
                    CurrentPlay = {CurrentPlay}
                    setYoutubePlay = {setYoutubePlay}
                    setCurrentPlay = {setCurrentPlay}
                    setYoutubePlayUrl = {setYoutubePlayUrl}
                    setYoutubeDatainState = {setYoutubeDatainState}
                   />
                )}
              </div>
            </div>
            <hr className="text-white mb-0" style={{ margin: "0.4rem"}} />
            <div className="row p-2">
              <div className="col-5">
                <div className=" todayList buttonPadding br-5 mp-0">
                  {searchTab == 'youtube' && searchKeyword != "" && prevPageToken != "" && prevPageToken != undefined || searchTab == 'vimeo' && searchKeyword != "" && vimeoPageNumber != 1 ? (
                    <button
                      // onClick={nextyoutuberesults}
                     onClick={(e) => {
                        if (searchTab === 'youtube') {
                            previousyoutuberesults(e);
                        } else {
                            setvimeoPageNumber(vimeoPageNumber - 1);
                            searchVideos(e);
                        }
                    }}
                      // onClick={previousyoutuberesults}
                      className="btn w-100  p-1 rounded-0 border-0 d-flex p-0 position-relative"
                    >
                      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="15 18 9 12 15 6"/></svg>
                      <span
                        className="m-auto text-white astroSpace"
                        style={{
                          textTransform: "uppercase",
                          fontSize: "90%",
                        }}
                      >
                        BACK
                      </span>
                    </button>
                  ) : (
                    <button
                      disabled
                      // onClick={previousyoutuberesults}
                      className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 13 position-relative"
                    >
                      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="15 18 9 12 15 6"/></svg>
                      <span
                        className="m-auto text-white astroSpace"
                        style={{
                          textTransform: "uppercase",
                          fontSize: "90%",
                        }}
                      >
                        BACK
                      </span>
                    </button>
                  )}
                </div>
              </div>
              <div className="col-2 p-0"></div>
              <div className="col-5">
                <div className=" todayList buttonPadding br-5 mp-0">
                  {searchKeyword != "" || searchVimeoKeyword != "" ? (
                    <button
                      onClick={(e) => {
                        if (searchTab === 'youtube') {
                            nextyoutuberesults(e);
                        } else {
                            setvimeoPageNumber(vimeoPageNumber + 1);
                            searchVideos({searchText: searchVimeoKeyword, section: searchSection});
                        }
                    }}
                      className="btn w-100  p-1 rounded-0 border-0 d-flex p-0 position-relative"
                    >
                      <span
                        className="m-auto text-white astroSpace"
                        style={{
                          textTransform: "uppercase",
                          fontSize: "90%",
                        }}
                      >
                        MORE
                      </span>
                      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="9 18 15 12 9 6"/></svg>
                    </button>
                  ) : (
                    <button
                      disabled
                      className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 14 position-relative"
                    >
                      <span
                        className="m-auto text-white astroSpace"
                        style={{
                          textTransform: "uppercase",
                          fontSize: "90%",
                        }}
                      >
                        MORE
                      </span>
                      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="9 18 15 12 9 6"/></svg>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* End Third Section */}

        {/* Add New Playlist */}

        {/* <Button variant="primary" onClick={handleShow}>
            Launch demo modal
          </Button> */}

                <Modal show={show.new_list} onHide={() => {handleClose('new_list');}}>
                    <Modal.Header closeButton>  
                    <Modal.Title>{editPlaylist ? 'Update' : 'Create New'} Playlist</Modal.Title>
                    </Modal.Header>
                    <form onSubmit={(e) => { e.preventDefault(); addNewPlaylistSubmit(); }} className="row g-3 m-0" >
                        <Modal.Body>
                            <div className="col-12">
                                <label className="form-label">Title</label>
                                <div className="input-group" id="show_hide_password">
                                <input
                                    onChange={(e) => setnewplaylistName(e.target.value)}
                                    value={newplaylistName}
                                    type="text"
                                    className="form-control border-end-0"
                                    id="inputChoosePassword"
                                    placeholder="Enter Playlist Name"
                                />
                                </div>
                            </div>

							<div className="col-12 mt-2">
                                <label className="form-label">Description</label>
                                <div className="input-group" id="show_hide_password">
								<textarea
									onChange={(e) => setnewplaylistDescription(e.target.value)}
									className="form-control border-end-0"
									placeholder="Enter Playlist Description"
								>{newplaylistDescription}</textarea>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                        <Button variant="secondary" onClick={() => {handleClose('new_list');setEditPlaylist(false);}}>
                            Close
                        </Button>
                        <button type="submit" className="btn btn-primary" > {editPlaylist ? 'Update' : 'Add'} Playlist </button>
                        </Modal.Footer>
                    </form>
                </Modal>

				<Modal show={show.playlistDesc} onHide={() => {handleClose('playlistDesc');}}>
                    <Modal.Header closeButton>
                    <Modal.Title>Update Playlist Description</Modal.Title>
                    </Modal.Header>
                    <form onSubmit={(e) => { e.preventDefault(); addNewPlaylistSubmit(); }} className="row g-3 m-0" >
                        <Modal.Body>
							<div className="col-12">
								<label className="form-label">Title</label>
								<div className="input-group" id="show_hide_password">
								<input
									onChange={(e) => setnewplaylistName(e.target.value)}
									value={newplaylistName}
									type="text"
									className="form-control border-end-0"
									id="inputChoosePassword"
									placeholder="Enter Playlist Name"
								/>
								</div>
							</div>

							<div className="col-12 mt-2">
								<label className="form-label">Description</label>
								<div className="input-group" id="show_hide_password">
								<textarea
									onChange={(e) => setnewplaylistDescription(e.target.value)}
									value={newplaylistDescription}
									className="form-control border-end-0"
									placeholder="Enter Playlist Description"
								>{newplaylistDescription}</textarea>
								</div>
							</div>
                        </Modal.Body>
                        <Modal.Footer>
                        <Button variant="secondary" onClick={() => {handleClose('playlistDesc');setEditPlaylist(false);}}>
                            Close
                        </Button>
                        <button type="submit" className="btn btn-primary" >Update</button>
                        </Modal.Footer>
                    </form>
                </Modal>
        {/* Upload Video */}
		<Modal show={show.user_media} onHide={() => {handleClose('user_media');}}>
			<Modal.Header closeButton>
			<Modal.Title>Intro Video</Modal.Title>
			</Modal.Header>
			<form onSubmit={(e) => onFormSubmit(e)} className="row g-3 m-0" >
				<Modal.Body>
					<div className="col-12">
						<label className="form-label">Choose Video</label>
						<div className="input-group" id="show_hide_password">
						<input
							onChange={(e) => setnewVideoVideo(e.target.files[0])}
							type="file"
							name="myImage"
							className=""
							accept="video/*"
						/>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button type="button" className="btn btn-secondary" onClick={() => {handleClose('user_media');}}> Close </button>
                    <button id="dismissModel" type="submit" className="btn btn-primary" > Upload </button>
				</Modal.Footer>
			</form>
		</Modal>

		<Modal show={show.saved_csv} onHide={() => {handleClose('saved_csv');}} centered>
			<Modal.Header closeButton>
			<Modal.Title>Saved online.</Modal.Title>
			</Modal.Header>
			<Modal.Body>Your playlist has been saved online. You can also download a CSV copy to your device.</Modal.Body>
			<Modal.Footer className="mt-0">
				<button type="button" className="btn btn-secondary" onClick={() => {handleClose('saved_csv');}}>OK</button>
				<button type="button" className="btn btn-primary" onClick={() => {exportPlaylistCSV(); handleClose('saved_csv');}}>.csv</button>
			</Modal.Footer>
		</Modal>
		<Modal show={show.user_media_url} onHide={() => {handleClose('user_media_url');}}>
            <Modal.Header closeButton>
            <Modal.Title>Add User Media Video</Modal.Title>
            </Modal.Header>
                <Modal.Body>
                    <form
                       onSubmit={(e) => onFormSubmitUserMedia(e)}
                    >
                      <div className="form-group">
                        <label>Embed Video</label>
                        <input
                          id="EmbadeCodeInputId"
                          type="text"
                          className="form-control"
                          aria-describedby="emailHelp"
                          placeholder="Enter Video Embed Code"
                          onChange={(e) => setembedInputUserMedia(e.target.value)}
                          value={embedInputUserMedia}
                        />
                      </div>
                    </form>
                </Modal.Body>
                <Modal.Footer className="mt-0">
                  <button
                    onClick={()=> {EmptyCopy(); handleClose('user_media_url');}}
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>

                  <button
                    onClick={onFormSubmitUserMedia}
                    type="button"
                    className="btn btn-primary"
                  >
                    Add Video
                  </button>
                </Modal.Footer>
        </Modal>
        {/* <div
          className="modal fade"
          id="uploadVideo"
          data-bs-backdrop="false"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title " id="staticBackdropLabel"> 
                  Intro Video
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={(e) => onFormSubmit(e)}>
                  <div className="col-12">
                    <label className="form-label">Choose Video</label>
                    <div className="input-group" id="show_hide_password">
                      <input
                        onChange={(e) => setnewVideoVideo(e.target.files[0])}
                        type="file"
                        name="myImage"
                        className=""
                        accept="video/*"
                      />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      id="dismissModel"
                      data-bs-dismiss="modal"
                      type="submit"
                      className="btn btn-primary"
                    >
                      Upload
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div> */}
        {/* Please Login */}
        <div
          className="modal fade"
          id="LoginModal"
          data-bs-backdrop="false"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  Warning
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <h3>Please Login First !! </h3>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Add Embed Code */}
        <Modal show={show.past_url} onHide={() => {handleClose('past_url');}}>
            <Modal.Header closeButton>
            <Modal.Title>Add Embed Code Video</Modal.Title>
            </Modal.Header>
                <Modal.Body>
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        addEmbedVideoInTeampPlayList();
                      }}
                    >
                      <div className="form-group">
                        <label>Video Embed Code</label>
                        <input
                          id="EmbadeCodeInputId"
                          type="text"
                          className="form-control"
                          aria-describedby="emailHelp"
                          placeholder="Paste Embed Code Here"
                          onChange={(e) => setembedInput(e.target.value)}
                          value={embedInput}
                        />
                      </div>
                    </form>
                </Modal.Body>
                <Modal.Footer className="mt-0">
                  <button
                    onClick={()=> {EmptyCopy(); handleClose('past_url');}}
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>

                  <button
                    data-bs-dismiss="modal"
                    onClick={addEmbedVideoInTeampPlayList}
                    type="button"
                    className="btn btn-primary"
                  >
                    Add Video
                  </button>
                </Modal.Footer>
        </Modal>

        {/* Share Playlist */}
        {/* Add Embed Code */}

        <Modal show={show.share_list} onHide={() => {handleClose('share_list');}}>
            <Modal.Header closeButton>
            <Modal.Title>Share</Modal.Title>
            </Modal.Header>
            <form onSubmit={(e) => { e.preventDefault(); addNewPlaylistSubmit(); }} className="row g-3" >
                <Modal.Body>
                    <div className="row">
                  <div className="col-9">
                      {sharedPlaylist?._id !== undefined ? (
						<>
							<div className="d-flex justify-content-center">
								<FacebookShareButton url={reactAppUrl+"/playlist?id=" +currentPlaylist?._id}>
									<FacebookIcon size={35} round className="mx-2" />
								</FacebookShareButton>
								<TwitterShareButton url={reactAppUrl+"/playlist?id=" +currentPlaylist?._id}>
									<TwitterIcon size={35} round className="mx-2"  />
								</TwitterShareButton>
								<LinkedinShareButton url={reactAppUrl+"/playlist?id=" +currentPlaylist?._id}>
									<LinkedinIcon size={35} round className="mx-2"  />
								</LinkedinShareButton>
								<RedditShareButton url={reactAppUrl+"/playlist?id=" +currentPlaylist?._id}>
									<RedditIcon size={35} round className="mx-2"  />
								</RedditShareButton>
							</div>
						</>
                      ) : (
                        ""
                      )}
                  </div>
                  <div className="col-2">
                    <button
						style={{ cursor: "pointer" }}
						type="button"
						className="btn btn-primary m-0"
						onClick={() => {
							handleClose('share_list');
							setTimeout(() => {
								handleShow('embed_code');
								EmptyCopy();
							}, 0);
						}}
                    >
                      Embed
                    </button>
                  </div>
                </div>
                </Modal.Body>
                <Modal.Footer className="mt-0">
                <div>
                  {sharedPlaylist ? (
                    <form>
                      <div className="row">
                        <div className="col-8">
                          <input
                            style={{ width: "100%" }}
                            className="m-2"
                            ref={textAreaRef}
                            value={
                              reactAppUrl+"/playlist?id=" +
                              sharedPlaylist._id
                            }
                          />
                        </div>
                        <div className="col-4">
                          {document.queryCommandSupported("copy") && (
                            <div>
                              {" "}
                              <button
                                type="button"
								data-type="textAreaRef"
                                style={{ height: "30px", paddingTop: "2px" }}
                                className="btn btn-dark m-2"
                                onClick={copyToClipboard}
                              >
                                Copy
                              </button>{" "}
                              {copySuccess}
                            </div>
                          )}
                        </div>
                      </div>
                    </form>
                  ) : (
                    ""
                  )}
                </div>
                </Modal.Footer>
            </form>
        </Modal>
        <div
          className="modal fade"
          id="sharePlaylist"
          data-bs-backdrop="false"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  Share
                </h5>
                <button
                  onClick={EmptyCopy}
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-9">
                      {currentPlaylist?._id !== undefined ? (
							<div className="d-flex justify-content-center">
								<FacebookShareButton url={reactAppUrl+"/playlist?id=" +currentPlaylist._id}>
									<FacebookIcon size={35} round className="mx-2" />
								</FacebookShareButton>
								<TwitterShareButton url={reactAppUrl+"/playlist?id=" +currentPlaylist._id}>
									<TwitterIcon size={35} round className="mx-2"  />
								</TwitterShareButton>
								<LinkedinShareButton url={reactAppUrl+"/playlist?id=" +currentPlaylist._id}>
									<LinkedinIcon size={35} round className="mx-2"  />
								</LinkedinShareButton>
								<RedditShareButton url={reactAppUrl+"/playlist?id=" +currentPlaylist._id}>
									<RedditIcon size={35} round className="mx-2"  />
								</RedditShareButton>
							</div>
                      ) : (
                        ""
                      )}
                  </div>
                  <div className="col-2">
                    <button
                      data-bs-dismiss="modal"
                      style={{ marginTop: "27px", cursor: "pointer" }}
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal1"
                      className="btn btn-primary"
                      onClick={EmptyCopy}
                    >
                      Embed
                    </button>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div>
                  {currentPlaylist ? (
                    <form>
                      <div className="row">
                        <div className="col-8">
                          <input
                            style={{ width: "100%" }}
                            className="m-2"
                            ref={textAreaRef}
                            value={
                              reactAppUrl+"/playlist?id=" +
                              currentPlaylist._id
                            }
                          />
                        </div>
                        <div className="col-4">
                          {document.queryCommandSupported("copy") && (
                            <div>
                              {" "}
                              <button
                                type="button"
								data-type="textAreaRef"
                                style={{ height: "30px", paddingTop: "2px" }}
                                className="btn btn-dark m-2"
                                onClick={copyToClipboard}
                              >
                                Copy
                              </button>{" "}
                              {copySuccess}
                            </div>
                          )}
                        </div>
                      </div>
                    </form>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="row todayList mpt-1 m-border-0 md-none" 
        style={{ borderTop: "none", borderLeft: "none" }}
      >
        <div className="col-12 col-lg-3 col-sm-12 col-xs-12 order-lg-1 order-sm-second">
          <div className="todayList borderRadius lcheck54" style={{padding: "0"}}>
            <div className="row m-0" style={{padding: ".5rem 1rem 0"}}>
              <div className="col-6">
                <div className="todayList" style={{ borderRadius: "2px" }}>
                <button
                  style={{ outline: "none !important", margin: "-6px" }}
                  className="btn w-100 p-1 text-white rounded-0 border-0 d-flex pt-0 pb-0"
                >
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"17px",height:"17px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><path d="M4 6h16"/><path d="M4 10h16"/><path d="M4 14h10"/><polygon points="16 14 22 18 16 22 16 14"/></svg>
                  <span className="m-auto astroSpace" style={{ textTransform: "uppercase", fontSize: "90%" }}>Playlists</span>
                </button>
                </div>
              </div>
              <div className="col-6">
                <div className="todayList" style={{ borderRadius: "2px" }}>
                <label
                  style={{ outline: "none !important", margin: "-6px", cursor: "pointer" }}
                  className="btn w-100 p-1 text-white rounded-0 border-0 d-flex pt-0 pb-0"
                >
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"17px",height:"17px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                  <span className="m-auto astroSpace" style={{ textTransform: "uppercase", fontSize: "90%" }}>Import</span>
                  <input type="file" accept=".csv" style={{ display: "none" }} onChange={(e) => { handleCsvImport(e.target.files[0], () => { e.target.value = ''; }); }} />
                </label>
                </div>
              </div>
			
            </div>
              <div className="creator_PlaylistPlayer__playlists p-0 bt-1" style={{padding: 0, margin: 0, borderRadius: 0}}>
                {/* <hr style={{ margin: "0.5rem", color: "#fff" }} /> */}
				
                {playlists?.length == 0 ||
                  (playlists?.[0]?.title == "Temp" && playlists?.length == 1) ? (
                  <img
                    src={require("../asset/images/NothingImgAdd.png")}
                    className="img-fluid m-0 p-0"
                    alt=""
                    style={{ width: "100%", height: "80%" }}
                  />
                ) : (
                  playlists?.map((playlist, index) =>
                    isLogin != null && playlist.title != "Temp" && playlist?.users[0]?._id == loginId ? (
                      <>
                        <div
                          key={playlist._id || index}
                          className={`playlist_main_box new-${playlist._id}`}
                          style={{position: "relative", width: "100%", cursor: "grab"}}
                          draggable="true"
                          onDragStart={(e) => handlePlaylistDragStart(e, index)}
                          onDragEnd={handlePlaylistDragEnd}
                          onDragOver={handlePlaylistDragOver}
                          onDragLeave={handlePlaylistDragLeave}
                          onDrop={(e) => handlePlaylistDrop(e, index)}
                        >
                          <PlaylistButton
                            playlist={playlist}
                            onClick={() => {
                              setPlaylistIndex(index);
                              setVideoIndex(0);
                              changePalylistData(index);
                            }}
                            active={index === playlistIndex}
                            deletePlaylist = {() => {deleteCurrentPlaylist(playlist)}}
                            totalViews = {GetViews(playlist)}
                            shared = {()=> {setsharedPlaylist(playlist); EmptyCopy();  handleShow('share_list');}}
							rerender={playlistsSequenceStatus}
                          />
                         

						  <ul
                              className="icons vertical-justify px-2 playlist-button-border bg-dark cursor-pointer" draggable="false"
                              style={{
                                height: "100%",
                                position: "absolute",
                                top: "0",
                                right: "0",
                                listStyle: "none",
                                bottom:"0",
                                margin:"0"
                              }}
                            >
							{/*<li className="text-center" onClick={() => {setPlaylistOrderSequence(index, 'up');}}>
                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"15px",height:"15px",stroke:"white",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><polyline points="18 15 12 9 6 15"/></svg>
							</li>*/}
							<li
							  className="text-center"
							  style={{
								opacity: playlists.findIndex(p => p._id === playlist._id) === 0 ? 0.3 : 1,
								pointerEvents: playlists.findIndex(p => p._id === playlist._id) === 0 ? 'none' : 'auto',
							  }}
							  onClick={(e) => {
									const currentIndex = playlists.findIndex(p => p._id === playlist._id);
									if (currentIndex === 0) return; // 🛑 don’t allow move
									setPlaylistOrderSequence(playlist._id, 'up',e);
								  }}
							>
								  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"15px",height:"15px",stroke:"white",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><polyline points="18 15 12 9 6 15"/></svg>
								</li>
                              <li className="text-center" style={{ cursor: "grab" }}>
                                <svg viewBox="0 0 12 16" xmlns="http://www.w3.org/2000/svg" stroke="white" strokeWidth="1.5" fill="none" style={{ width: "14px", height: "16px", opacity: 0.4 }}>
                                  <line x1="2" y1="4" x2="10" y2="4"/><line x1="2" y1="7" x2="10" y2="7"/><line x1="2" y1="10" x2="10" y2="10"/><line x1="2" y1="13" x2="10" y2="13"/>
                                </svg>
                              </li>
                              {/* <li onClick={() => tempPlayListVideoRemove(index)}>
                                <img
                                  src={require("../asset/images/Minus.webp")}
                                  className="img-fluid"
                                  alt=""
                                  style={{ width: "19px" }}
                                />
                              </li> */}
                              {/*<li className="text-center" onClick={() => {setPlaylistOrderSequence(index, 'down');}}>
                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"15px",height:"15px",stroke:"white",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><polyline points="6 9 12 15 18 9"/></svg>
                              </li>*/}
							 <li
								  className="text-center"
								 style={{
									opacity:
									  playlists.findIndex(p => p._id === playlist._id) === playlists.length - 1
										? 0.3
										: 1,
									pointerEvents:
									  playlists.findIndex(p => p._id === playlist._id) === playlists.length - 1
										? 'none'
										: 'auto',
								  }}
								  onClick={(e) => {
									const currentIndex = playlists.findIndex(p => p._id === playlist._id);
									if (currentIndex === playlists.length - 1) return; // 🛑 don’t allow move
									setPlaylistOrderSequence(playlist._id, 'down', e);
								  }}
								> 
							  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"15px",height:"15px",stroke:"white",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><polyline points="6 9 12 15 18 9"/></svg>
							</li>
                            </ul>
                          {/* Play overlay on hover */}
                          <div className="playlist-play-overlay" onClick={() => {
                            setVideoIndex(0);
                            setPlaylistIndex(index);
                            changePalylistData(index);
                          }}>
                            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polygon points="5,3 19,12 5,21"/></svg>
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  )
                )}
              </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 col-sm-12 col-xs-12 order-lg-2 order-sm-last mp-0 mmt-3">
          <div className="todayList borderRadius p-0 pt-3" style={{padding: "8px"}}>
            <div className="row m-0" style={{borderBottom: "1px solid rgba(255,255,255,0.10)", paddingBottom: "8px", marginBottom: "6px"}}>
              <div className="col-4 mpx-2">
                <div className="todayList  buttonPadding br-5 mp-0 h-100">

                  <button
                    onClick={() => { redirectNorLogin(); handleShow('user_media_url'); }}
                    className="btn w-100  rounded-0 border-0 d-flex p-0 p-1 position-relative h-100"
                  >
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"18px",height:"18px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.55,flexShrink:0}}><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1.5"/></svg>
                    <span
                      className="m-auto astroSpace mps-4"
                      style={{
                        textTransform: "uppercase",
                        fontSize: "90%",
                        color: "white",
                      }}
                    >

                      User Media
                    </span>
                  </button>

                </div>
              </div>
              <div className="col-4 mpx-2">
                <div className="todayList  buttonPadding br-5 mp-0 h-100">
                  <button
                    // onClick={randomizePlaylist}
					onClick={() => { window.location.href = 'https://tvavi.com/guides'; }}
                    className="btn w-100  rounded-0 border-0 d-flex p-1 position-relative h-100"
                  >
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"18px",height:"18px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.55,flexShrink:0}}><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/><line x1="8" y1="7" x2="16" y2="7"/><line x1="8" y1="11" x2="13" y2="11"/></svg>
                    <span
                      className="m-auto astroSpace mps-4"
                      style={{
                        textTransform: "uppercase",
                        fontSize: "90%",
                        color: "white",
                      }}
                    >
                      Guides
                    </span>
                  </button>
                </div>
              </div>
              <div className="col-4 mpx-2">
                <div className="todayList  buttonPadding br-5 mp-0 h-100">
                  <button
                    // onClick={randomizePlaylist}
					onClick={() => { window.location.href = 'https://tvavi.com/market'; }}
                    className="btn w-100  rounded-0 border-0 d-flex p-1 position-relative  h-100"
                  >
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"18px",height:"18px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.55,flexShrink:0}}><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
                    <span
                      className="m-auto astroSpace mps-4"
                      style={{
                        textTransform: "uppercase",
                        fontSize: "90%",
                        color: "white",
                      }}
                    >
                      Market
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div>

              <div className="mt-1 p-0 user_media_container" style={{maxHeight:"31.2rem", overflow:"auto"}}> 
                {uploadIntroLoader ? (
                  <div className="main_loader_box">
                    <h5
                      style={{
                        lineHeight: "11px",
                        margin: "20px",
                        color: "#fff",
                      }}
                    >
                      Uploading
                    </h5>
                    <div className="loader">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                ) : (
                //   <DataTable
                //     style={{ background: "transparent" }}
                //     title=""
                //     columns={columns}
                //     data={IntroVideoArr}
                //     defaultSortFieldId={1}
                //     // sortIcon={<ArrowUpwardIcon />}
                //     pagination
                //   // selectableRows
                //   // onSelectedRowsChange={handleChange}
                //   />
					
				userMedia.length ? userMedia.map((val, index) => (
					<div key={index} lassName="mainBox" style={{ position: "relative" }}
					>
					<div className="creator_VideoBadge playlist-border bs-0 be-0 mb-0 user_media_list_box py-2 user_media_playlist ">
						<div
						className="creator_VideoBadge__logo br-10 ms-2"
						style={{ backgroundImage: `url(${val.thumbnail})` }}
						/>
						<div
						className="creator_VideoBadge__info lcheck3" 
						style={{ padding: "3px", width:"100%" }}
						>
						<div className="info user_media">
							<p
							style={{
								lineHeight: "11px",
								fontSize: "10px",
								margin: "2px",
								color: "#fff",
							}}
							>

							<div style={{ fontSize: "20px" }} title="title">
								<marquee className="pb-2 pt-1" scrollamount={3}> {val.title} </marquee>
							</div>
							{/* <h6>{video.name
								? <marquee scrollamount="3">{video.name}</marquee>
								: ""}</h6> */}


							{/* {video.description
								? video.description.slice(0, 75) + "..."
								: ""} */}
								<div className="playlist_ellipsis mb-2" style={{ lineHeight: "40px", fontSize:"15px" }}>
									{val.description}
								</div>
							{/* <br />
							<img
								src={require("../asset/images/ButtonNotLike.png")}
								className="img-fluid"
								alt=""
								style={{ width: "20px", cursor: "pointer" }}
							/>{" "}
							{video.metadata.connections.likes.total}
							<br />
							play@:
							{moment("2015-01-01")
								.startOf("day")
								.seconds(video.duration)
								.format("H:mm:ss")} */}

								<div className="text-white">
								<div className="d-inline me-1" data-id={val._id} onClick={() => {removeUserMedia(val._id);}}>
									<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"22px",height:"22px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><circle cx="12" cy="12" r="10"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
								</div>
								<div className="d-inline ms-3 me-1 float-end user_media_add_url_box common-border rounded overflow-hidden" style={{width:"8rem"}}>
									<button
                      onClick={() => {redirectNorLogin(); handleShow('user_media_url');}}
                      className="btn w-100 p-1 rounded-0 border-0 d-flex p-0 2"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: "16px", height: "16px" }}><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
                      <span
                        className="m-auto text-white astroSpace"
                        style={{
                          textTransform: "uppercase",
                          fontSize: "90%",
                        }}
                      >
                        + Add Video
                      </span>
                    </button>
								</div>
							</div>
							</p>
						</div>
						</div>
					</div>
					<ul
						className="icons playlist-border bt-0 bb-0 bs-0 user_media_playlist_button_box">

						<li
							style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							margin: "10px 0"
							}}
							onClick={() => {
								setCurrentPlay(getId(val.url));
								setYoutubePlay(true);
								setVideoIndex(videoIndex);
								setYoutubePlayUrl(val.url);
							}}
						>
						<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"16px",height:"16px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><rect x="2" y="2" width="20" height="20" rx="4" ry="4"/><polygon points="10 8 16 12 10 16 10 8" style={{fill:"rgba(255,255,255,0.8)",stroke:"none"}}/></svg>
						</li>

						<li
						
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							margin: "10px 0"
							}}
							 onClick={() => {addToPlaylist(val.url);}}
						>
						<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"16px",height:"16px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
						</li>
					</ul>
					</div>
				)) : 
					<div class="row m-0">
					<div class="col-12 mpx-2">
						<div class="todayList  buttonPadding p-2 text-white text-center">No Video Added.</div>
					</div>
					</div>
                )}

              </div>

            </div>
            {/* {currentPlaylist ? (
              JSON.parse(sessionStorage.getItem("userDetails")) != null &&
                currentPlaylist.users[0] != null &&
                JSON.parse(sessionStorage.getItem("userDetails")).user_id ==
                currentPlaylist.users[0]._id ? (
                <div className="">
                  <div className="row">
                    <div className="col-4">
                      <div className="todayList  buttonPadding">
                        {isLogin != null ? (
                          <button
                            data-bs-toggle="modal"
                            data-bs-target="#uploadVideo"
                            className="btn w-100  rounded-0 border-0 d-flex p-0 p-1"
                          >
                            <img
                              src={require("../asset/images/LensPlus.webp")}
                              className="img-fluid"
                              alt=""
                              style={{ width: "30px" }}
                            />
                            <span
                              className="m-auto astroSpace"
                              style={{
                                textTransform: "uppercase",
                                fontSize: "90%",
                                color: "white",
                              }}
                            >
                              {currentPlaylist.introVideo
                                ? "USER MEDIA"
                                : "USER MEDIA"}
                            </span>
                          </button>
                        ) : (
                          <button
                            onClick={redirectNorLogin}
                            className="btn w-100 btn-light rounded-0 border-0 d-flex p-0 p-1"
                          >
                            <img
                              src={require("../asset/images/LensPlus.webp")}
                              className="img-fluid"
                              alt=""
                              style={{ width: "35px" }}
                            />
                            <span
                              className="m-auto astroSpace"
                              style={{
                                textTransform: "uppercase",
                                fontSize: "90%",
                                color: "white",
                              }}
                            >
                              {currentPlaylist.introVideo
                                ? "USER MEDIA"
                                : "USER MEDIA"}
                            </span>
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="todayList  buttonPadding">
                        <button
                          onClick={randomizePlaylist}
                          className="btn w-100  rounded-0 border-0 d-flex p-1"
                        >
                          <img
                            src={require("../asset/images/Graph.webp")}
                            className="img-fluid"
                            alt=""
                            style={{ width: "17px" }}
                          />
                          <span
                            className="m-auto astroSpace"
                            style={{
                              textTransform: "uppercase",
                              fontSize: "90%",
                              color: "white",
                            }}
                          >
                            ADS/STATS
                          </span>
                        </button>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="todayList  buttonPadding">
                        <button
                          onClick={randomizePlaylist}
                          className="btn w-100  rounded-0 border-0 d-flex p-1"
                        >
                          <img
                            src={require("../asset/images/Star.webp")}
                            className="img-fluid"
                            alt=""
                            style={{ width: "27px" }}
                          />
                          <span
                            className="m-auto astroSpace"
                            style={{
                              textTransform: "uppercase",
                              fontSize: "90%",
                              color: "white",
                            }}
                          >
                            MARKETPLACE
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <hr style={{ margin: "0.5rem", color: "#fff" }} />
                  {uploadIntroLoader ? (
                    <div className="main_loader_box">
                      <h5
                        style={{
                          lineHeight: "11px",
                          margin: "20px",
                          color: "#fff",
                        }}
                      >
                        Uploading
                      </h5>
                      <div className="loader">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {isLogin == null ? (
                    ""
                  ) : (
                    <div>
                      {JSON.parse(sessionStorage.getItem("userDetails"))
                        .user_id == currentPlaylist.users[0]._id ? (
                        <div className="container mt-3">
                          {currentPlaylist ? (
                            currentPlaylist.introVideo != null ? (
                              <div>
                                <div
                                  className="creator_PlaylistPlayer__player-wrapper"
                                  style={{ position: "relative" }}
                                >
                                  <ReactPlayer
                                    url={require("../asset/introvideo/" +
                                      currentPlaylist.introVideo)}
                                    className="creator_PlaylistPlayer__player"
                                    width="100%"
                                    height="100%"
                                  />
                                  <div
                                    className="inroDiv"
                                    style={{
                                      position: "absolute",
                                      left: "0",
                                      top: "0",
                                      background: "rgba(0,0,0,0.5)",
                                      width: "100%",
                                      height: "100%",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                    }}
                                  >
                                    <button
                                      onClick={() => {
                                        setYoutubePlay(true);
                                        setYoutubePlayUrl(
                                          require("../asset/introvideo/" +
                                            currentPlaylist.introVideo)
                                        );
                                      }}
                                      className="btn btn-primary mx-2"
                                    >
                                      Play Intro Video
                                    </button>
                                    <button
                                      onClick={DeleteIntro}
                                      className="btn btn-danger"
                                    >
                                      Delete Intro Video
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                </div>
              ) : (
                ""
              )
            ) : (
              ""
            )} */}
          </div>
        </div>
        <div onClick={() => {
          setsearchSection("down");
        }} className="col-12 col-lg-3 col-sm-12 col-xs-12 order-lg-3 order-sm-first p-0 mmb-3 md-none">
          <div className="todayList borderRadius p-0 overflow-hidden lcheck55">
            <div className="">
              <div className="row">
                <div className="col-12">
                  <div className="todayList  buttonPadding border-0 mp-0">
                    <form
                        onSubmit={(e) => searchVideos(e)}
                         ref={formRefDown}
                        className="d-flex youtube-search-form"
                        data-section="down"
                    >
					<div className="search-box p-2">
                         <button type="submit" className="border-0 bg-transparent p-0 m-0">
                            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"16px",height:"16px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                        </button>
					</div>
                      <input
                        onChange={(e) => {searchTabDown === 'vimeo' ? setSearchVimeoKeyword(e.target.value) : setSearchKeyword(e.target.value)}}
                        type="text"
                        placeholder='Search'
                        name="youtubesearch"
                        style={{
							outline: "none",
							background: "transparent",
							color: "white",
							border: "transparent",
							fontSize: "13px"
                        }}
                        className="w-100 p-2"
                      />
                    </form>
                  </div>
                </div>
              </div>

                <div className="row m-0 text-white playlist-border br-5 mt-2 mx-2">
                    <div className="pe-0 playlist-title text-center w-10">
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"16px",height:"16px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><path d="M4 6h16"/><path d="M4 10h16"/><path d="M4 14h10"/><path d="M16 14l7 4-7 4z"/></svg>
                    </div>
                    <div className="d-flex align-items-center w-90 position-relative cursor-pointer" style={{ padding: "0", paddingLeft: ".75rem" }}>
                    <span className="flex-grow-1 fs-5">
                        <div className="custom-dropdown" ref={dropdownRefDown}>
                            <div
                                className="search_dropdown"
                                onClick={() => setIsOpenDown(!isOpenDown)}
                            >
                                {selectedOptionDown}
                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"12px",height:"12px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.45,flexShrink:0}}><polyline points="6 9 12 15 18 9"/></svg>
                            </div>
                            {isOpenDown && (
                                <ul className="CustomDropdown rounded w-100" style={{maxHeight:"400px",overflowY:"auto"}}>
                                    <li className="cursor-pointer w-100" onClick={() => {handleSelectDown('Search All'); setsearchTabDown('all')}}>
                                        <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                            <span>Search All</span>
                                        </a>
                                    </li>
                                    <li className="cursor-pointer w-100" onClick={() => {handleSelectDown('YouTube'); setsearchTabDown('youtube')}}>
                                        <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                            <span>YouTube</span>
                                        </a>
                                    </li>
                                    <li className="cursor-pointer w-100" onClick={() => {handleSelectDown('Vimeo'); setsearchTabDown('vimeo')}}>
                                        <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                            <span>Vimeo</span>
                                        </a>
                                    </li>
                                    <li className="cursor-pointer w-100" onClick={() => {handleSelectDown('Archive.org'); setsearchTabDown('archiveorg')}}>
                                        <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                            <span>Archive.org</span>
                                        </a>
                                    </li>
                                    <li className="cursor-pointer w-100" onClick={() => {handleSelectDown('Wikimedia'); setsearchTabDown('wikimedia')}}>
                                        <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                            <span>Wikimedia</span>
                                        </a>
                                    </li>
                                    <li className="cursor-pointer w-100" onClick={() => {handleSelectDown('PeerTube'); setsearchTabDown('peertube')}}>
                                        <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                            <span>PeerTube</span>
                                        </a>
                                    </li>
                                    <li className="cursor-pointer w-100" onClick={() => {handleSelectDown('Dailymotion'); setsearchTabDown('dailymotion')}}>
                                        <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                            <span>Dailymotion</span>
                                        </a>
                                    </li>
                                    <li className="cursor-pointer w-100" onClick={() => {handleSelectDown('Odysee'); setsearchTabDown('odysee')}}>
                                        <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                            <span>Odysee</span>
                                        </a>
                                    </li>
                                    <li className="cursor-pointer w-100" onClick={() => {handleSelectDown('Twitch Clips'); setsearchTabDown('twitch')}}>
                                        <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                            <span>Twitch Clips</span>
                                        </a>
                                    </li>
                                    <li className="cursor-pointer w-100" onClick={() => {handleSelectDown('Audius (audio)'); setsearchTabDown('audius')}}>
                                        <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                            <span>Audius (audio)</span>
                                        </a>
                                    </li>
                                    <li className="cursor-pointer w-100" onClick={() => {handleSelectDown('Pixabay'); setsearchTabDown('pixabay')}}>
                                        <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                            <span>Pixabay</span>
                                        </a>
                                    </li>
                                    <li className="cursor-pointer w-100" onClick={() => {handleSelectDown('Pexels'); setsearchTabDown('pexels')}}>
                                        <a className="" href="#" onClick={(e) => {e.preventDefault();}}>
                                            <span>Pexels</span>
                                        </a>
                                    </li>
                                </ul>
                            )}
                        </div>
                    </span>
                </div>
                </div>
                
              {/* <hr style={{ margin: "0.5rem", color: "#fff" }} /> */}
              <div className="row mt-2">
                <div className="creator_PlaylistPlayer__menu userUploadVideo lcheck11">
                  {vimeoSearchLoader ? (
                    <div className="main_loader_box">
                      <div className="loader">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                  ) : videoAllSearchDataDown.length != 0 || allYoutubeSearchVideoDataDown.length != 0 ? (
                    selectedOptionDown !== 'Vimeo' ? 
                    <YoutubeListSection
                        allYoutubeSearchVideoData={allYoutubeSearchVideoDataDown}
                        CurrentPlay = {CurrentPlay}
                        setCurrentPlay = {setCurrentPlay}
                        setYoutubePlay = {setYoutubePlay}
                        setVideoIndex = {setVideoIndex}
                        videoIndex = {videoIndex}
                        setYoutubePlayUrl = {setYoutubePlayUrl}
                        setYoutubeDatainState = {setYoutubeDatainState}
                        />
                    : 
                    <VimeoListSection
                        videoAllSearchData = {videoAllSearchDataDown}
                        CurrentPlay = {CurrentPlay}
                        setYoutubePlay = {setYoutubePlay}
                        setCurrentPlay = {setCurrentPlay}
                        setYoutubePlayUrl = {setYoutubePlayUrl}
                        setYoutubeDatainState = {setYoutubeDatainState}
                    setYoutubePlayThumb = {setYoutubePlayThumb}
                    />
                  ) : (
                    <VideoLoader />
                  )}
                </div>
              </div>
              <div style={{ borderTop: "1px solid rgba(255,255,255,0.15)", margin: "0" }}></div>
              <div className="row p-2">
                <div className="col-5">
                  <div className=" todayList buttonPadding br-5 mp-0">
                        {searchTabDown == 'youtube' && searchVimeoKeyword != "" && prevPageTokenDown != "" && prevPageTokenDown != undefined || searchTabDown == 'vimeo' && searchVimeoKeyword != "" && vimeoPageNumberDown != 1 ? (
                      <button
                         onClick={(e) => {
                            if (searchTabDown === 'youtube') {
                                previousyoutuberesults(e);
                            } else {
                                // setvimeoPageNumberDown(vimeoPageNumberDown - 1);
                                setvimeoPageNumberDown((vimeoPageNumber) => {
                                    const newPageNumber = vimeoPageNumber - 1;
                                    return newPageNumber < 1 ? 1 : newPageNumber;
                                });
                                searchVideos(e);
                            }
                        }}
                        className="btn w-100 p-1  rounded-0 border-0 d-flex p-0 position-relative"
                      >
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="15 18 9 12 15 6"/></svg>
                        <span
                          className="m-auto text-white astroSpace"
                          style={{
                            textTransform: "uppercase",
                            fontSize: "90%",
                          }}
                        >
                          BACK
                        </span>
                      </button>
                    ) : (
                      <button
                        disabled
                        className="btn w-100 p-1  rounded-0 border-0 d-flex p-0 position-relative"
                      >
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="15 18 9 12 15 6"/></svg>
                        <span
                          className="m-auto text-white astroSpace"
                          style={{
                            textTransform: "uppercase",
                            fontSize: "90%",
                          }}
                        >
                          BACK
                        </span>
                      </button>
                    )}
                  </div>
                </div>
                <div className="col-2 p-0"></div>
                <div className="col-5">
                  <div className=" todayList buttonPadding br-5 mp-0">
                    {searchVimeoKeyword != "" ? (
                      /*
  <button
                        onClick={(e) => {
                            if (searchTabDown === 'youtube') {
                                nextyoutuberesults(e);
                            } else {
                               setvimeoPageNumberDown(vimeoPageNumberDown + 1);
                                // searchVimeoVideo(e)
                                
                            }
                        }}
                        className="btn w-100 p-1  rounded-0 border-0 d-flex p-0 position-relative"
                      >   
                        <span
                          className="m-auto text-white astroSpace"
                          style={{
                            textTransform: "uppercase",
                            fontSize: "90%",
                          }}
                        >
                          MORE 
                        </span>
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="9 18 15 12 9 6"/></svg>
                      </button>
                      */
                    <button
  onClick={(e) => {
    if (searchTabDown === 'youtube') {
      nextyoutuberesults(e);
    } else {
      setvimeoPageNumberDown(vimeoPageNumberDown + 1);
      searchVimeoVideo({
        searchText: searchVimeoKeyword, // make sure this is coming from state
        section: 'down',
      });
    }
  }}
  className="btn w-100 p-1  rounded-0 border-0 d-flex p-0 position-relative"
>   
  <span
    className="m-auto text-white astroSpace"
    style={{
      textTransform: "uppercase",
      fontSize: "90%",
    }}
  >
    MORE 
  </span>
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="9 18 15 12 9 6"/></svg>
</button>

                    ) : (
                      <button
                        disabled
                        className="btn w-100 p-1  rounded-0 border-0 d-flex p-0 position-relative"
                      >
                        <span
                          className="m-auto text-white astroSpace"
                          style={{
                            textTransform: "uppercase",
                            fontSize: "90%",
                          }}
                        >
                          MORE
                        </span>
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><polyline points="9 18 15 12 9 6"/></svg>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
const VideoBadge = ({ video, onClick, active }) => {
  const className = classnames({
    creator_VideoBadge: true,
    "creator_VideoBadge--clickable": onClick,
    "creator_VideoBadge--active": active,
  });
  return (
    <div className={className} onClick={onClick}>
      {/* <div
        className="creator_VideoBadge__logo"
        style={{ backgroundImage: `url(${video.thumbnail})` }}
      />
      <div className="creator_VideoBadge__info" style={{ padding: "3px" }}>
        <div className="info">
          <p
            style={{
              lineHeight: "11px",
              fontSize: "10px",
              margin: "2px",
              color: "#fff",
            }}
          >
            {video.title}
            <br />
            {video.channel_name}/Youtube - {video.posted_date}
            <br />
            {video.views} views - {video.likes} likes <br />
            category : {video.category}
            <br />
            duration : {video.duration}
          </p>
        </div>
      </div> */}
    </div>
  );
};
const PlaylistButton = ({ playlist, onClick, active, deletePlaylist, totalViews,shared,rerender }) => {
  const className = classnames({
    creator_PlaylistButton: true,
    "creator_PlaylistButton--active": active,
  });
  return (
    <>
      <div
        style={{ display: "flex", width: "100%" }}
        className={className+' bb-1 m-0'}
        onClick={onClick}
      >
				<div className="creator_VideoBadge__logo overflow-hidden" style={{ background: "#242424" }}>
  {/* Show default image if no valid image array */}
  {rerender && (!Array.isArray(playlist.image) || playlist.image === "no") && (
    <div className="w-100 p-3 m-0 overflow-hidden" style={{ height: "100%", background: "#fff" }}>
      <img
        src="https://img.icons8.com/ios/90/000000/no-video--v1.png"
        className="img-fluid"
        style={{ display: "inline-block", width: "100%" }}
        alt="No video"
      />
    </div>
  )}

  {/* Case: 1 image */}
  {rerender && Array.isArray(playlist.image) && playlist.image.length === 1 && (
    <div className="w-100 overflow-hidden" style={{ height: "100%" }}>
      {playlist.image[0].includes(".mp4") || playlist.image[0].includes(".mov") ? (
        <video
          src={playlist.image[0]}
          style={{ display: "inline-block", width: "100%", height: "100%" }}
        />
      ) : playlist.image[0] !== "no" ? (
        <div
          style={{
            display: "inline-block",
            width: "100%",
            height: "100%",
            backgroundImage: `url(${playlist.image[0]})`,
            backgroundSize: "auto 135%",
            backgroundPosition: "center",
          }}
          className="img-fluid"
          aria-label="Playlist Image"
        />
      ) : null}
    </div>
  )}

  {/* Case: 2 images */}
  {rerender && Array.isArray(playlist.image) && playlist.image.length === 2 && (
    <div className="row m-0 overflow-hidden" style={{ height: "4.9rem" }}>
      {[0, 1].map(i => (
        <div key={i} className="col-12 p-0 overflow-hidden" style={{ height: "2.45rem" }}>
          {playlist.image[i].includes(".mp4") || playlist.image[i].includes(".mov") ? (
            <video
              src={playlist.image[i]}
              className="img-fluid"
              style={{ display: "inline-block", width: "100%" }}
            />
          ) : (
            <div
              style={{
                display: "inline-block",
                width: "100%",
                height: "100%",
                backgroundImage: `url(${playlist.image[i]})`,
                backgroundSize: "auto 135%",
                backgroundPosition: "center",
              }}
              className="img-fluid h-100"
              aria-label="Playlist Image"
            />
          )}
        </div>
      ))}
    </div>
  )}

  {/* Case: 3 images */}
  {rerender && Array.isArray(playlist.image) && playlist.image.length === 3 && (
    <div className="row p-0 w-100 m-auto overflow-hidden" style={{ height: "5rem" }}>
      {playlist.image.map((img, i) => (
        <div key={i} className={`col-${i === 0 ? 12 : 6}`} style={{ height: "2.45rem" }}>
          {img.includes(".mp4") || img.includes(".mov") ? (
            <video
              src={img}
              className="img-fluid"
              style={{ height: "100%", width: "100%" }}
            />
          ) : (
            <div
              className="img-fluid"
              style={{
                height: "100%",
                width: "100%",
                background: `url(${img})`,
                backgroundSize: "auto 135%",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            />
          )}
        </div>
      ))}
    </div>
  )}

  {/* Case: 4+ images */}
  {rerender && Array.isArray(playlist.image) && playlist.image.length >= 4 && (
    <div className="row w-100 m-auto overflow-hidden" style={{ height: "5rem" }}>
      {playlist.image.slice(0, 4).map((img, i) => (
        <div key={i} className="col-6 playlist_thumbnail" style={{ height: "50px", padding:"0px" }}>
          {img.includes(".mp4") || img.includes(".mov") ? (
            <video
              src={img}
              className="img-fluid"
              style={{ height: "100%", width: "100%" }}
            />
          ) : (
            <div
              style={{
                height: "100%",
                width: "100%",
                background: `url(${img})`,
                backgroundSize: "auto 135%",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            />
          )}
        </div>
      ))}
    </div>
  )}
</div>

        <div className="info user_playlist_video_content" style={{padding: "4px 5px" }}>
          <p
            style={{
              lineHeight: "15px",
              fontSize: "12px",
              margin: "2px",
              color: "#fff",
            }}
          >
			 {playlist.title}
            <br />
            {playlist.users.length != 0
              ? playlist.users[0].username
              : ""}
			<div style={{ color: 'white', fontSize:'12px;' }}>
				<div style={{display: 'inline'}}>
					<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
				</div>

				<div style={{display: 'inline'}}>
					<span style={{fontSize:"15px",opacity:1,margin:"0 3px",color:"rgba(255,255,255,0.6)",fontWeight:"bold"}}>±</span>
				</div>
				<div style={{display: 'inline', color:"rgba(255,255,255,0.5)", fontSize:"11px"}}> 
					{totalViews}
				</div>
        <div style={{display: 'inline'}}>
					<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"13px",height:"13px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
				</div>
				<div style={{display: 'inline', color:"rgba(255,255,255,0.5)", fontSize:"11px"}}> 
					{playlist.totalTime} 
				</div>
				<div style={{ display: 'inline', float: 'right' }} onClick={shared}>
					<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"15px",height:"15px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
				</div>
				<div style={{ display: 'inline', float: 'right' }} onClick={deletePlaylist}>
					<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"14px",height:"14px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><circle cx="12" cy="12" r="10"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
				</div>
				</div>			
            {/* {playlist.title}
            <br />
            {playlist.users.length != 0
              ? " User : " + playlist.users[0].username
              : ""}
            <br />
            Created:{moment(playlist.createdAt).format("MM/DD/YYYY")}
            <br />
            Channel : <br />
            Notes : <br />
            Keyword :  <br />
            Category :{" "}
            {playlist.category.length == 1
              ? playlist.category.join()
              : playlist.category.join().slice(0, 15) + "..."}
            <br />
            Total Runtime : {playlist.totalTime} <br /> */}

          </p>
        </div>
      </div>
    </>
  );
};
function VideoLoader() {
  return (
    <div className="row px-3 mt-3">
      <div className="col-5 mb-4">
        <Skeleton animation="wave" variant="rectangular" width={"100%"} height={100} />
      </div>
      <div className="col-7 mb-4">
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </div>
      <div className="col-5 mb-4">
        <Skeleton animation="wave" variant="rectangular" width={"100%"} height={100} />
      </div>
      <div className="col-7 mb-4">
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </div>
      <div className="col-5 mb-4">
        <Skeleton animation="wave" variant="rectangular" width={"100%"} height={100} />
      </div>
      <div className="col-7 mb-4">
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </div>
      <div className="col-5 mb-4">
        <Skeleton animation="wave" variant="rectangular" width={"100%"} height={100} />
      </div>
      <div className="col-7 mb-4">
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </div>
      <div className="col-5 mb-4">
        <Skeleton animation="wave" variant="rectangular" width={"100%"} height={100} />
      </div>
      <div className="col-7 mb-4">
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </div>
    </div>
  );
}
const YoutubeListSection = ({allYoutubeSearchVideoData,CurrentPlay, setCurrentPlay, setYoutubePlay, setVideoIndex, videoIndex, setYoutubePlayUrl, setYoutubeDatainState, setYoutubePlayThumb}) => {
  return (
    allYoutubeSearchVideoData.map((video, index) => (
        <div key={index} className={(CurrentPlay != '' && CurrentPlay == video.id.videoId ? 'active_video' : '')+" mainBox"} style={{ position: "relative" }} data-length={allYoutubeSearchVideoData.length} data-index={index}>
            <div className={"creator_VideoBadge playlist-border bs-0 be-0 mb-0 youtube_search_list_box py-2"+(allYoutubeSearchVideoData.length-1 == index ? '' : ' bb-0')}>
            <div className="creator_VideoBadge__logo mx-2 br-5" style={{ backgroundImage: `url(${video.snippet.thumbnails.default.url})` }} />
            <div className="creator_VideoBadge__info mw-100 lcheck2" style={{ padding: "3px", width:"66%" }}>
                <div className="info">
                <p style={{ lineHeight: "15px", fontSize: "11px", margin: "2px", color: "#fff", }}>
                    <l style={{ fontSize: "15px" }} title={String(video.snippet.title || '')}>
                    {String(video.snippet.title || '').length <= 30 ? (
                        String(video.snippet.title || '').substring(0, 30)
                    ) : (
                        <marquee style={{ marginTop: "-340px" }} scrollamount={3}>
                        {String(video.snippet.title || '')}
                        </marquee>
                    )}
                    </l>
                    <br/>
                    <div className="playlist_ellipsis mb-2">
                        {video.snippet.description ? (<l title={video.snippet.description}>
                        {video.snippet.description}
                        </l>) : ("")}
                    </div>
                    {/* <l title={video.snippet.description}>{video.snippet.description.substring(0, 25)}...</l> */}
                    <div className="text-white">
                            <div className="d-inline me-1">
                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"15px",height:"15px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                            </div>
                            <div className="d-inline"> 
                                {
                                    !video.views || video.views === 0 || video.views === "0" ? "-.-" : video.views > 999 && video.views < 1000000 ? (video.views / 1000).toFixed(1) + "K" : video.views > 1000000 ? (video.views / 1000000).toFixed(1) + "M" : video.views
                                }
                            </div>

                            <div className="d-inline ms-3 me-1">
                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"15px",height:"15px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
                            </div>
                            <div className="d-inline"> 
                                    {!video.likes || video.likes === 0 || video.likes === "0" ? "-.-" : video.likes > 999 && video.likes < 1000000 ? (video.likes / 1000).toFixed(1) + "K" : video.likes > 1000000 ? (video.likes / 1000000).toFixed(1) + "M" : video.likes}
                            </div>
                            
                            </div>
                    {/* <br />
                    {video.snippet.channelTitle} <br />
                    {moment(video.snippet.publishTime).utc().format("MM/DD/YYYY")}
                    <br/>
                    <img src={require("../asset/images/Globe.webp")} className="img-fluid" alt="" style={{ width: "16px", cursor: "pointer" }} />
                    {!video.views || video.views === 0 || video.views === "0" ? "-.-" : video.views > 999 && video.views < 1000000 ? (video.views / 1000).toFixed(1) + "K" : video.views > 1000000 ? (video.views / 1000000).toFixed(1) + "M" : video.views}
                    <img src={require("../asset/images/ButtonNotLike.png")} className="img-fluid" alt="" style={{ width: "22px", cursor: "pointer" }} />
                    {!video.likes || video.likes === 0 || video.likes === "0" ? "-.-" : video.likes > 999 && video.likes < 1000000 ? (video.likes / 1000).toFixed(1) + "K" : video.likes > 1000000 ? (video.likes / 1000000).toFixed(1) + "M" : video.likes}
                    <br />
                    {moment("2022-01-01").startOf("day").seconds(moment.duration(video.duration).asSeconds()).format("H:mm:ss")} */}
                </p>
                </div>
            </div>
            </div>
            <ul
                className="icons playlist-border bt-0 bb-0 bs-0"
                style={{
                    height: "100%",
                    position: "absolute",
                    top: "0%",
                    left: "0",
                    listStyle: "none",
                    padding: "0",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "12%"
                }}
                >
                <li
                    onClick={() => {
                    setCurrentPlay(video.id.videoId);
                    setYoutubePlay(true);
                    setVideoIndex(videoIndex);
                    setYoutubePlayUrl(video._embedUrl || video._url || ("https://www.youtube.com/watch?v=" + video.id.videoId));
                    if (setYoutubePlayThumb) setYoutubePlayThumb(video.snippet.thumbnails.high.url || "");
                    }}
                    style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "10px 0"  // Adding some margin for spacing between buttons
                    }}
                >
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"16px",height:"16px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><rect x="2" y="2" width="20" height="20" rx="4" ry="4"/><polygon points="10 8 16 12 10 16 10 8" style={{fill:"rgba(255,255,255,0.8)",stroke:"none"}}/></svg>
                </li>
                <li
                    onClick={() =>
                    setYoutubeDatainState(
                        video.snippet.title,
                        video._url || ("https://www.youtube.com/watch?v=" + video.id.videoId),
                        video.views,
                        video.likes,
                        video.snippet.publishTime,
                        moment.duration(video.duration).asSeconds(),
                        (video.tags = null),
                        video.snippet.channelTitle,
                        video._channelUrl || ("https://www.youtube.com/channel/" + video.snippet.channelId),
                        video.snippet.thumbnails.high.url,
                        video.snippet.description,
                        video._embeded_code || video._embedUrl || ('<iframe width="560" height="315" src="https://www.youtube.com/embed/' + video.id.videoId + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'),
                        video.category,
                        null,
                        video._source || "youtube"
                    )
                    }
                    style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "10px 0"  // Adding some margin for spacing between buttons
                    }}
                >
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"16px",height:"16px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
                </li>
                </ul>

        </div>
        ))
  );
};

const VimeoListSection = ({videoAllSearchData, CurrentPlay, setYoutubePlay, setCurrentPlay, setYoutubePlayUrl, setYoutubeDatainState}) => {
  return (
    videoAllSearchData.map((video, index) => {
        return (
        <div
            key={index}
            className={(CurrentPlay != '' && CurrentPlay == video.link ? 'active_video' : '')+" mainBox"}
            style={{ position: "relative" }}
        >
            <div className="creator_VideoBadge playlist-border bs-0 be-0 mb-0 vimeo_search_list_box py-2">
            <div
                className="creator_VideoBadge__logo br-10 ms-2"
                style={{
                backgroundImage: `url(${video.pictures.base_link})`,
                }}
            />
            <div
                className="creator_VideoBadge__info mw-100 lcheck3" 
                style={{ padding: "3px" }}
            >
                <div className="info">
                <p
                    style={{
                    lineHeight: "11px",
                    fontSize: "10px",
                    margin: "2px",
                    color: "#fff",
                    }}
                >

                <div style={{ fontSize: "15px" }} title={video.name}>
                    <marquee className="pb-2" scrollamount={3}> {video.name} </marquee>
                </div>
                    {/* <h6>{video.name
                    ? <marquee scrollamount="3">{video.name}</marquee>
                    : ""}</h6> */}


                    {/* {video.description
                    ? video.description.slice(0, 75) + "..."
                    : ""} */}
                    <div className="playlist_ellipsis mb-2" style={{ lineHeight: "40px" }}>
                        {video.description ? (<l title={video.description}>
                        {video.description}
                        </l>) : ("")}
                    </div>
                    {/* <br />
                    <img
                    src={require("../asset/images/ButtonNotLike.png")}
                    className="img-fluid"
                    alt=""
                    style={{ width: "20px", cursor: "pointer" }}
                    />{" "}
                    {video.metadata.connections.likes.total}
                    <br />
                    play@:
                    {moment("2015-01-01")
                    .startOf("day")
                    .seconds(video.duration)
                    .format("H:mm:ss")} */}

                    <div className="text-white">
                    <div className="d-inline me-1">
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"15px",height:"15px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                    </div>
                    <div className="d-inline"> -.-
                        {/* {
                            !video.views || video.views === 0 || video.views === "0" ? "-.-" : video.views > 999 && video.views < 1000000 ? (video.views / 1000).toFixed(1) + "K" : video.views > 1000000 ? (video.views / 1000000).toFixed(1) + "M" : video.views
                        } */}
                    </div>

                    <div className="d-inline ms-3 me-1">
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"15px",height:"15px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
                    </div>
                    <div className="d-inline"> 
                            {!video.metadata.connections.likes.total || video.metadata.connections.likes.total === 0 ? "-.-" : video.metadata.connections.likes.total > 999 && video.metadata.connections.likes.total < 1000000 ? (video.metadata.connections.likes.total / 1000).toFixed(1) + "K" : video.metadata.connections.likes.total > 1000000 ? (video.metadata.connections.likes.total / 1000000).toFixed(1) + "M" : video.metadata.connections.likes.total}
                    </div>
                    
                </div>
                </p>
                </div>
            </div>
            </div>
            <ul
            className="icons playlist-border bt-0 bb-0 bs-0"
            style={{
                height: "100%",
                position: "absolute",
                top: "0%",
                left: "0",
                listStyle: "none",
                padding: "0",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "12%"
            }}
            >

            <li onClick={() => {
                setYoutubePlay(true);
                setCurrentPlay(video.link);
                setYoutubePlayUrl(video.link);
                }}
                style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "10px 0"  // Adding some margin for spacing between buttons
                }}
            >
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"16px",height:"16px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.65,flexShrink:0}}><rect x="2" y="2" width="20" height="20" rx="4" ry="4"/><polygon points="10 8 16 12 10 16 10 8" style={{fill:"rgba(255,255,255,0.8)",stroke:"none"}}/></svg>
            </li>

            <li
                onClick={() =>
                setYoutubeDatainState(
                    video.name || '',
                    video.link || '',
                    null,
                    video.metadata?.connections?.likes?.total || 0,
                    video.created_time || '',
                    video.duration || 0,
                    null,
                    video.user?.name || '',
                    video.user?.link || '',
                    video.pictures?.base_link || '',
                    video.description || '',
                    video.embed?.html || '',
                    (video.categories && video.categories.length > 0)
                    ? video.categories[0].name
                    : null,
                    video.user?.location_details || null,
                    "vimeo"
                )
                }
                style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "10px 0"
                }}
            >
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{width:"16px",height:"16px",stroke:"currentColor",strokeWidth:1.5,fill:"none",opacity:0.5,flexShrink:0}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
            </li>
            </ul>
        </div>
        );
    })
  );
};
